// ClockInOut.js  (v3.4 — see earlier notes below)
// v3.35: STYLED TIMESHEET DESIGN CASCADED. The banner-block builder is
//       generalised (tsBlocks/tsRowCells/styledTimesheetSheet) and now also
//       drives the DAY-VIEW export: one styled tab per pharmacy, one row per
//       staff member (Staff/Role/Four-week id columns), same PAYROLL / THE
//       PLAN / WHAT HAPPENED / REVIEW blocks, highlighted payroll figures,
//       "How calculated" narrative, single Review status, SUBMIT TO PAYROLL
//       totals sentence and X/Y reviewed count. Day export loses its
//       distance/device columns (cascade of v3.32). Summary export is a
//       pharmacy x role aggregate matrix, so the per-day design does not
//       apply there — unchanged. Backend scheduled timesheets get the same
//       design in report_scheduler.js v40.
// v3.34: MONTH EXPORT — "a timesheet that explains itself". Columns
//       regrouped under merged, colour-filled banner blocks: PAYROLL —
//       SUBMIT THESE FIGURES (the two payroll columns, highlighted green +
//       bold, plus a "How calculated" narrative column showing the per-row
//       arithmetic; overrides and still-clocked-in called out) | THE PLAN
//       (planned session with hours, break allowance incl. paid/unpaid,
//       paid contracted) | WHAT HAPPENED (sessions, raw hours, breaks taken
//       with times + total, potential OT, OT approved — "No" in red) |
//       REVIEW (single Review status column replacing Event reviewed +
//       Auto-confirmed: Auto / Auto + reviewed / Reviewed / NOT REVIEWED in
//       red; manager + session notes). Unit-pair columns merged. TOTALS row
//       bold with a SUBMIT TO PAYROLL sentence and an X/Y days reviewed
//       count. Blocks separated by vertical rules. Both month exports
//       (single pharmacy and all pharmacies) go through this builder.
// v3.33: MONTH-VIEW EXPORT polish. "Raw hours on site (h)" moved left of
//       "Contracted"; "Hours to be on site (h)" moved right of "Breaks
//       paid". All figure cells are centred (header row too) via a new
//       optional centring pass in buildSheet — requires the drop-in
//       xlsx-js-style package (npm install xlsx-js-style) because the
//       community "xlsx" build strips cell styles on write. Long free-text
//       columns (Actual, Breaks, Manager notes, Session notes) keep default
//       alignment. Only the month export opts in for now.
// v3.32: MONTH-VIEW EXCEL EXPORT reshaped (this export only for now; other
//       exports to follow once approved). "Payroll hours (h)" renamed
//       "Contracted hrs for payroll" and moved to the FIRST data column
//       after Day; "Payroll o/time (h)" renamed "Overtime hrs for payroll"
//       and moved to the second. Distance in (m), Distance out (m),
//       >50m flag, Clock-in device(s), Clock-out device(s) and Device
//       changed columns removed entirely (rows and totals).
// v3.31: SCHEDULE EDITOR — ONE SAVE SYSTEM (applies wherever the dialog
//       is opened: month-view Configure button and day-view name click).
//       Per-row Apply buttons removed; any change (field edits, Replicate,
//       Paid breaks toggle) only updates the editor, shows an "Unsaved
//       changes" marker and enables the single save button, relabelled
//       "Save all changes" (disabled until then; no pre-save confirm any
//       more — nothing is written before it). Dialog is strictly modal:
//       backdrop clicks no longer close it; a Cancel button sits beside
//       Save, and Cancel/Close with unsaved changes asks "Abandon all
//       changes and close?" before discarding.
// v3.29: the standalone "Validated" column is removed; the chip (same
//       colours, same hover detail) now sits at the very bottom of the
//       "What happened" panel, under the totals. Freed width redistributed
//       to the What happened and Analysis columns.
// v3.28: MONTH-VIEW DAY LIST SIMPLIFIED. (1) The four-line VALIDATION
//       column is replaced by a single "Validated" chip — green when all
//       clockings are in range and on the usual device, red when one was
//       too far away or the device id changed; the four detail lines moved
//       into the chip's hover text. (2) "Scheduled" is renamed "Planned
//       session" and is READ-ONLY (same info: times, break + paid flag,
//       contracted hours) — planned times are edited only in the four-week
//       schedule editor; the inline draft/commit machinery and
//       persistPlanned are removed. (3) "What happened" restructured:
//       sessions (with notes inline) first, small space, break times,
//       small space, then "Total hours actually on site" and "Total breaks
//       taken". (4) ANALYSIS lines spread out with more vertical space.
// v3.27: day-detail dialog SIMPLIFIED — the two bulk "Copy to all days"
//       buttons (this staff member / all staff members) are removed along
//       with their copyTimes handler; the dialog now edits only this one
//       day's contracted slot ("every Nth <weekday> of the month"). Bulk
//       edits live in the four-week schedule editor. An always-visible amber
//       note (and input tooltips) in the left panel state that edits apply
//       to every Nth weekday of each month (e.g. every 3rd Wednesday).
// v3.26: ONE FOUR-WEEK SCHEDULE EDITOR. The two schedule-configuration
//       screens (month view's "Configure scheduled hours" popup vs the
//       day-view staff-name-click dialog) are unified on the richer popup —
//       per-day break column in every week. Day-view name clicks now render
//       SchedulePatternDialog directly (gaining the role subtitle and the
//       "Email schedule form" button via new optional props); the old
//       StaffScheduleDialog compact layout and its single global break are
//       gone. The editor gains per-row "Apply" buttons (appear on edit) that
//       save that weekday of that week immediately — hours AND that day's
//       break together; "Replicate week 1 → weeks 2-4" copies hours AND
//       breaks and prompts to Save pattern.
// v3.25: FOUR-WEEK SCHEDULE PATTERNS. staff patterns often differ between
//       weeks 1-4 of the month while every month repeats — and the backend
//       staff_times model already supports it (keyed per weekday x
//       occurrence 1-5, dates resolved via occurrence = floor((day-1)/7)+1),
//       so NO backend change is needed for resolution. What changes is that
//       the frontend stops flattening it: (1) StaffScheduleDialog (name
//       click) and SchedulePatternDialog (Configure scheduled hours) now
//       show FOUR week panels, Mon-Sun each, with floating help ("Configure
//       the pattern for week 1. Replicate this for the other weeks, and
//       make any further adjustments as required") and a working
//       "Replicate week 1 → weeks 2-4" button; row Apply saves only that
//       weekday of that week. (2) Month-view scheduled edits (persistPlanned)
//       and the day-dialog "Save to this staff member..." now write only
//       the edited date's occurrence (e.g. every 3rd Friday) and patch only
//       matching dates. (3) A 5th occurrence of a weekday in longer months
//       follows the WEEK 1 pattern — occurrence 5 is written whenever week 1
//       is saved. (4) Four-week totals in the editors sum the four weeks
//       instead of weekly x 4. Bulk "Copy to all days" tools still overwrite
//       every week deliberately.
// v3.24: USABILITY PASS on the Staffing panel. (1) Every view tab now shows
//       a formatted hover panel (native title tooltips can't be styled):
//       sectioned headings with short paragraphs — the Day view one covers the default-today / past-date
//       selector, hover-for-detail, name-click schedule dialogue and
//       cell-click full detail. (2) Day-view cell dialog: the "Log" button
//       moves to the header, left of "Close", renamed "View log";
//       "Cont hrs on payroll" → "Cont. hrs submitted" and "O/time hrs on
//       payroll" → "O/time submitted", each with new floating help;
//       "Review complete" gains floating help; the left panel's
//       "Paid contracted hrs" becomes "Paid contracted hours today:" and
//       the "Four week contracted hours total" line moves to the bottom of
//       that panel. The month-view row layout picks up the same relabels
//       and help text so both views stay consistent.
// v3.23: month grid totals rows (Raw / Planned / Actual payroll / Overtime)
//       are now STICKY at the bottom of the scroll area, mirroring the sticky
//       header rows, so the day cells scroll between the two. Fixed 24px row
//       height per totals row with stacked bottom offsets; the label cells
//       stay pinned left as well.
// v3.22: hours are TWO DECIMAL PLACES everywhere — the shared h1() rounder
//       (exports, grid footer totals) moves from 1dp to 2dp so spreadsheets
//       match the on-screen figures exactly; the unused 1dp mm() helper in
//       the month export is removed.
// v3.21: EXPORT ALIGNMENT — every Excel output now carries the new fields.
//       Day export + month exports (one pharmacy and all pharmacies) gain
//       "Payroll o/time (h)" (override where set, else surplus on approved
//       days), "Clock-in device(s)", "Clock-out device(s)" and "Device
//       changed"; month TOTALS row sums payroll o/time; the month grid's
//       "Overtime total" footer and the Summary tab (backend v42.4) now
//       honour manual payroll-o/time overrides on approved days.
// v3.20: CellDialog widened to 1320px; month-view staff-name column headers
//       turn GREEN when every one of that member's days needing review is
//       reviewed (manually or automatically) — same rule as the dialog's
//       "Days reviewed" counter.
// v3.19: each staff-dialog row gains a small "Log" button pinned to its top
//       right (change history popup); Approved overtime ticks now also write
//       a log entry. CellDialog is ALIGNED with the row layout: "Contracted
//       hrs covered / Potential overtime" lines, "Cont hrs on payroll" and a
//       new editable "O/time hrs on payroll" + Approved, and a read-only
//       "Auto review" tick — both views now expose the same data with the
//       same labels. Both entry builders pass payrollOtHours through.
// v3.18: Manager-notes box pinned to a true square (132×54, no flex-grow) —
//       it was stretching across the flexible Review column as a wide bar.
// v3.17: Review flattened to ONE band: the two payroll lines stack on the
//       left, and to their right sit a square Manager-notes box (between
//       Approved and the review tick) and "Review complete" — removing the
//       third row and cutting row height further.
// v3.16: "Automatically reviewed" label shortened to "Auto review".
// v3.15: header stats row — "Days reviewed" moves up beside the month label,
//       followed by "Total cont hrs" (sum of the month's paid contracted
//       hours), "Payroll cont. hrs" (sum of each day's standard payroll:
//       override where set, else covered hours) and "Payroll o/time" (sum of
//       payroll overtime on days with Approved ticked). The two contracted
//       chips turn green together when they match; all live-update as saves land.
// v3.14: WIDTH CONTROL FIX — the flexible grid column was "What happened",
//       so any spare dialog width poured into it (why it kept ballooning).
//       Review is now the flexible column; What happened is pinned narrow.
//       SAVE SAFETY — failed saves now REVERT the optimistic tick/value and
//       report the server's words (a plain "Forbidden" usually means the
//       session expired — log in again). Each day gains a small "log" link
//       opening that day's change log. The Configure popup shows the live
//       four-week contracted total (per-day breaks respected).
// v3.13: "Automatically reviewed" moves under the Analysis text; in Review,
//       Manager notes moves up beside "Review complete" on one line — the
//       column is now three rows, holding row height down.
// v3.12: wider dialog (1780px), a "Days reviewed: n/N" counter at the top of
//       the day list (N = days with a plan or clockings; n = reviewed
//       manually or automatically) shown green when complete and ochre
//       otherwise, and the overtime "Approved" checkbox now also enables
//       whenever the O/time-on-payroll box holds a value.
// v3.11: staff-dialog column rebalance — "What happened" halved, "Review"
//       doubled and spread onto labelled lines: "Cont hrs on payroll"
//       (defaults to the on-site hours that satisfy the contracted figure),
//       "O/time hrs on payroll" (defaults to the surplus) with an "Approved"
//       checkbox beside it, then "Review complete" (default unticked) and a
//       read-only "Automatically reviewed" indicator.
// v3.10: staff-dialog visual tidy — the Review column was wrapping every
//       control onto its own line, stretching each row to ~300px. Review is
//       now a tight 2×2 grid (approve OT | reviewed / Std | O/T) with notes
//       beneath; consistent 12px type and 1.4 line rhythm across all
//       sections; rows top-aligned and compact (~90px typical).
// v3.9: staff-dialog polish: "Paid" label, narrower break box, break total on
//       its own line under hours on site, explanatory hover help on all four
//       validation lines, ANALYSIS shows "Contracted hrs covered" (on-site
//       hours toward paid contracted, capped) with "Potential overtime"
//       beneath, and REVIEW gains editable "Payroll std hrs" and "Payroll
//       o/time hrs" persisted per day (backend v42.3).
// v3.8: staff-dialog rows recut: FIRST CELL — "Mon 2nd" top-left, scheduled
//       from/to under it flush left, break hrs + Paid break, and the day's
//       total contracted hours (scheduled less unpaid break). Sections are
//       separated by vertical rules: ACTUAL (bigger, read-only session times
//       with each event's notes to its right, breaks beneath, totals for
//       hours on site and breaks at the foot) | VALIDATION (distances and
//       device ids stacked vertically, line background flags >50 m or a
//       changed device) | ANALYSIS | REVIEW. Rows tightened for minimal
//       height.
// v3.7: staff-dialog day rows restructured for readability: five tight
//       sections — WHAT IT SHOULD BE (editable schedule), WHAT IT IS
//       (sessions/breaks/notes), VALIDATION (distance in/out with ✓/✗ AND
//       device id in/out, red-highlighted when changed vs the previous
//       session), ANALYSIS (on-site total, potential OT, issues,
//       auto-approved), REVIEW (approve OT, reviewed, manager notes).
//       Larger base font, compact aligned grid, no dead space.
// v3.6: STAFF DIALOG v2 (month view): schedule editing moves into its own
//       "Configure scheduled hours" popup — Mon–Sun start/end each with a
//       PER-DAY break length + one paid-breaks flag; "Save pattern" writes
//       the whole pattern to every week of the month (overwriting what was
//       there). The day list is now FULL WIDTH with clear columns per day:
//       (1) SCHEDULED — planned start/end, break length, paid flag, all
//       editable inline (saves to that weekday's pattern) + potential OT;
//       (2) ACTUAL — each session's in/out and breaks with notes aligned
//       beside each; (3) DISTANCE — check-in and check-out each with ✓/✗;
//       (4) APPROVALS — auto-approved (read-only), approve overtime, mark
//       reviewed, manager notes. Rows go GREEN when approved (auto or
//       manual), OCHRE when attention is still needed. Everything auto-saves;
//       double-clicking a row still marks its review complete.
// v3.5: STAFF DIALOG REDESIGN (month view name-click): much larger two-panel
//       layout. LEFT — "Scheduled sessions": the weekly pattern editor, four
//       week total, break controls and email button (unchanged behaviour;
//       Apply buttons still write to the month). RIGHT (2/3) — every day of
//       the selected month for that staff member with the full cell analysis
//       (planned, sessions with distances/notes/devices, breaks, OT, payroll,
//       manager notes, issues, auto-confirmed) inline. Reviewed tick, OT
//       approval, payroll hours and notes AUTO-SAVE as they're changed;
//       DOUBLE-CLICKING a day marks its review complete. Rows are tinted with
//       the same status colours as the grid and patch the grid live. The Day
//       view name-click keeps the previous compact schedule-only dialog.
// v3.4: staff weekly-schedule dialogue — widened to 940px with no-wrap
//       rows so both Apply buttons sit inline right of the time inputs;
//       "Apply to all weekdays" now also updates the dialogue's own input
//       boxes (it already updated the grid behind); double-clicking either
//       time input sets that day to 09:00–18:00.
// v3.3: bulk schedule-invite UI DELETED (not just hidden); with headoffice
//       v41.1 refusing anything but a single named staffId, bulk emails to
//       staff cannot be fired from any client. Single-staff send remains.
// v3.2: schedule-invite emails split into two flags — the SINGLE-staff
//       "✉ Email schedule form to <name>" button (weekly schedule
//       dialogue) is ENABLED; the day/month "email all staff" buttons
//       remain hidden (SCHEDULE_INVITE_ALL_ENABLED = false).
// v3.1: schedule-invite emails DISABLED behind SCHEDULE_INVITES_ENABLED =
//       false (all three send buttons hidden: day view all-staff, month
//       view all-staff, single-staff in the weekly schedule dialogue).
//       Flip the flag to true to restore — backend endpoints and the
//       public form module stay deployed and functional.
// v3.0: STAFF SELF-SERVICE SCHEDULE EMAILS. Day view ("all branches") and
//       month view ("selected pharmacy") gain "✉ Email schedule forms to
//       all staff"; the staff weekly-schedule dialogue gains a single-staff
//       send. Every send shows a confirm dialog first and a result summary
//       after (sent / skipped-no-email / failed). Links (headoffice v41 +
//       staff_schedule_public.js) last 24 hours and open an interactive
//       form: view/update/submit own weekly hours, no break access, live
//       four-week contracted total.
// v2.9: "Four week contracted hours total" — four weeks of the weekly
//       pattern minus unpaid break entitlements (backend v40.1) — shown in
//       the cell dialogue (left panel), live-computed in the staff weekly
//       schedule dialogue, added to each staff tab's header in the month
//       exports and as a column in the day export.
// v2.8: MONTH VIEW — pharmacy dropdown entries carry a status background
//       (green: every recorded day approved manually or auto; red: any day
//       needing attention; no colour: nothing recorded or awaiting
//       completion) from the new /clock/month/status; and an "Export all
//       pharmacies" button producing ONE WORKBOOK PER PHARMACY for the
//       selected month (all roles, tab per staff member).
// v2.7: CLOCK DEVICE TRACKING. Sessions carry clockIn/clockOut device ids
//       (headoffice v40, both field casings read). The cell dialogue shows
//       "Clock-in device / Clock-out device" in its bottom corner; a value
//       that CHANGED versus the staff member's last recorded clocking gets
//       a red background with the previous id alongside, auto-confirmation
//       is blocked (reason shown), the grid withholds the auto-green
//       (amber until reviewed) and the hover tooltip explains why.
// v2.6: (1) "Raw hours on site" — every session's out minus in, no
//       adjustments — added as the FIRST bottom totals row on the month
//       view, as an early column (with TOTALS value) in the month export
//       (replacing the later duplicate "Hours on site (h)" column), and as
//       the first labelled totals row on the Summary tab screen + export.
//       (2) Clicking a staff member's NAME (day chip or month column
//       header, dotted underline + explanatory tooltip) opens a WEEKLY
//       SCHEDULE dialogue: Mon–Sun rows of scheduled start/end from
//       staff_times (new /clock/times/get), per-row "Apply to <Wd>s for
//       whole of month" and confirm-guarded "Apply to all weekdays for
//       whole of month", with Break length + Paid break saved along.
// v2.5: PAYROLL TOTALS EVERYWHERE. Month view bottom rows are now
//       "Planned hrs total:", "Actual payroll hours total:" and "Overtime
//       total:" (approved days only, net rule), all computed with the
//       shared dayCalc() that mirrors the cell dialogue. Summary tab gains
//       a Payroll measure (backend v38 payrollH) and the SAME three
//       labelled totals rows per column, on screen and in its export. Day
//       and month exports expanded to the FULL numeric set per episode:
//       contracted times, hours to be on site, break entitlement, breaks
//       paid, paid contracted, sessions, distances + >50m flag, hours on
//       site, break time taken, payroll hours, potential OT, OT approved,
//       event reviewed, auto-confirmed, manager + session notes; month
//       TOTALS row carries planned/on-site/breaks/payroll/approved-OT.
// v2.4.1: payroll default corrected — total hours on site LESS total break
//         time TAKEN when breaks are unpaid (nothing deducted when paid),
//         then capped at paid contracted hrs; potential overtime is the
//         surplus of that net figure.
// v2.4: PAYROLL ARITHMETIC. Left panel: "Hours to be on site" (end minus
//       start), editable "Break entitlement (hrs)" + "Paid?" checkbox
//       (default unpaid), and read-only "Paid contracted hrs" = on-site
//       hours minus the break entitlement ONLY when unpaid. Right panel:
//       "Hours to go on payroll sheet" now defaults LIVE to total hours on
//       site capped at paid contracted hrs (manual override still allowed
//       and logged); the surplus above paid contracted is the "Potential
//       overtime", exposed with its Approved checkbox when over 0.2h.
// v2.3: LEFT panel gains "Break length of xx hrs" (fractions) with a
//       "Breaks paid? yes/no" choice (default no) shown when >0 — stored on
//       the staff_times pattern (headoffice v37.1) and included in the
//       save/copy actions. MIDDLE panel: labelled "Notes (clock in/out)"
//       rows on every session, a Breaks section ("Break from xx to yy"),
//       and two totals — hours on site and break time taken. RIGHT panel:
//       "Contracted hours for payroll" renamed "Hours to go on payroll
//       sheet".
// v2.2: THREE-PANEL CellDialog (day + month): (1) staff/role + contracted
//       times with "Save for every <weekday>" and confirm-guarded "Copy to
//       all days ..." for one staff or ALL staff (buttons appear on change,
//       vanish after the confirmation message); (2) all sessions with
//       per-event notes and distances + total actual hours; (3) summary —
//       covered ✓/✗, editable "Contracted hours for payroll" (logged),
//       "Potential overtime of x hours" + Accept checkbox when excess >30m,
//       manager notes, LOG button (audit popup from staff_event_reviews),
//       "Review complete" tick. Review complete OR auto-confirmed (clean,
//       complete, no OT possibility) now paint the cell GREEN; blue retired.
//       Backend v37.
// v2.1: SHARED CellDialog — the full day-analysis dialogue (analysis rows,
//       overtime tick, event-review tick + manager notes, planned-hours
//       pattern editor) is now one component used by BOTH tabs: click a
//       month cell, or DOUBLE-CLICK a staff chip on the day view. The day
//       endpoint (headoffice v36.1) now returns breaks so both dialogues
//       are identical. Optimistic patches update whichever view is open.
// v2.0: SINGLE-STATUS CELL COLOURS replace the split halves — green (clean
//       & complete: on-time in, out between planned end and +10 min where
//       known, distances <50m, no notes), amber (clean, still clocked in),
//       red (any factor wrong, or planned-but-absent), BLUE when a manager
//       ticks the NEW "Event reviewed and approved" checkbox on the cell
//       analysis (persisted in staff_event_reviews, headoffice v35);
//       reviewed cells also show "✔ reviewed" and both exports gain an
//       "Event reviewed" column. THREE NEW TABS moved in from the left
//       menu: Workforce planner (real pharmacy names), Raw data
//       (stafflogin list, reverse-chronological, pharmacy/staff/search/
//       problems filters), Pharmacist rota.
// v1.4: CLOCK DISTANCES (headoffice v34). Sessions carry distIn/distOut
//       (metres from the pharmacy). Shown in cell tooltips and in the
//       month view's day-analysis dialogue ("Distance from pharmacy" row);
//       any session beyond 50m outlines the cell RED in BOTH the day and
//       month views (background halves unchanged) and flags "⚠". Day and
//       month exports gain "Distance in (m)" / "Distance out (m)" and a
//       ">50m flag" column.
// v1.2: OVERTIME = day's hours on site minus contracted hours when known
//       (whole worked day when no contracted hours) — computed server-side
//       per cell (headoffice v33). Cells with an excess get a BLUE right
//       half and an "OT xh" badge with tick state. Clicking a cell now
//       opens the FULL DAY ANALYSIS: contracted vs actual times, minutes
//       late arriving, early/late leaving, breaks and the overtime
//       arithmetic — with a "count this overtime" CHECKBOX (persisted in
//       tenant staff_overtime_approvals). The bottom overtime total shows
//       ONLY the ticked cells per column, and the export matches. The
//       planned-hours pattern editor lives on in the same dialogue.
//       "Refresh now" buttons added beside Export on Month and Summary.
// v1.3: EXPORT RESTRUCTURE — day view exports ONE TAB PER PHARMACY
//       (abbreviated pharmacy name as the tab label, per-tab header block,
//       Pharmacy column dropped as redundant); month view exports ONE TAB
//       PER STAFF MEMBER with the parameters split into columns —
//       Contracted / Actual / Breaks / Overtime (h) / Overtime approved /
//       Notes — and a TOTALS bottom row (contracted, on-site, breaks, all
//       calculated overtime, and the ticked-overtime figure).
// v1.1: Day-view arrival colours are HALF-cell (left half): green when
//       clocked in on time OR with no planned hours; amber late; red when
//       overdue and absent — right half stays white until clock-out.
//       Departure with no planned end now shows green (nothing breached).
//       Day view gains a working Refresh button. Month grid TRANSPOSED:
//       days run vertically, staff (grouped under role headers) across,
//       totals as four bottom rows; export matches the new orientation.
// -----------------------------------------------------------------------------
// Head-office "Clock in/out" panel — full-screen view opened from the Staff
// group on the dashboard. Three tabs:
//   1. Day view    — rows are branches, columns are staff grouped by role,
//                    for a chosen date. Cell colour tells the story at a
//                    glance (red = should be in but isn't; amber = late;
//                    green = on time; split halves when clocked out too).
//   2. Month view  — one pharmacy, one month; every staff member's day
//                    cells with sessions, notes and breaks; planned hours
//                    editable per weekday-occurrence (writes staff_times);
//                    per-staff totals at the bottom.
//   3. Summary     — pharmacy x role totals for a year/month window, with
//                    selectable measures (contracted / on site / overtime).
// All tabs export the currently displayed dataset to Excel (SheetJS).
// Data comes from headoffice.js v32 /api/headoffice/clock/* (JWT-scoped:
// the org comes from the token, like every other head-office module).
// -----------------------------------------------------------------------------

import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
// v3.33: xlsx-js-style is a drop-in, API-compatible fork of SheetJS that
// KEEPS cell styles on write (the community "xlsx" build strips them), so
// exports can centre-align cells.  ->  npm install xlsx-js-style
import * as XLSX from "xlsx-js-style";
import Workforce from "./Workforce";
import Stafflogin from "./stafflogin";
import PharmacistRota from "./PharmacistRota";

const API = "https://api.pharmacegroup.co.uk";

function authToken() {
  return localStorage.getItem("token") || localStorage.getItem("authToken") || localStorage.getItem("jwt") || "";
}
async function post(path, body) {
  const r = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken()}` },
    body: JSON.stringify(body || {})
  });
  const d = await r.json();
  if (!r.ok) throw new Error(d.error || `HTTP ${r.status}`);
  return d;
}

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
// v3.25: four-week pattern helpers. staff_times is keyed per (weekday,
// occurrence 1-5) — the nth such weekday of the month — and the backend
// already resolves each date via occurrence = floor((dayOfMonth-1)/7)+1.
// The editors below now expose that: weeks 1-4 are configured separately;
// a 5th occurrence of a weekday in a month follows the WEEK 1 pattern
// (saved to occurrence 5 whenever week 1 is saved).
const WEEK_ORD = ["1st", "2nd", "3rd", "4th", "5th"];
const occurrenceOfDate = (dateStr) => Math.floor((Number(String(dateStr).slice(8, 10)) - 1) / 7) + 1;
const occsForWeek = (wk) => (wk === 1 ? [1, 5] : [wk]); // week 1 also covers a 5th occurrence
// Clocking further than this from the pharmacy flags the cell in red.
const DIST_LIMIT_M = 50;
const distText = (m) => (m === null || m === undefined) ? "" : (m >= 1000 ? `${Math.round(m / 100) / 10}km` : `${m}m`);
const dmy = (iso) => { const [y, m, d] = String(iso || "").split("-"); return d ? `${d}/${m}/${y}` : String(iso || ""); };
const farSession = (s) => (s.distIn != null && s.distIn > DIST_LIMIT_M) || (s.distOut != null && s.distOut > DIST_LIMIT_M);
const anyFar = (sessions) => (sessions || []).some(farSession);
const distPair = (s) => {
  const parts = [];
  if (s.distIn != null) parts.push(`in ${distText(s.distIn)}${s.distIn > DIST_LIMIT_M ? " ⚠" : ""}`);
  if (s.distOut != null) parts.push(`out ${distText(s.distOut)}${s.distOut > DIST_LIMIT_M ? " ⚠" : ""}`);
  return parts.join(", ");
};
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const hm = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};
const plannedDate = (dateStr, hhmm) => new Date(`${dateStr}T${hhmm}:00`);

// ---- colour rules (v2.0 single-status scheme) --------------------------------
// One background colour tells the whole story of the day's clocking event:
//   GREEN  — clean and complete: arrived no later than the planned start,
//            left no earlier than the planned end and no more than 10 min
//            after it (where planned times are known), both clock distances
//            under 50m (where recorded), and no notes.
//   AMBER  — clean so far but incomplete (still clocked in / no clock-out).
//   RED    — something needs attention: late in, left early, left more than
//            10 min after the planned end, either distance over 50m, any
//            notes, or planned to be in but absent once the start has passed.
//   BLUE   — "Event reviewed and approved" ticked by a manager: overrides
//            the computed colour so checked red cells stand out as handled.
//   blank  — nothing to say (no data, or not yet due).
const C = {
  green: "#bbf7d0", amber: "#fde68a", red: "#fecaca",
  blue: "#93c5fd", blank: "#ffffff", off: "#f8fafc"
};
const LATE_OUT_GRACE_MIN = 10;
function cellIssues(dateStr, planned, sessions) {
  // Returns the list of reasons a cell is RED (empty list = clean).
  const issues = [];
  const withIn = (sessions || []).filter(s => s.in);
  const firstIn = withIn.length ? withIn[0].in : null;
  const outs = (sessions || []).filter(s => s.out).map(s => s.out).sort();
  const lastOut = outs.length ? outs[outs.length - 1] : null;
  const stillIn = (sessions || []).some(s => s.in && !s.out);
  if (planned && planned.start && firstIn && new Date(firstIn) > plannedDate(dateStr, planned.start)) issues.push("arrived late");
  if (planned && planned.end && lastOut && !stillIn) {
    const end = plannedDate(dateStr, planned.end);
    if (new Date(lastOut) < end) issues.push("left early");
    if (new Date(lastOut) > new Date(end.getTime() + LATE_OUT_GRACE_MIN * 60000)) issues.push(`left more than ${LATE_OUT_GRACE_MIN} min late`);
  }
  if ((sessions || []).some(farSession)) issues.push(`clocked more than ${DIST_LIMIT_M}m from the pharmacy`);
  if ((sessions || []).some(s => s.inNotes || s.outNotes)) issues.push("has notes");
  return issues;
}
// Full per-day payroll arithmetic (mirrors the CellDialog): contracted,
// break entitlement, paid contracted, on-site, breaks taken, net actual,
// payroll hours (stored override wins, else net capped at paid contracted)
// and net-rule potential overtime. All figures minutes unless suffixed H.
function dayCalc(dateStr, cell) {
  const pl = cell?.planned || null;
  const sessions = cell?.sessions || [];
  const breaks = cell?.breaks || [];
  let contractedM = 0;
  if (pl && pl.start && pl.end) {
    const [sh, sm] = pl.start.split(":").map(Number), [eh, em] = pl.end.split(":").map(Number);
    contractedM = Math.max(0, (eh * 60 + (em || 0)) - (sh * 60 + (sm || 0)));
  }
  const breakEntM = pl && Number.isFinite(Number(pl.breakMins)) ? Number(pl.breakMins) : 0;
  const breaksPaid = pl?.breaksPaid === true;
  const paidContractedM = contractedM > 0 ? Math.max(0, contractedM - (breaksPaid ? 0 : breakEntM)) : 0;
  let actualM = 0;
  for (const s of sessions) if (s.in && s.out) actualM += Math.max(0, (new Date(s.out) - new Date(s.in)) / 60000);
  const breakTakenM = breaks.reduce((t, b) => t + (b.mins || 0), 0);
  // UNPAID breaks: the entitlement is a FLOOR on what is deducted. The plan
  // side has already removed the full entitlement from the contracted hours,
  // so deducting only the break actually taken would count unused break time
  // as worked time and surface it as overtime. Deducting whichever is greater
  // keeps the paid/unpaid toggle changing the absolute figures without ever
  // changing whether the day is over or under its contracted hours.
  const unpaidBreakM = breaksPaid ? 0 : Math.max(breakTakenM, breakEntM);
  const netActualM = Math.max(0, actualM - unpaidBreakM);
  const payrollAutoM = Math.min(netActualM, paidContractedM > 0 ? paidContractedM : netActualM);
  const payrollM = cell?.payrollHours != null ? Math.round(cell.payrollHours * 60) : payrollAutoM;
  const potOtM = Math.max(0, netActualM - (paidContractedM > 0 ? paidContractedM : netActualM));
  const stillIn = sessions.some(s => s.in && !s.out);
  const deviceChanged = !!(cell?.deviceChangedIn || cell?.deviceChangedOut);
  const autoConf = autoConfirmed(dateStr, pl, sessions, potOtM, deviceChanged);
  return { contractedM, breakEntM, breaksPaid, paidContractedM, actualM, breakTakenM, unpaidBreakM, netActualM, payrollM, potOtM, stillIn, autoConf, deviceChanged };
}
const h1 = (mins) => Math.round(mins / 0.6) / 100;   // hours to 2dp everywhere
// Payroll overtime for one day: the manual o/time override where set, else
// the net-rule surplus — counted only when the overtime is APPROVED.
const payrollOtM = (cell, potOtM) => {
  if (!cell?.overtimeApproved) return 0;
  return cell?.payrollOtHours != null ? Math.round(cell.payrollOtHours * 60) : Math.max(0, potOtM);
};

// A day is AUTO-CONFIRMED when it needs no human attention at all: no
// issues (on time in/out, distances fine, no notes), fully clocked out, and
// no overtime possibility beyond 30 minutes.
function autoConfirmed(dateStr, planned, sessions, overtimeMins, deviceChanged) {
  // A clock-in/out DEVICE change since the last recorded day always blocks
  // auto-confirmation — a manager must review the day explicitly.
  if (deviceChanged) return false;
  if (!(sessions || []).length) return false;
  if (sessions.some(s => s.in && !s.out) || !sessions.some(s => s.out)) return false;
  if (cellIssues(dateStr, planned, sessions).length) return false;
  return !((overtimeMins || 0) > 30);
}
function cellStatus(dateStr, planned, sessions, eventReviewed, now = new Date(), deviceChanged = false) {
  // v2.2: "Review complete" turns the cell GREEN (not blue) — and a clean,
  // complete day is auto-confirmed green without any tick.
  // v2.7: a clock-device change withholds the auto-green — the cell stays
  // amber until a manager marks the review complete.
  if (eventReviewed) return C.green;
  if (deviceChanged && (sessions || []).length && !cellIssues(dateStr, planned, sessions).length) return C.amber;
  const any = (sessions || []).length > 0;
  if (!any) {
    if (planned && planned.start && now > plannedDate(dateStr, planned.start)) return C.red; // should be in but isn't
    return C.blank;
  }
  if (cellIssues(dateStr, planned, sessions).length) return C.red;
  const stillIn = sessions.some(s => s.in && !s.out) || !sessions.some(s => s.out);
  return stillIn ? C.amber : C.green;
}
function cellTooltip(planned, sessions, breaks, overtimeMins, dateStr, eventReviewed, reviewNotes, extra) {
  const lines = [];
  for (const s of sessions) {
    lines.push(`In ${hm(s.in) || "—"}${s.out ? `  Out ${hm(s.out)}` : "  (still clocked in)"}`);
    const dp = distPair(s);
    if (dp) lines.push(`  Distance: ${dp}`);
    if (s.inNotes) lines.push(`  In note: ${s.inNotes}`);
    if (s.outNotes) lines.push(`  Out note: ${s.outNotes}`);
  }
  if (dateStr) {
    const issues = cellIssues(dateStr, planned, sessions);
    if (issues.length) lines.push(`⚠ ${issues.join("; ")}`);
  }
  if (eventReviewed) lines.push("✔ Review complete (manager)");
  if (extra?.deviceChanged) lines.push("⚠ Clocking device changed since previous record — auto-confirmation withheld");
  if (reviewNotes) lines.push(`Manager note: ${reviewNotes}`);
  if (breaks && breaks.length) {
    for (const b of breaks) lines.push(`Break ${hm(b.start)}–${b.end ? hm(b.end) : "…"} (${b.mins || 0}m)`);
  }
  if (planned && (planned.start || planned.end)) lines.push(`Planned ${planned.start || "?"}–${planned.end || "?"}`);
  if (overtimeMins > 0) lines.push(`Overtime: ${Math.floor(overtimeMins / 60)}h ${overtimeMins % 60}m (on site beyond contracted) — click for full analysis`);
  return lines.join("\n");
}
function sessionsText(sessions) {
  if (!sessions.length) return "—";
  return sessions.map(s => `${hm(s.in) || "?"}${s.out ? `–${hm(s.out)}` : "–…"}`).join(", ");
}

// ---- shared bits -----------------------------------------------------------
const S = {
  btn: (c = "#0f766e") => ({ border: `1px solid ${c}`, color: c, background: "#fff", borderRadius: 4, padding: "6px 12px", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }),
  lab: { fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: 0.3 },
  inp: { fontSize: 13, padding: "5px 8px", border: "1px solid #9ca3af", borderRadius: 4, fontFamily: "inherit" }
};

function RoleChecks({ roles, active, setActive }) {
  return (
    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
      <span style={S.lab}>Roles:</span>
      {roles.map(r => (
        <label key={r} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13, cursor: "pointer", whiteSpace: "nowrap" }}>
          <input type="checkbox" checked={active.has(r)}
            onChange={e => setActive(prev => {
              const n = new Set(prev);
              if (e.target.checked) n.add(r); else n.delete(r);
              return n;
            })} />
          {r}
        </label>
      ))}
      {roles.length > 1 && (
        <button style={{ ...S.btn("#6b7280"), padding: "2px 8px", fontSize: 11 }}
          onClick={() => setActive(new Set(roles))}>All</button>
      )}
    </div>
  );
}

// Excel sheet-name rules: max 31 chars, no [ ] : * ? / \ — abbreviate and
// de-duplicate (two long names can collide after truncation).
function sheetNameFor(raw, used) {
  let base = String(raw || "Sheet").replace(/[\[\]:*?\/\\]/g, "").trim().slice(0, 31) || "Sheet";
  let name = base, n = 2;
  while (used.has(name.toLowerCase())) {
    const suffix = ` (${n++})`;
    name = base.slice(0, 31 - suffix.length) + suffix;
  }
  used.add(name.toLowerCase());
  return name;
}
function buildSheet(rows, headerLines, centerExcept) {
  const ws = headerLines.length
    ? XLSX.utils.aoa_to_sheet([...headerLines.map(l => [l]), []])
    : XLSX.utils.json_to_sheet(rows);
  if (headerLines.length) XLSX.utils.sheet_add_json(ws, rows, { origin: `A${headerLines.length + 2}` });
  // v3.33: centre-align cells when the sheet asks for it. centerExcept lists
  // column headers left at default alignment (long free text); the column
  // header row itself is always centred.
  if (centerExcept) {
    const keys = Object.keys(rows[0] || {});
    const skip = new Set(centerExcept);
    const hdrR = headerLines.length ? headerLines.length + 1 : 0;
    for (let r = hdrR; r <= hdrR + rows.length; r++) {
      keys.forEach((k, ci) => {
        if (r > hdrR && skip.has(k)) return;
        const addr = XLSX.utils.encode_cell({ r, c: ci });
        if (ws[addr]) ws[addr].s = { ...(ws[addr].s || {}), alignment: { horizontal: "center", vertical: "center" } };
      });
    }
  }
  const cols = Object.keys(rows[0] || {}).map((k, i) => ({
    wch: Math.min(46, Math.max(
      k.length,
      i === 0 ? Math.max(0, ...headerLines.map(l => Math.min(l.length, 46))) : 0,
      ...rows.map(r => String(r[k] ?? "").length)) + 2)
  }));
  ws["!cols"] = cols;
  return ws;
}
// One tab per entry: [{ name, headerLines, rows }]
function exportWorkbook(sheets, fileName) {
  const wb = XLSX.utils.book_new();
  const used = new Set();
  for (const s of sheets) {
    XLSX.utils.book_append_sheet(wb, buildSheet(s.rows, s.headerLines || [], s.centerExcept), sheetNameFor(s.name, used));
  }
  XLSX.writeFile(wb, fileName);
}

/* =============================================================================
   v3.34: STYLED MONTH EXPORT ("timesheet that explains itself").
   Columns are grouped under merged banner blocks — PAYROLL / THE PLAN /
   WHAT HAPPENED / REVIEW — with the two payroll figures highlighted and a
   "How calculated" narrative column showing the arithmetic per row, so the
   manager can check every headline figure without leaving the row.
   Requires xlsx-js-style (plain xlsx would strip all of this styling).
   ========================================================================== */
// The arithmetic, narrated. Mirrors dayCalc/payrollOtM exactly — same
// numbers, explaining themselves.
function payrollNarrative(c, k) {
  const H = (m) => `${(m / 60).toFixed(2)}h`; // fixed 2dp — reads like payroll
  const hasClock = !!c?.sessions?.length;
  if (!hasClock) {
    if (c?.payrollHours != null) return `MANAGER OVERRIDE: payroll set to ${H(k.payrollM)} with no clockings recorded (see log)`;
    if (k.contractedM > 0) return "No clockings recorded for the planned session";
    return "";
  }
  const bits = [];
  if (k.breaksPaid) {
    bits.push(`${H(k.actualM)} on site${k.breakTakenM > 0 ? ` (breaks paid \u2014 ${H(k.breakTakenM)} taken, nothing deducted)` : ""} = ${H(k.netActualM)} net`);
  } else if (k.unpaidBreakM > 0) {
    // Unpaid: the entitlement is the minimum deduction, so an under-taken
    // break is spelled out rather than quietly inflating the net figure.
    bits.push(k.breakEntM > k.breakTakenM
      ? `${H(k.actualM)} on site \u2212 ${H(k.unpaidBreakM)} unpaid break entitlement (only ${H(k.breakTakenM)} actually taken \u2014 unused unpaid break is not paid) = ${H(k.netActualM)} net`
      : `${H(k.actualM)} on site \u2212 ${H(k.unpaidBreakM)} unpaid breaks taken = ${H(k.netActualM)} net`);
  } else {
    bits.push(`${H(k.actualM)} on site, no break deduction = ${H(k.netActualM)} net`);
  }
  const autoM = Math.min(k.netActualM, k.paidContractedM > 0 ? k.paidContractedM : k.netActualM);
  if (k.paidContractedM > 0) {
    bits.push(k.netActualM > k.paidContractedM
      ? `capped at ${H(k.paidContractedM)} paid contracted \u2192 ${H(autoM)} payroll`
      : `within ${H(k.paidContractedM)} paid contracted \u2192 ${H(autoM)} payroll`);
  } else {
    bits.push(`no schedule for this day \u2192 ${H(autoM)} payroll`);
  }
  if (c?.payrollHours != null && Math.round(c.payrollHours * 60) !== autoM) {
    bits.push(`MANAGER OVERRIDE: payroll set to ${H(k.payrollM)} (see log)`);
  }
  const otM = payrollOtM(c, k.potOtM);
  if (k.potOtM > 0 || c?.payrollOtHours != null) {
    if (c?.overtimeApproved) {
      bits.push(c?.payrollOtHours != null && Math.round(c.payrollOtHours * 60) !== k.potOtM
        ? `${H(k.potOtM)} surplus \u2014 manager set overtime to ${H(otM)}, approved`
        : `${H(k.potOtM)} surplus approved \u2192 ${H(otM)} overtime`);
    } else {
      bits.push(`${H(k.potOtM)} surplus NOT approved \u2192 no overtime`);
    }
  }
  if (k.stillIn) bits.push("still clocked in \u2014 figures incomplete");
  return bits.join("; ");
}

// ---- generic styled timesheet sheet ----------------------------------------
// v3.35: the banner/blocks/highlight design is generalised so every
// timesheet export (month, day, backend scheduled) shares one spec.
const TS_LINE = "94A3B8";
function tsBlocks(idCols, opts = {}) {
  const whatHappened = [
    { label: "Sessions", w: 22, align: "lw" },
    { label: "Raw hours on site (h)", w: 11 },
    { label: "Breaks taken", w: 26, align: "lw" },
    { label: "Potential OT (h)", w: 10 },
    { label: "OT approved", w: 9, redWhen: v => v === "No" }];
  // v3.37: audit trail alongside the figures — every logged change for the
  // day, so the original values and who altered them are visible in the
  // sheet itself. Opt-in (opts.withChanges) so exports that have no log to
  // hand keep their existing column count.
  if (opts.withChanges) whatHappened.push({ label: "Changes made (audit log)", w: 54, align: "lw" });
  return [
    { title: "", ban: null, hdr: "F1F5F9", cols: idCols },
    { title: "PAYROLL \u2014 SUBMIT THESE FIGURES", ban: "0F766E", hdr: "99F6E4", cols: [
      { label: "Contracted hrs for payroll", w: 12, kind: "payrollFig" },
      { label: "Overtime hrs for payroll", w: 12, kind: "payrollFig" },
      { label: "How calculated", w: 58, kind: "narrative" }] },
    { title: "THE PLAN", ban: "475569", hdr: "E2E8F0", cols: [
      { label: "Planned session", w: 20 },
      { label: "Break allowance", w: 14 },
      { label: "Paid contracted (h)", w: 11 }] },
    { title: "WHAT HAPPENED", ban: "6D28D9", hdr: "EDE9FE", cols: whatHappened },
    { title: "REVIEW", ban: "B45309", hdr: "FDE68A", cols: [
      { label: "Review status", w: 15, redWhen: v => v === "NOT REVIEWED" },
      { label: "Manager notes", w: 28, align: "lw" },
      { label: "Session notes", w: 28, align: "lw" }] }
  ];
}
// The 12 standard (non-identity) cell values for one staff-day.
function tsRowCells(c, k) {
  const hasClock = !!c?.sessions?.length;
  const breaksList = (c?.breaks || []).map(b => `${hm(b.start)}\u2013${b.end ? hm(b.end) : "\u2026"} (${b.mins || 0}m)`).join(", ");
  return [
    hasClock || c?.payrollHours != null ? h1(k.payrollM) : "",
    payrollOtM(c, k.potOtM) > 0 ? h1(payrollOtM(c, k.potOtM)) : (c?.payrollOtHours != null ? c.payrollOtHours : ""),
    payrollNarrative(c, k),
    c?.planned ? `${c.planned.start || "?"}\u2013${c.planned.end || "?"} (${h1(k.contractedM)}h)` : (hasClock ? "Not scheduled" : ""),
    c?.planned ? (k.breakEntM > 0 ? `${h1(k.breakEntM)}h ${k.breaksPaid ? "paid" : "unpaid"}` : "none") : "",
    k.paidContractedM > 0 ? h1(k.paidContractedM) : "",
    hasClock ? sessionsText(c.sessions) : "",
    hasClock ? h1(k.actualM) : "",
    breaksList ? `${breaksList}${k.breakTakenM > 0 ? ` = ${h1(k.breakTakenM)}h` : ""}` : "",
    k.potOtM > 0 ? h1(k.potOtM) : "",
    k.potOtM > 0 || c?.payrollOtHours != null ? (c?.overtimeApproved ? "Yes" : "No") : "",
    k.autoConf ? (c?.eventReviewed ? "Auto + reviewed" : "Auto") : (c?.eventReviewed ? "Reviewed" : (hasClock ? "NOT REVIEWED" : ""))
    // manager notes + session notes appended by the caller (kept separate so
    // callers with different note sources can supply their own)
  ];
}
function styledTimesheetSheet({ infoLines, blocks, dataRows, totalsRow, estimatedRows = null, flaggedRows = null }) {
  const cols = blocks.flatMap(b => b.cols.map(cl => ({ ...cl, _b: b })));
  const NCOL = cols.length;
  let ci0 = 0;
  const bannerRow = [];
  for (const b of blocks) { b._start = ci0; for (let i = 0; i < b.cols.length; i++) bannerRow.push(i === 0 ? (b.title || "") : ""); ci0 += b.cols.length; }
  const aoa = [...infoLines.map(l => [l]), [], bannerRow, cols.map(cl => cl.label), ...dataRows];
  const BANNER_R = infoLines.length + 1, HDR_R = BANNER_R + 1;
  const DATA_R0 = HDR_R + 1;   // estimatedRows indexes are relative to dataRows
  if (totalsRow) aoa.push(totalsRow);
  const TOT_R = totalsRow ? aoa.length - 1 : -1;
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!merges"] = blocks.filter(b => b.title && b.cols.length > 1)
    .map(b => ({ s: { r: BANNER_R, c: b._start }, e: { r: BANNER_R, c: b._start + b.cols.length - 1 } }));
  ws["!cols"] = cols.map(cl => ({ wch: cl.w || 12 }));
  ws["!rows"] = []; ws["!rows"][BANNER_R] = { hpt: 18 }; ws["!rows"][HDR_R] = { hpt: 30 };
  const center = { horizontal: "center", vertical: "center" };
  const leftWrap = { horizontal: "left", vertical: "center", wrapText: true };
  const blockEnds = new Set(blocks.map(b => b._start + b.cols.length - 1));
  const lastR = TOT_R >= 0 ? TOT_R : aoa.length - 1;
  for (let r = BANNER_R; r <= lastR; r++) {
    for (let c2 = 0; c2 < NCOL; c2++) {
      const addr = XLSX.utils.encode_cell({ r, c: c2 });
      if (!ws[addr]) ws[addr] = { t: "s", v: "" };
      const col = cols[c2], b = col._b, st = {};
      const isTot = r === TOT_R;
      if (r === BANNER_R) {
        if (b.ban) st.fill = { fgColor: { rgb: b.ban } };
        st.font = { bold: true, color: { rgb: "FFFFFF" }, sz: 10 };
        st.alignment = center;
      } else if (r === HDR_R) {
        st.fill = { fgColor: { rgb: b.hdr || "F1F5F9" } };
        st.font = { bold: true, sz: 9 };
        st.alignment = { ...center, wrapText: true };
        st.border = { bottom: { style: "thin", color: { rgb: TS_LINE } } };
      } else {
        const v = ws[addr].v;
        if (col.kind === "payrollFig") { st.fill = { fgColor: { rgb: isTot ? "6EE7B7" : "D1FAE5" } }; st.font = { bold: true, sz: isTot ? 11 : 10.5 }; st.alignment = center; }
        else if (col.kind === "narrative") { st.fill = { fgColor: { rgb: isTot ? "6EE7B7" : "F0FDF4" } }; st.font = { bold: isTot, sz: 9 }; st.alignment = leftWrap; }
        else if (col.kind === "id") { st.font = { bold: true, sz: 10 }; st.alignment = { horizontal: "left", vertical: "center" }; }
        else if (col.align === "lw") { st.alignment = leftWrap; st.font = { sz: 9.5, bold: isTot }; }
        else { st.alignment = center; st.font = { sz: 10, bold: isTot }; }
        if (col.redWhen && col.redWhen(ws[addr].v)) st.font = { ...st.font, bold: true, color: { rgb: "B91C1C" } };
        // ESTIMATED day (no clock data yet): whole row italic on amber so
        // the scheduled-hours assumption is unmistakable.
        if (estimatedRows && estimatedRows.has(r - DATA_R0)) {
          st.font = { ...st.font, italic: true };
          st.fill = { fgColor: { rgb: "FEF3C7" } };
        }
        // NOT REVIEWED (neither auto-confirmed nor manually approved): the
        // WHOLE row goes light red, overriding the block tints, so an
        // unapproved day cannot be missed when scanning the sheet.
        if (flaggedRows && flaggedRows.has(r - DATA_R0)) {
          st.fill = { fgColor: { rgb: "FEE2E2" } };
        }
        if (isTot) st.border = { ...(st.border || {}), top: { style: "medium", color: { rgb: TS_LINE } } };
      }
      if (blockEnds.has(c2)) st.border = { ...(st.border || {}), right: { style: "thin", color: { rgb: TS_LINE } } };
      ws[addr].s = st;
    }
  }
  return ws;
}

// ---------------------------------------------------------------------------
// Payroll-month-end export (org setting `payroll_month_end` from Settings:
// "last" | "first" | "1".."31"; empty = legacy calendar-month export). The
// export period for the selected month runs BACKWARDS from the payroll month
// end: start = previous month's payroll end + 1 day, end = this month's
// payroll end. Scheduled days after the generation date are ESTIMATED at
// scheduled hours (italic, amber), and the workbook opens with a
// Reconciliation page showing actual clockings for the previously estimated
// block. Mirrors report_scheduler.js so manual and scheduled sheets match.
// ---------------------------------------------------------------------------
function normalizePayrollSetting(v) {
  if (v == null || v === "") return null;
  if (v === "last" || v === "first") return v;
  const n = Number(v);
  return Number.isFinite(n) && n >= 1 && n <= 31 ? n : null;
}
function payrollMonthEndSetting() {
  return normalizePayrollSetting((localStorage.getItem("payroll_month_end") || "").trim());
}
function resolvePayrollEndDateFE(year, monthIdx, setting) {
  const lastDom = new Date(year, monthIdx + 1, 0).getDate();
  if (setting === "first" || Number(setting) === 1) return new Date(year, monthIdx, 1);
  const n = Number(setting);
  if (Number.isFinite(n) && n >= 2 && n <= 31) return new Date(year, monthIdx, Math.min(n, lastDom));
  return new Date(year, monthIdx, lastDom);           // "last" / default
}
const feDayKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
function payrollPeriodForMonth(year, monthIdx, setting) {
  const end = resolvePayrollEndDateFE(year, monthIdx, setting);        // inclusive
  const prevEnd = resolvePayrollEndDateFE(monthIdx === 0 ? year - 1 : year, (monthIdx + 11) % 12, setting);
  const start = new Date(prevEnd); start.setDate(start.getDate() + 1);
  // Reconciliation block: generation-day anchor (the auto-send day, else
  // today's day-of-month) in the month of the previous payroll end → the
  // previous payroll end. Null when the previous period had no estimated tail.
  const anchor = Number(localStorage.getItem("timesheet_day")) || new Date().getDate();
  const rY = prevEnd.getFullYear(), rM = prevEnd.getMonth();
  const rLast = new Date(rY, rM + 1, 0).getDate();
  const rStart = new Date(rY, rM, Math.min(Math.max(1, anchor), rLast));
  const recon = rStart <= prevEnd
    ? { start: rStart, end: prevEnd, startKey: feDayKey(rStart), endKey: feDayKey(prevEnd) }
    : null;
  const days = [];
  const spansMonths = start.getMonth() !== end.getMonth() || start.getFullYear() !== end.getFullYear();
  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    days.push({
      date: feDayKey(d), day: d.getDate(), weekday: d.getDay(),
      label: spansMonths
        ? `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")} ${WEEKDAYS[d.getDay()]}`
        : undefined
    });
  }
  return { start, end, startKey: feDayKey(start), endKey: feDayKey(end), days, recon };
}
// Merge the selected month's payload with the previous month's (cells keyed
// by date never collide across months; staff/roles come from the selected
// month, falling back to prev-month-only staff).
function mergeMonthPayloads(cur, prev) {
  const cells = {};
  const ids = new Set([...Object.keys(cur?.cells || {}), ...Object.keys(prev?.cells || {})]);
  for (const id of ids) cells[id] = { ...(prev?.cells?.[id] || {}), ...(cur?.cells?.[id] || {}) };
  const staff = [...(cur?.staff || [])];
  const have = new Set(staff.map(x => x.staffId));
  for (const x of (prev?.staff || [])) if (!have.has(x.staffId)) staff.push(x);
  return { staff, cells };
}
// Reconciliation sheet — FIRST tab: actual clockings for the previously
// estimated block, red rows where time on site doesn't cover the contracted
// hours (shortfall / absent) or exceeds them (overtime / unscheduled).
function buildReconSheet(merged, staffList, recon, phName) {
  const rows = [];
  const dkList = [];
  for (let d = new Date(recon.start); d <= recon.end; d.setDate(d.getDate() + 1)) dkList.push(feDayKey(d));
  for (const s of staffList) {
    const cellsFor = merged.cells[s.staffId] || {};
    for (const dk of dkList) {
      const c = cellsFor[dk];
      if (!c) continue;                                    // no schedule, no clockings
      const k = dayCalc(dk, c);
      const hasClock = !!c?.sessions?.length;
      if (!hasClock && k.paidContractedM <= 0) continue;
      let status = "OK", flag = false;
      if (!hasClock && k.paidContractedM > 0) { status = `ABSENT \u2014 no clockings (${h1(k.paidContractedM)}h short)`; flag = true; }
      else if (k.netActualM + 1 < k.paidContractedM) { status = `SHORTFALL ${h1(k.paidContractedM - k.netActualM)}h`; flag = true; }
      else if (k.paidContractedM > 0 && k.netActualM > k.paidContractedM + 1) { status = `OVERTIME ${h1(k.netActualM - k.paidContractedM)}h`; flag = true; }
      else if (k.paidContractedM === 0 && k.netActualM > 0) { status = `UNSCHEDULED ${h1(k.netActualM)}h worked`; flag = true; }
      rows.push({ flag, staffName: s.staffName, dk, cells: [
        dk.split("-").reverse().join("/"),
        s.staffName,
        c?.planned ? `${c.planned.start || "?"}\u2013${c.planned.end || "?"}` : "",
        k.paidContractedM > 0 ? h1(k.paidContractedM) : "",
        hasClock ? sessionsText(c.sessions) : "",
        k.actualM > 0 ? h1(k.actualM) : "",
        k.breakTakenM > 0 ? h1(k.breakTakenM) : "",
        k.netActualM > 0 ? h1(k.netActualM) : "",
        status
      ]});
    }
  }
  // Grouped BY STAFF MEMBER, dates ascending within each group; each group
  // opens with a coloured staff band and carries an alternating group tint
  // (flagged rows stay red on top of it).
  rows.sort((a, b) => a.staffName.localeCompare(b.staffName) || a.dk.localeCompare(b.dk));
  const fmt = (d) => d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  const info = [
    `Pharmacy: ${phName}`,
    `RECONCILIATION \u2014 actual clockings for the days ESTIMATED on the previous timesheet`,
    `Window: ${fmt(recon.start)} to ${fmt(recon.end)}`,
    `Red rows: time on site does not cover the contracted hours (shortfall / absent), or exceeds them (overtime / unscheduled) \u2014 check these against what was submitted to payroll last cycle.`,
    generatedStamp()
  ];
  const header = ["Date", "Staff", "Planned session", "Paid contracted (h)",
    "Clock sessions", "On site (h)", "Breaks taken (h)", "Net (h)", "Status"];
  // Interleave a band row before each staff group; remember which output
  // rows are bands, which are flagged, and each row's group tint.
  const GROUP_BANDS = ["0F766E", "3730A3", "B45309", "0E7490", "6D28D9", "15803D"];
  const GROUP_TINTS = ["F0FDFA", "EEF2FF", "FFFBEB", "ECFEFF", "F5F3FF", "F0FDF4"];
  const outRows = [];   // { cells, kind: "band"|"data", flag, band, tint }
  let gi = -1, curStaff = null;
  for (const r of rows) {
    if (r.staffName !== curStaff) {
      curStaff = r.staffName; gi++;
      const grp = rows.filter(x => x.staffName === curStaff);
      const flagged = grp.filter(x => x.flag).length;
      outRows.push({ kind: "band", band: GROUP_BANDS[gi % GROUP_BANDS.length],
        cells: [`${curStaff} \u2014 ${grp.length} day(s), ${flagged ? `${flagged} flagged` : "all OK"}`,
                "", "", "", "", "", "", "", ""] });
    }
    outRows.push({ kind: "data", flag: r.flag, tint: GROUP_TINTS[gi % GROUP_TINTS.length], cells: r.cells });
  }
  const aoa = [...info.map(l => [l]), [], header,
    ...(outRows.length ? outRows.map(r => r.cells)
                       : [["(no scheduled sessions or clockings in this window)"]])];
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = [{ wch: 12 }, { wch: 22 }, { wch: 14 }, { wch: 11 },
                 { wch: 26 }, { wch: 10 }, { wch: 11 }, { wch: 9 }, { wch: 30 }];
  const HDR_R = info.length + 1;
  ws["!merges"] = outRows
    .map((r, i) => r.kind === "band"
      ? { s: { r: HDR_R + 1 + i, c: 0 }, e: { r: HDR_R + 1 + i, c: header.length - 1 } }
      : null)
    .filter(Boolean);
  for (let c = 0; c < header.length; c++) {
    const addr = XLSX.utils.encode_cell({ r: HDR_R, c });
    if (!ws[addr]) ws[addr] = { t: "s", v: "" };
    ws[addr].s = { fill: { fgColor: { rgb: "E2E8F0" } }, font: { bold: true, sz: 9 },
                   alignment: { horizontal: "center", vertical: "center", wrapText: true },
                   border: { bottom: { style: "thin", color: { rgb: TS_LINE } } } };
  }
  outRows.forEach((r, i) => {
    for (let c = 0; c < header.length; c++) {
      const addr = XLSX.utils.encode_cell({ r: HDR_R + 1 + i, c });
      if (!ws[addr]) ws[addr] = { t: "s", v: "" };
      if (r.kind === "band") {
        ws[addr].s = { fill: { fgColor: { rgb: r.band } },
                       font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
                       alignment: { horizontal: "left", vertical: "center" } };
        continue;
      }
      const st = { font: { sz: 9.5 }, alignment: c === 4 || c === 8
        ? { horizontal: "left", vertical: "center", wrapText: true }
        : { horizontal: "center", vertical: "center" } };
      st.fill = { fgColor: { rgb: r.flag ? "FEE2E2" : r.tint } };
      if (r.flag && c === 8) st.font = { sz: 9.5, bold: true, color: { rgb: "B91C1C" } };
      ws[addr].s = st;
    }
  });
  return ws;
}

// One staff member's styled MONTH tab (one row per day).
// opts (payroll-month-end mode): { estimateAfterKey } — scheduled period
// days AFTER that date with no clockings are ESTIMATED at scheduled hours
// (italic on amber) so the period totals are right for the payment cycle.
function buildStyledMonthSheet(mData, s, phName, monthLabelStr, opts = {}) {
  const estimateAfterKey = opts.estimateAfterKey || null;
  // changeLogs: { `${staffId}|${date}` -> multi-line audit text }. When
  // supplied, an extra "Changes made (audit log)" column is added to the
  // WHAT HAPPENED block. Absent (e.g. an export with no log to hand) the
  // sheet keeps its original 15 columns.
  const changeLogs = opts.changeLogs || null;
  const withChanges = !!changeLogs;
  const logFor = (dk) => (changeLogs && changeLogs[`${s.staffId}|${dk}`]) || "";
  const CHG_AT = 12;                      // insert before "Review status"
  const withChg = (row, text) => { if (withChanges) row.splice(CHG_AT, 0, text); return row; };
  const cellsFor = mData.cells[s.staffId] || {};
  let payrollTotM = 0, otApprovedTotM = 0, onSiteTotM = 0, breakTotM = 0, paidContrTotM = 0;
  let needReview = 0, reviewedN = 0;
  const estimatedRowIdx = new Set();
  const notApprovedRowIdx = new Set();
  let changedN = 0;
  const dataRows = mData.days.map((d, di) => {
    const c = cellsFor[d.date];
    const k = dayCalc(d.date, c);
    const hasClock = !!c?.sessions?.length;
    const isEstimated = !!(estimateAfterKey && d.date > estimateAfterKey && !hasClock);
    const dayLabel = d.label || `${d.day} ${WEEKDAYS[d.weekday]}`;
    if (isEstimated) {
      // No clock data yet — assume the scheduled (paid contracted) hours.
      if (k.paidContractedM > 0 || c?.planned) {
        payrollTotM += k.paidContractedM; paidContrTotM += k.paidContractedM;
        estimatedRowIdx.add(di);
        return withChg([
          dayLabel,
          k.paidContractedM > 0 ? h1(k.paidContractedM) : "",
          "",
          "ESTIMATED \u2014 scheduled hours assumed; clock in/out data not yet available for this day",
          c?.planned ? `${c.planned.start || "?"}\u2013${c.planned.end || "?"} (${h1(k.contractedM)}h)` : "",
          c?.planned ? (k.breakEntM > 0 ? `${h1(k.breakEntM)}h ${k.breaksPaid ? "paid" : "unpaid"}` : "none") : "",
          k.paidContractedM > 0 ? h1(k.paidContractedM) : "",
          "", "", "", "", "", "ESTIMATED", "", ""
        ], "");
      }
      // Not scheduled that day — an empty future row, still amber/italic.
      estimatedRowIdx.add(di);
      return withChg([dayLabel, "", "", "", "", "", "", "", "", "", "", "", "", "", ""], "");
    }
    payrollTotM += k.payrollM; otApprovedTotM += payrollOtM(c, k.potOtM);
    onSiteTotM += k.actualM; breakTotM += k.breakTakenM; paidContrTotM += k.paidContractedM;
    if (hasClock) { needReview++; if (k.autoConf || c?.eventReviewed) reviewedN++; }
    // Unapproved = has clockings but neither auto-confirmed nor manually
    // reviewed — i.e. the "NOT REVIEWED" review status.
    if (hasClock && !(k.autoConf || c?.eventReviewed)) notApprovedRowIdx.add(di);
    const chg = logFor(d.date);
    if (chg) changedN++;
    return withChg([
      dayLabel,
      ...tsRowCells(c, k),
      c?.reviewNotes || "",
      (c?.sessions || []).map(x => [x.inNotes, x.outNotes].filter(Boolean).join("; ")).filter(Boolean).join(" | ")
    ], chg);
  });
  const totalsRow = withChg([
    "TOTALS", h1(payrollTotM), h1(otApprovedTotM),
    `SUBMIT TO PAYROLL: ${h1(payrollTotM)}h contracted + ${h1(otApprovedTotM)}h approved overtime`,
    "", "", paidContrTotM > 0 ? h1(paidContrTotM) : "",
    "", h1(onSiteTotM), breakTotM > 0 ? h1(breakTotM) : "", "", "",
    needReview ? `${reviewedN}/${needReview} days reviewed` : "", "", ""
  ], changedN ? `${changedN} day(s) with recorded changes` : "");
  return styledTimesheetSheet({
    infoLines: [
      `Pharmacy: ${phName}`, `Staff: ${s.staffName} (${s.roleName})`,
      `Four week contracted hours total: ${s.fourWeekContractedH != null ? s.fourWeekContractedH.toFixed(2) : "\u2014"}h`,
      `Clock in/out \u2014 month view: ${monthLabelStr}`, generatedStamp(),
      ...(notApprovedRowIdx.size
        ? [`NOTE: ${notApprovedRowIdx.size} day(s) shaded LIGHT RED are NOT REVIEWED \u2014 neither auto-confirmed nor approved by a manager.`]
        : []),
      ...(withChanges
        ? [`NOTE: "Changes made (audit log)" lists every recorded alteration for the day (original \u2192 new value, with who and when). Blank means the day has not been altered.`]
        : []),
      ...(estimatedRowIdx.size
        ? [`NOTE: ${estimatedRowIdx.size} day(s) shown in italic on amber are ESTIMATED at scheduled hours (clock data not yet available).`]
        : [])
    ],
    blocks: tsBlocks([{ label: "Day", w: opts.estimateAfterKey ? 14 : 10, kind: "id" }], { withChanges }),
    dataRows, totalsRow,
    estimatedRows: estimatedRowIdx.size ? estimatedRowIdx : null,
    flaggedRows: notApprovedRowIdx.size ? notApprovedRowIdx : null
  });
}
// ---------------------------------------------------------------------------
// v3.37: audit trail for the timesheet export. Only days that were actually
// ALTERED are fetched (clock times edited, payroll/overtime overridden, or
// manager notes written) — a plain "review complete" tick is not an edit, so
// a clean month costs no extra requests. Returns
// { `${staffId}|${date}` -> multi-line text } for the sheet builder.
// NOTE: the backend scheduled report (report_scheduler.js) should read the
// same log server-side and build this map directly — the sheet builder takes
// the map, not the fetcher, so the two stay identical.
// ---------------------------------------------------------------------------
const CHANGE_LOG_CONCURRENCY = 5;
const CHANGE_LOG_MAX_DAYS = 600;         // hard ceiling on requests per export
function dayWasEdited(c) {
  if (!c) return false;
  return !!(c.clockManuallyEdited
    || c.payrollHours != null
    || c.payrollOtHours != null
    || (c.reviewNotes && String(c.reviewNotes).trim()));
}
async function fetchChangeLogs(dbName, mData, staffList, days) {
  const jobs = [];
  for (const s of staffList) {
    const cellsFor = mData?.cells?.[s.staffId] || {};
    for (const d of (days || [])) {
      if (dayWasEdited(cellsFor[d.date])) jobs.push({ staffId: s.staffId, date: d.date });
    }
  }
  const out = {};
  if (!jobs.length) return out;
  const capped = jobs.slice(0, CHANGE_LOG_MAX_DAYS);
  const stamp = (at) => {
    if (!at) return "";
    const dt = new Date(at);
    return isNaN(dt) ? "" : dt.toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
  };
  let next = 0;
  const worker = async () => {
    while (next < capped.length) {
      const j = capped[next++];
      const key = `${j.staffId}|${j.date}`;
      try {
        const r = await post("/api/headoffice/clock/review/history", { dbName, staffId: j.staffId, date: j.date });
        const lines = (r.log || []).map(l =>
          `${[stamp(l.at), l.by].filter(Boolean).join(" \u2014 ")}${(l.at || l.by) ? ": " : ""}${l.msg || ""}`.trim());
        if (lines.length) out[key] = lines.join("\n");
      } catch (e) {
        out[key] = `(change log could not be loaded: ${e.message})`;
      }
    }
  };
  await Promise.all(Array.from({ length: Math.min(CHANGE_LOG_CONCURRENCY, capped.length) }, worker));
  if (jobs.length > capped.length) {
    out.__truncated = jobs.length - capped.length;
  }
  return out;
}

function exportSheet(rows, sheetName, fileName, headerLines = []) {
  exportWorkbook([{ name: sheetName, headerLines, rows }], fileName);
}
const generatedStamp = () => `Generated: ${new Date().toLocaleString("en-GB")}`;
const orgLine = () => localStorage.getItem("organisationName") || "";

const Legend = () => (
  <div style={{ display: "flex", gap: 14, flexWrap: "wrap", fontSize: 12, color: "#374151", alignItems: "center" }}>
    {[["Auto-confirmed (clean & complete) or review complete", C.green],
      ["Clean, still clocked in", C.amber],
      [`Needs attention — late in, left early / >${LATE_OUT_GRACE_MIN} min late out, >${DIST_LIMIT_M}m away, notes, or absent`, C.red]]
      .map(([t, c]) => (
        <span key={t} style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <span style={{ width: 14, height: 14, background: c, border: "1px solid #d1d5db", borderRadius: 3, display: "inline-block" }} />{t}
        </span>
      ))}
    <span style={{ color: "#6b7280" }}>Hover a cell for the detail; click a month cell for the full analysis and the approval ticks.</span>
  </div>
);

/* ============================================================================
   Shared cell analysis dialogue — used by BOTH the day view (double-click a
   staff chip) and the month view (click a cell). Shows the full day
   analysis, the overtime and event-review ticks with manager notes, and the
   planned-hours pattern editor.
   Props:
     dbName        tenant of the pharmacy the entry belongs to
     entry         { staffId, staffName, date 'YYYY-MM-DD', weekday,
                     occurrence, planned, sessions, breaks, overtimeMins,
                     overtimeApproved, eventReviewed, reviewNotes }
     onLocalPatch  (fields) => void — optimistic update of the host view
     onReload      () => Promise — full refresh (fallback + after saves)
     onClose       () => void
   ============================================================================ */
// Feature flags: staff self-service schedule emails. The SINGLE-staff send
// (inside the weekly schedule dialogue opened from a staff member's name)
// is live. Bulk "email all staff" was REMOVED entirely — its UI code is
// gone from this file and the backend (headoffice v41.1) refuses any
// request that is not exactly one named staff member, so bulk sends
// cannot be triggered from anywhere.
const SCHEDULE_INVITE_SINGLE_ENABLED = true;

// Send self-service schedule form emails (24h tokenised links) with a
// confirmatory dialog before sending and a result summary after.
async function sendScheduleInvites({ dbName, staffIds, label }) {
  if (!window.confirm(`Email an interactive schedule form (24-hour link) to ${label}?`)) return;
  try {
    const r = await post("/api/headoffice/clock/schedule/invite", { dbName, staffIds });
    const parts = [`✔ ${r.sent} email${r.sent === 1 ? "" : "s"} sent.`];
    if (r.skippedNoEmail?.length) parts.push(`Skipped (no email address): ${r.skippedNoEmail.join(", ")}.`);
    if (r.failed?.length) parts.push(`Failed: ${r.failed.join(", ")}.`);
    window.alert(parts.join("\n"));
  } catch (e) { window.alert(`Could not send: ${e.message}`); }
}

/* Schedule dialog — opened by clicking a staff member's NAME on the day or
   month view. v3.26: BOTH routes now use the SAME four-week editor
   (SchedulePatternDialog): day-view name-clicks render it directly (with the
   role subtitle and email-invite button), while the month view keeps its
   full-page day list and opens it from the "Configure scheduled hours"
   button. One editor, one behaviour: per-day breaks, Replicate and Apply
   both carry breaks with the hours. */
function StaffScheduleDialog({ dbName, staffId, staffName, roleName, onReload, onClose,
                               monthDays, cellsForStaff, monthLabel, fourWeekContractedH, onCellPatch }) {
  const monthMode = Array.isArray(monthDays) && monthDays.length > 0;
  const [showPattern, setShowPattern] = useState(false);

  /* --------------- Day view name-click: the SAME four-week editor as the
     month view's "Configure scheduled hours" button — one editor everywhere
     (v3.26). Per-day break column, Replicate (hours AND breaks), per-row
     "Save all changes" single-save flow (v3.31). --------------- */
  if (!monthMode) return (
    <SchedulePatternDialog dbName={dbName} staffId={staffId} staffName={staffName} roleName={roleName}
      showEmailInvite
      onClose={onClose}
      onSaved={async () => { await onReload(); onClose(); }} />
  );

  /* ------------- month layout: full-width day list + pattern popup ------------- */
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9550 }}>
      <div style={{ background: "#fff", borderRadius: 8, width: "min(1780px, 98vw)", height: "92vh", display: "flex", flexDirection: "column", padding: 0, overflow: "hidden" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, padding: "12px 18px 10px", borderBottom: "1px solid #e5e7eb", flexWrap: "wrap" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <span style={{ fontWeight: 800, fontSize: 16 }}>{staffName}</span>
            <span style={{ fontSize: 12.5, color: "#6b7280" }}>{roleName || "—"}{monthLabel ? ` — ${monthLabel}` : ""}</span>
            {(() => {
              const cells = cellsForStaff || {};
              const hrs2 = (m) => (Math.round((m / 60) * 100) / 100).toFixed(2);
              let need = 0, done = 0, contM = 0, payM = 0, otM = 0;
              for (const dd of monthDays) {
                const cc = cells[dd.date] || {};
                const calc2 = dayCalc(dd.date, cc);
                contM += calc2.paidContractedM;
                const coveredM = Math.min(calc2.netActualM, calc2.paidContractedM > 0 ? calc2.paidContractedM : calc2.netActualM);
                payM += cc.payrollHours != null ? Math.round(cc.payrollHours * 60) : coveredM;
                if (cc.overtimeApproved) otM += cc.payrollOtHours != null ? Math.round(cc.payrollOtHours * 60) : calc2.potOtM;
                const pl = cc.planned || null, ss = cc.sessions || [];
                if (!ss.length && !pl) continue;
                need++;
                if (cc.eventReviewed || calc2.autoConf) done++;
              }
              const all = need > 0 && done === need;
              const match = hrs2(contM) === hrs2(payM);
              const chip = (bg, col, bord) => ({ fontSize: 12.5, fontWeight: 800, padding: "3px 10px", borderRadius: 5,
                background: bg, color: col, border: `1px solid ${bord}`, whiteSpace: "nowrap" });
              const grey = chip("#f3f4f6", "#374151", "#e5e7eb");
              const green = chip("#dcfce7", "#15803d", "#86efac");
              return (
                <>
                  <span style={all ? green : chip("#fde68a", "#92400e", "#f59e0b")}
                        title="Days with a schedule or clockings that are reviewed (automatically or manually) out of all days requiring review this month.">
                    Days reviewed: {done}/{need}
                  </span>
                  <span style={match ? green : grey}
                        title="The month's paid contracted hours: each scheduled day's hours less its break when unpaid, summed.">
                    Total cont hrs: {hrs2(contM)}
                  </span>
                  <span style={match ? green : grey}
                        title="Each day's standard payroll hours summed: the manual override where set, otherwise on-site hours capped at contracted. Green (with Total cont hrs) when the two match.">
                    Payroll cont. hrs: {hrs2(payM)}
                  </span>
                  <span style={chip("#eff6ff", "#1d4ed8", "#bfdbfe")}
                        title="Payroll overtime summed over days where Approved is ticked: the manual o/time override where set, otherwise the day's potential overtime.">
                    Payroll o/time: {hrs2(otM)}
                  </span>
                </>
              );
            })()}
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button style={{ ...S.btn("#fff"), background: "#0f766e", color: "#fff", border: "none", fontWeight: 700 }}
              onClick={() => setShowPattern(true)}>
              Configure scheduled hours
            </button>
            {SCHEDULE_INVITE_SINGLE_ENABLED && (
              <button style={S.btn("#3730a3")}
                title="Emails this staff member a personal link (valid 24 hours) to view, update and submit their own four-week schedule (weeks 1–4 of the month)."
                onClick={() => sendScheduleInvites({ dbName, staffIds: [staffId], label: staffName })}>
                ✉ Email schedule form
              </button>
            )}
            <button style={S.btn("#6b7280")} onClick={onClose}>Close</button>
          </div>
        </div>
        <StaffMonthDayList
          dbName={dbName} staffId={staffId} staffName={staffName}
          monthDays={monthDays} cellsForStaff={cellsForStaff || {}}
          fourWeekContractedH={fourWeekContractedH}
          onCellPatch={onCellPatch}
          onReload={onReload}
        />
        {showPattern && (
          <SchedulePatternDialog dbName={dbName} staffId={staffId} staffName={staffName}
            onClose={() => setShowPattern(false)}
            onSaved={async () => { setShowPattern(false); await onReload(); }} />
        )}
      </div>
    </div>
  );
}

/* -----------------------------------------------------------------------------
   THE four-week schedule editor (the single editor for both routes: the
   month view's "Configure scheduled hours" button AND day-view staff-name
   clicks). FOUR WEEK SECTIONS (week 1..4 of the month) — Mon–Sun start/end
   AND a per-day break length in each — plus one paid-breaks flag.
   v3.31: ONE SAVE SYSTEM. Per-row Apply is gone; every change (edits,
   Replicate, paid-breaks toggle) only updates the editor and enables the
   single "Save all changes" button, which writes all four weeks in one go
   (emptied days cleared; week 1 also writes occurrence 5). The dialog is
   strictly modal: clicking the backdrop does nothing; Close/Cancel with
   unsaved changes asks "Abandon all changes and close?" first.
   Optional props: roleName (subtitle) and showEmailInvite (self-service
   schedule email button) for the day-view name-click route.
   ----------------------------------------------------------------------------- */
function SchedulePatternDialog({ dbName, staffId, staffName, roleName, onClose, onSaved, showEmailInvite }) {
  const WD_ORDER = [1, 2, 3, 4, 5, 6, 0];
  const WD_FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const WEEKS = [1, 2, 3, 4];
  const [rows, setRows] = useState(null);   // week (1-4) -> weekday -> {start,end,breakH}
  const [changed, setChanged] = useState(false); // any unsaved change (edits, Replicate, paid-breaks) — enables Save all changes
  const [breaksPaid, setBreaksPaid] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [msg, setMsg] = useState(null);
  const HELP_WEEKS = "Configure the pattern for week 1. Replicate this for the other weeks, and make any further adjustments as required. " +
    "Each week is the 1st, 2nd, 3rd or 4th occurrence of that weekday in the month — every month repeats the same four-week pattern. " +
    "A 5th Monday, Tuesday etc. in a longer month follows the Week 1 pattern.";

  useEffect(() => {
    (async () => {
      try {
        const d = await post("/api/headoffice/clock/times/get", { dbName, staffId });
        const byWkWd = {};
        for (const t of d.times || []) {
          const occ = Number(t.occurrence) || 1;
          if (occ < 1 || occ > 4) continue; // occurrence 5 mirrors week 1
          byWkWd[occ] = byWkWd[occ] || {};
          byWkWd[occ][t.weekday] = { start: t.start || "", end: t.end || "",
            breakH: t.breakMins ? String(Math.round((t.breakMins / 60) * 100) / 100) : "0" };
          if (t.breaksPaid) setBreaksPaid(true);
        }
        const r = {};
        for (const wk of WEEKS) { r[wk] = {}; for (const wd of WD_ORDER) r[wk][wd] = byWkWd[wk]?.[wd] || { start: "", end: "", breakH: "0" }; }
        setRows(r);
      } catch (e) { setErr(e.message); setRows({}); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbName, staffId]);

  const edit = (wk, wd, field, v) => {
    setRows(r => ({ ...r, [wk]: { ...r[wk], [wd]: { ...r[wk][wd], [field]: v } } }));
    setChanged(true);
    setMsg(null);
  };
  // Replicate copies hours AND breaks — the whole row — for every day of week 1
  const replicateWeek1 = () => {
    setRows(r => { const n = { ...r }; for (const wk of [2, 3, 4]) { n[wk] = {}; for (const wd of WD_ORDER) n[wk][wd] = { ...r[1][wd] }; } return n; });
    setChanged(true);
    setMsg("Week 1 (hours and breaks) copied to weeks 2–4 — adjust as required, then Save all changes.");
  };
  // Cancel / Close: nothing was written along the way, so with unsaved
  // changes we confirm before abandoning them.
  const guardedClose = () => {
    if (changed && !window.confirm("Abandon all changes and close?")) return;
    onClose();
  };

  const savePattern = async () => {
    setBusy(true); setErr(null);
    try {
      for (const wk of WEEKS) {
        for (const wd of WD_ORDER) {
          const r = rows[wk]?.[wd] || {};
          await post("/api/headoffice/clock/times/set", {
            dbName, staffId, weekday: wd, occurrences: occsForWeek(wk),
            start: r.start || null, end: r.end || null,
            breakMins: Math.round(Number(r.breakH || 0) * 60), breaksPaid
          });
        }
      }
      await post("/api/headoffice/clock/event/review", {
        dbName, staffId, date: new Date().toISOString().slice(0, 10),
        log: ["Four-week pattern saved via Configure scheduled hours"]
      }).catch(() => {});
      await onSaved();
    } catch (e) { setErr(e.message); setBusy(false); }
  };

  const inp = { ...S.inp };
  const weekGrid = (wk) => (
    <div key={wk} style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 10px", background: wk === 1 ? "#f0fdfa" : "#fafafa", minWidth: 0 }}
         title={HELP_WEEKS}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 6 }}>
        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 0.5, color: wk === 1 ? "#0f766e" : "#6b7280", textTransform: "uppercase" }}>
          Week {wk} <span style={{ fontWeight: 600, textTransform: "none" }}>— {WEEK_ORD[wk - 1]} of each weekday</span>
        </div>
        {wk === 1 && (
          <button style={{ ...S.btn("#0f766e"), whiteSpace: "nowrap", padding: "4px 9px", fontSize: 11.5 }}
            disabled={busy}
            title="Copies every day of Week 1 — hours AND breaks — into Weeks 2, 3 and 4 in this editor. Adjust as required, then Save all changes."
            onClick={replicateWeek1}>
            Replicate to weeks 2–4 →
          </button>
        )}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "80px 1fr 10px 1fr 64px", gap: "5px 6px", alignItems: "center", fontSize: 12.5 }}>
        <div />
        <div style={{ ...S.lab, marginBottom: 0 }}>Start</div><div />
        <div style={{ ...S.lab, marginBottom: 0 }}>End</div>
        <div style={{ ...S.lab, marginBottom: 0 }}>Break (h)</div>
        {WD_ORDER.map(wd => (
          <React.Fragment key={wd}>
            <div style={{ fontWeight: 700 }}>{WD_FULL[wd]}</div>
            <input type="time" style={inp} value={rows[wk][wd]?.start || ""} onChange={e => edit(wk, wd, "start", e.target.value)}
              title="Double-click to set 09:00–18:00"
              onDoubleClick={() => { edit(wk, wd, "start", "09:00"); edit(wk, wd, "end", "18:00"); }} />
            <span style={{ color: "#9ca3af", textAlign: "center" }}>–</span>
            <input type="time" style={inp} value={rows[wk][wd]?.end || ""} onChange={e => edit(wk, wd, "end", e.target.value)} />
            <input type="number" min="0" step="0.25" style={{ ...inp, width: 54 }} value={rows[wk][wd]?.breakH ?? "0"}
              onChange={e => edit(wk, wd, "breakH", e.target.value)} />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9580 }}>
      {/* v3.31: strictly modal — clicking the backdrop does NOT close */}
      <div style={{ background: "#fff", borderRadius: 8, width: "min(1660px, 98vw)", maxHeight: "90vh", overflowY: "auto", padding: 18 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 4 }}>
          <div style={{ fontWeight: 800, fontSize: 15 }}>Configure scheduled hours — {staffName}</div>
          <button style={S.btn("#6b7280")} onClick={guardedClose}>Close</button>
        </div>
        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 12 }} title={HELP_WEEKS}>
          {roleName ? <span><b>{roleName}</b> — </span> : null}
          Start/end and break length per weekday, for each of weeks 1–4 of the month.
          Configure <b>Week 1</b>, use <b>Replicate</b>, then adjust the other weeks as required. Nothing is saved until you click <b>Save all changes</b>.
        </div>
        {err && <div style={{ color: "#dc2626", fontSize: 12.5, marginBottom: 8 }}>{err}</div>}
        {msg && <div style={{ color: "#15803d", fontSize: 13, fontWeight: 700, marginBottom: 8 }}>{msg}</div>}
        {rows === null && <div style={{ fontSize: 13, color: "#6b7280" }}>Loading…</div>}
        {rows !== null && (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 10 }}>
              {WEEKS.map(wk => weekGrid(wk))}
            </div>
            <div style={{ marginTop: 12, fontSize: 13.5, fontWeight: 700 }}
                 title="The four weeks above summed: each scheduled day's hours minus that day's break when breaks are unpaid. Updates live as you edit.">
              Four week contracted hours total: {(() => {
                let totalM = 0;
                for (const wk of WEEKS) for (const wd of WD_ORDER) {
                  const r = rows?.[wk]?.[wd];
                  if (!r || !r.start || !r.end) continue;
                  const [sh, sm] = r.start.split(":").map(Number), [eh, em] = r.end.split(":").map(Number);
                  let m = Math.max(0, (eh * 60 + (em || 0)) - (sh * 60 + (sm || 0)));
                  if (!breaksPaid) m = Math.max(0, m - Math.round(Number(r.breakH || 0) * 60));
                  totalM += m;
                }
                return `${(totalM / 60).toFixed(2)}h`;
              })()}
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 10, flexWrap: "wrap", gap: 10 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
                <input type="checkbox" checked={breaksPaid} onChange={e => { setBreaksPaid(e.target.checked); setChanged(true); setMsg(null); }} />
                Paid breaks?
              </label>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {changed && <span style={{ fontSize: 12, fontWeight: 700, color: "#b45309" }}>Unsaved changes</span>}
                <button style={S.btn("#6b7280")} disabled={busy}
                  title="Discards every change made in this dialogue (after confirmation) and closes it. Nothing has been saved along the way."
                  onClick={guardedClose}>
                  Cancel
                </button>
                <button style={{ ...S.btn("#fff"), background: changed ? "#0f766e" : "#9ca3af", color: "#fff", border: "none", fontWeight: 800, padding: "8px 18px",
                                 cursor: changed && !busy ? "pointer" : "default" }}
                  disabled={busy || !changed}
                  title="Saves everything in this dialogue in one go — all four weeks, hours and breaks. Enabled once anything has been changed."
                  onClick={savePattern}>
                  {busy ? "Saving…" : "Save all changes"}
                </button>
              </div>
            </div>
            <div style={{ fontSize: 11.5, color: "#9ca3af", marginTop: 8 }}>
              Nothing is saved until you click Save all changes. Days left empty are cleared (not scheduled). Overwrites the existing four-week pattern; every month repeats it. A 5th occurrence of a weekday follows Week 1.
            </div>
            {showEmailInvite && SCHEDULE_INVITE_SINGLE_ENABLED && (
              <button style={{ ...S.btn("#3730a3"), marginTop: 12 }}
                title="Emails this staff member a personal link (valid 24 hours) to view, update and submit their own four-week schedule (weeks 1–4 of the month) — breaks stay manager-only; the form shows their four-week contracted total."
                onClick={() => sendScheduleInvites({ dbName, staffIds: [staffId], label: staffName })}>
                ✉ Email schedule form to {staffName}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}

/* -----------------------------------------------------------------------------
   Right panel of the (month) staff dialog: one analysis card per day — the
   same figures the cell dialog shows — with AUTO-SAVING controls: reviewed
   tick (double-click the card also marks review complete), overtime approval,
   payroll hours and manager notes. Every save patches the month grid live.
   ----------------------------------------------------------------------------- */
function StaffMonthDayList({ dbName, staffId, staffName, monthDays, cellsForStaff, fourWeekContractedH, onCellPatch, onReload }) {
  const [patches, setPatches] = useState({});      // date -> saved field patches
  const [drafts, setDrafts] = useState({});        // date -> unsaved text drafts
  const [saveErr, setSaveErr] = useState(null);
  const [savedFlash, setSavedFlash] = useState(null);
  const [logFor, setLogFor] = useState(null);      // { date } — per-day change-log popup
  const [logRows, setLogRows] = useState(null);
  const openLog = async (date) => {
    setLogFor({ date }); setLogRows(null);
    try {
      const dd = await post("/api/headoffice/clock/review/history", { dbName, staffId, date });
      setLogRows(dd.log || []);
    } catch (e) { setLogRows([{ at: null, msg: `Could not load log: ${e.message}` }]); }
  };
  const cellOf = (date) => ({ ...(cellsForStaff[date] || {}), ...(patches[date] || {}) });

  const flash = (date) => {
    setSavedFlash(date);
    setTimeout(() => setSavedFlash(f => (f === date ? null : f)), 1600);
  };
  const friendly = (msg) => /Forbidden|not valid JSON|Unexpected token/i.test(String(msg))
    ? "the server refused the request (your session may have expired — refresh and log in again). The change was NOT saved and has been undone."
    : String(msg);
  const persist = async (date, patch, logMsgs) => {
    const before = {};
    const cur = cellOf(date);
    for (const k of Object.keys(patch)) before[k] = cur[k];
    setPatches(p => ({ ...p, [date]: { ...(p[date] || {}), ...patch } }));
    onCellPatch && onCellPatch(date, patch);
    flash(date);
    try {
      await post("/api/headoffice/clock/event/review", { dbName, staffId, date,
        approved: patch.eventReviewed != null ? patch.eventReviewed : !!cellOf(date).eventReviewed,
        ...(patch.reviewNotes != null ? { notes: patch.reviewNotes } : {}),
        ...(patch.payrollHours != null ? { payrollHours: patch.payrollHours } : {}),
        ...(patch.payrollOtHours != null ? { payrollOtHours: patch.payrollOtHours } : {}),
        log: logMsgs || [] });
      setSaveErr(null);
    } catch (e) {
      setPatches(p => ({ ...p, [date]: { ...(p[date] || {}), ...before } }));
      onCellPatch && onCellPatch(date, before);
      setSaveErr(`${dmy(date)}: save failed — ${friendly(e.message)}`);
    }
  };
  const approveOt = async (date, approved) => {
    const prev = !!cellOf(date).overtimeApproved;
    setPatches(p => ({ ...p, [date]: { ...(p[date] || {}), overtimeApproved: approved } }));
    onCellPatch && onCellPatch(date, { overtimeApproved: approved });
    flash(date);
    try {
      await post("/api/headoffice/clock/overtime/approve", { dbName, staffId, date, approved });
      await post("/api/headoffice/clock/event/review", { dbName, staffId, date,
        approved: !!cellOf(date).eventReviewed,
        log: [`Overtime ${approved ? "approved" : "un-approved"} (staff dialogue)`] }).catch(() => {});
      setSaveErr(null);
    } catch (e) {
      setPatches(p => ({ ...p, [date]: { ...(p[date] || {}), overtimeApproved: prev } }));
      onCellPatch && onCellPatch(date, { overtimeApproved: prev });
      setSaveErr(`${dmy(date)}: overtime save failed — ${friendly(e.message)}`);
    }
  };
  // v3.28: persistPlanned removed — the planned session is read-only in this
  // list; planned times are edited only in the four-week schedule editor.

  /* ---- layout: five sections separated by vertical rules, minimal height ---- */
  const COLS = "180px 280px 230px minmax(430px, 1fr)"; // v3.29: Planned session | What happened (Validated chip at foot) | Analysis | Review
  const secH = { fontSize: 10.5, fontWeight: 800, letterSpacing: 0.5, color: "#6b7280", textTransform: "uppercase", whiteSpace: "nowrap" };
  const tinyInp = { border: "1px solid #d1d5db", borderRadius: 4, fontSize: 12, padding: "1px 3px", fontFamily: "inherit" };
  const RULE = "1px solid rgba(15, 23, 42, 0.14)";
  const sec = { borderRight: RULE, paddingRight: 10, minWidth: 0, alignSelf: "stretch" };
  const ord = (n) => n + (n % 100 >= 11 && n % 100 <= 13 ? "th" : ["th", "st", "nd", "rd"][Math.min(n % 10, 4)] || "th");
  const hrs = (m) => (Math.round((m / 60) * 100) / 100).toFixed(2);

  return (
    <div style={{ flex: 1, minWidth: 0, overflowY: "auto", padding: "8px 16px", background: "#fafafa" }}>
      {(() => null)()}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5, gap: 10, flexWrap: "wrap" }}>
        <div style={{ fontSize: 12, color: "#6b7280" }}>
          Changes save automatically {"\u00b7"} double-click a day to mark it reviewed {"\u00b7"} planned times are read-only here \u2014 edit them in the schedule editor (Configure scheduled hours)
        </div>
        <div style={{ fontSize: 12, color: "#6b7280" }}>
          <span style={{ background: "#dcfce7", padding: "1px 8px", borderRadius: 3 }}>approved</span>{" "}
          <span style={{ background: "#fde68a", padding: "1px 8px", borderRadius: 3 }}>needs attention</span>
        </div>
      </div>
      {saveErr && <div style={{ color: "#dc2626", fontSize: 12.5, marginBottom: 6 }}>{saveErr}</div>}

      <div style={{ display: "grid", gridTemplateColumns: COLS, gap: 10, padding: "2px 10px", marginBottom: 2 }}>
        <div style={secH}>Planned session</div>
        <div style={secH}>What happened</div>
        <div style={secH}>Analysis</div>
        <div style={secH}>Review</div>
      </div>

      {monthDays.map(d => {
        const c = cellOf(d.date);
        const planned = c.planned || null;
        const sessions = c.sessions || [];
        const breaks = c.breaks || [];
        const calc = dayCalc(d.date, c);
        const issues = cellIssues(d.date, planned, sessions);
        const empty = !sessions.length && !planned;
        const approved = !!c.eventReviewed || calc.autoConf;
        const bg = empty ? "#fff" : approved ? "#dcfce7" : "#fde68a";
        const border = empty ? "#e5e7eb" : approved ? "#86efac" : "#f59e0b";
        const draft = drafts[d.date] || {};
        const setDraft = (field, v) => setDrafts(x => ({ ...x, [d.date]: { ...(x[d.date] || {}), [field]: v } }));
        const clearDraft = (field) => setDrafts(x => ({ ...x, [d.date]: { ...(x[d.date] || {}), [field]: undefined } }));

        const notesVal = draft.notes !== undefined ? draft.notes : (c.reviewNotes || "");
        const saveNotes = () => {
          if (draft.notes === undefined || draft.notes === (c.reviewNotes || "")) { clearDraft("notes"); return; }
          const v = draft.notes; clearDraft("notes");
          persist(d.date, { reviewNotes: v }, ["Manager notes updated (staff dialogue)"]);
        };

        const firstIn = sessions.length ? sessions[0] : null;
        const lastOutSession = [...sessions].reverse().find(s => s.out) || null;
        const inDevice = firstIn ? firstIn.inDevice : null;
        const outDevice = lastOutSession ? lastOutSession.outDevice : null;
        const distIn = firstIn ? firstIn.distIn : null;
        const distOut = lastOutSession ? lastOutSession.distOut : null;
        const breakTakenM = breaks.reduce((t, b) => t + (b.mins || 0), 0);

        return (
          <div key={d.date}
            onDoubleClick={() => { if (!c.eventReviewed && !empty) persist(d.date, { eventReviewed: true }, ["Review marked complete (double-click in staff dialogue)"]); }}
            title={empty ? undefined : "Double-click to mark review complete"}
            style={{ display: "grid", gridTemplateColumns: COLS, gap: 10, alignItems: "start",
                     background: bg, border: `1px solid ${border}`, borderRadius: 6,
                     padding: "6px 26px 6px 10px", marginBottom: 4, opacity: empty ? 0.6 : 1,
                     fontSize: 12, lineHeight: 1.45, position: "relative" }}>
            {!empty && (
              <button onClick={e => { e.stopPropagation(); openLog(d.date); }}
                      title="View the change log for this day — every edit made here or in the cell dialogue is recorded."
                      style={{ position: "absolute", top: 3, right: 3, fontSize: 10, fontWeight: 700,
                               padding: "1px 7px", border: "1px solid #d1d5db", borderRadius: 4,
                               background: "#fff", color: "#374151", cursor: "pointer", fontFamily: "inherit" }}>
                Log
              </button>
            )}

            {/* 1 \u2014 DAY + PLANNED SESSION (read-only \u2014 v3.28: edit planned
                times in the four-week schedule editor, not here) */}
            <div style={sec}
                 title="The planned session for this day, from the four-week schedule pattern. Read-only here \u2014 change it in the schedule editor (staff name click / Configure scheduled hours).">
              <div style={{ fontWeight: 800, fontSize: 14, lineHeight: 1.2 }}>
                {WEEKDAYS[d.weekday]} {ord(d.day)}
                {savedFlash === d.date && <span style={{ fontSize: 11, color: "#15803d", marginLeft: 6 }}>{"\u2713"} saved</span>}
              </div>
              {planned ? (
                <>
                  <div style={{ fontSize: 13.5, fontWeight: 700, marginTop: 4, whiteSpace: "nowrap" }}>
                    {planned.start || "\u2014"} {"\u2013"} {planned.end || "\u2014"}
                  </div>
                  <div style={{ fontSize: 12, marginTop: 4, color: "#6b7280", whiteSpace: "nowrap" }}>
                    {planned.breakMins ? `${Math.round((planned.breakMins / 60) * 100) / 100}h break (${planned.breaksPaid ? "paid" : "unpaid"})` : "no break"}
                  </div>
                  {calc.contractedM > 0 && (
                    <div style={{ fontSize: 12, marginTop: 4, color: "#374151" }}>
                      Contracted <b>{hrs(calc.paidContractedM)}h</b>
                    </div>
                  )}
                </>
              ) : (
                <div style={{ fontSize: 12.5, color: "#9ca3af", marginTop: 4 }}>Not scheduled.</div>
              )}
            </div>

            {/* 2 \u2014 WHAT HAPPENED (v3.28): sessions one after another with
                their notes on the same line, small space, then break times,
                small space, then the two totals. */}
            <div style={{ ...sec, fontSize: 12, display: "flex", flexDirection: "column" }}>
              {!sessions.length && <span style={{ color: "#9ca3af", fontSize: 13 }}>No clockings recorded.</span>}
              {sessions.map((s, i) => (
                <div key={i} style={{ display: "flex", alignItems: "baseline", gap: 10, whiteSpace: "nowrap", minWidth: 0 }}>
                  <span style={{ fontSize: 14.5, fontWeight: 800, letterSpacing: 0.2 }}>
                    {hm(s.in) || "\u2014"} {"\u2013"} {s.out ? hm(s.out) : "still in"}
                  </span>
                  {(s.inNotes || s.outNotes) && (
                    <span style={{ color: "#92400e", fontSize: 12, overflow: "hidden", textOverflow: "ellipsis" }}
                          title={[s.inNotes, s.outNotes].filter(Boolean).join(" \u00b7 ")}>
                      {"\u270e"} {[s.inNotes, s.outNotes].filter(Boolean).join(" \u00b7 ")}
                    </span>
                  )}
                </div>
              ))}
              {breaks.length > 0 && (
                <div style={{ marginTop: 6 }}>
                  {breaks.map((b, i) => (
                    <div key={"b" + i} style={{ color: "#7c3aed" }}>
                      break {hm(b.start) || "?"}{"\u2013"}{b.end ? hm(b.end) : "\u2026"} ({b.mins || 0}m)
                    </div>
                  ))}
                </div>
              )}
              {sessions.length > 0 && (
                <div style={{ marginTop: 6, color: "#374151" }}>
                  <div>Total hours actually on site: <b>{hrs(calc.actualM)}h</b>{calc.stillIn ? " (open)" : ""}</div>
                  <div>Total breaks taken: <b>{hrs(breakTakenM)}h</b></div>
                </div>
              )}
              {/* v3.29: Validated chip lives at the foot of this panel — green
                  when clockings are in range and on the usual device, red when
                  one was too far away or the device id changed; the four
                  validation detail lines are in its hover text. */}
              {sessions.length > 0 && (() => {
                const distBad = (distIn != null && distIn > DIST_LIMIT_M) || (distOut != null && distOut > DIST_LIMIT_M);
                const devBad = !!c.deviceChangedIn || !!c.deviceChangedOut;
                const bad = distBad || devBad;
                const line = (lbl, v) => `${lbl}: ${v}`;
                const tip = [
                  line("Clock-in distance", distIn == null ? "not recorded" : `${distText(distIn)} away${distIn > DIST_LIMIT_M ? ` \u2717 (over ${DIST_LIMIT_M}m limit)` : " \u2713"}`),
                  line("Clock-out distance", distOut == null ? "not recorded" : `${distText(distOut)} away${distOut > DIST_LIMIT_M ? ` \u2717 (over ${DIST_LIMIT_M}m limit)` : " \u2713"}`),
                  line("Clock-in device", inDevice ? `${String(inDevice).slice(0, 8)}${c.deviceChangedIn ? ` \u2717 changed${c.prevInDevice ? ` (was ${String(c.prevInDevice).slice(0, 8)})` : ""}` : " \u2713 unchanged"}` : "not recorded"),
                  line("Clock-out device", outDevice ? `${String(outDevice).slice(0, 8)}${c.deviceChangedOut ? ` \u2717 changed${c.prevOutDevice ? ` (was ${String(c.prevOutDevice).slice(0, 8)})` : ""}` : " \u2713 unchanged"}` : "not recorded"),
                  "",
                  bad ? "RED: a clocking was made too far from the pharmacy or on a different device to the previous day."
                      : `Green: clockings within ${DIST_LIMIT_M}m of the pharmacy and made on the usual device.`
                ].join("\n");
                return (
                  <div style={{ marginTop: "auto", paddingTop: 8 }}>
                    <span title={tip}
                          style={{ fontSize: 11.5, fontWeight: 800, padding: "3px 9px", borderRadius: 5, whiteSpace: "nowrap", cursor: "default",
                                   background: bad ? "#fee2e2" : "#dcfce7", color: bad ? "#991b1b" : "#15803d",
                                   border: `1px solid ${bad ? "#fca5a5" : "#86efac"}` }}>
                      {bad ? "\u2717 Check" : "\u2713 Validated"}
                    </span>
                  </div>
                );
              })()}
            </div>

            {/* 4 \u2014 ANALYSIS (v3.28: lines spread with more vertical space) */}
            <div style={{ ...sec, display: "flex", flexDirection: "column", gap: 7, paddingTop: 2 }}>
              {sessions.length > 0 && (
                <div title="Hours on site (net of unpaid breaks) counted toward the day's contracted hours, capped at the contracted figure. Anything above spills into potential overtime below.">
                  Contracted hrs covered: <b>{hrs(Math.min(calc.netActualM, calc.paidContractedM > 0 ? calc.paidContractedM : calc.netActualM))}h</b>
                  {calc.paidContractedM > 0 ? <span style={{ color: "#6b7280" }}> of {hrs(calc.paidContractedM)}h</span> : null}
                </div>
              )}
              {sessions.length > 0 && (
                <div style={{ color: calc.potOtM > 12 ? "#1d4ed8" : "#6b7280", fontWeight: calc.potOtM > 12 ? 700 : 400 }}
                     title="Net hours on site above the day's contracted hours: the surplus once contracted hours are covered.">
                  Potential overtime: <b>{hrs(calc.potOtM)}h</b>
                </div>
              )}
              {issues.length > 0 && <div style={{ color: "#b45309" }}>{"\u26a0"} {issues.join("; ")}</div>}
              {/* v3.30: auto-review is shown only when it applies — a green
                  label instead of the always-present (disabled) checkbox.
                  The underlying autoConf logic is unchanged. */}
              {calc.autoConf && (
                <div style={{ color: "#15803d", fontWeight: 700, whiteSpace: "nowrap" }}
                     title="Set automatically when the day is clean and complete: on time, in range, fully clocked out, no notes, no significant overtime.">
                  ✓ Entry automatically reviewed
                </div>
              )}
            </div>

            {/* 5 \u2014 REVIEW */}
            <div style={{ minWidth: 0, display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ flex: "0 0 auto" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}
                   title="This is the number of hours that will be finally submitted to payroll. It is automatically set to the number of hours worked up to the daily contracted number of hours. It can be edited as required. All changes are logged.">
                <span style={{ color: "#374151", width: 148 }}>Cont. hrs submitted</span>
                <input type="number" min="0" step="0.25" disabled={empty}
                  value={draft.pstd !== undefined ? draft.pstd
                    : (c.payrollHours != null ? String(c.payrollHours)
                      : hrs(Math.min(calc.netActualM, calc.paidContractedM > 0 ? calc.paidContractedM : calc.netActualM)))}
                  onChange={e => setDraft("pstd", e.target.value)}
                  onBlur={() => {
                    if (draft.pstd === undefined) return;
                    const v = Math.max(0, Math.round(Number(draft.pstd || 0) * 100) / 100);
                    clearDraft("pstd");
                    if (c.payrollHours != null && v === c.payrollHours) return;
                    persist(d.date, { payrollHours: v }, [`Payroll standard hours set to ${v.toFixed(2)} (staff dialogue)`]);
                  }}
                  style={{ ...tinyInp, width: 56 }} /> h
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap", marginTop: 3 }}
                   title="This is the number of hours that will be finally submitted for overtime for this day. It is automatically set at any surplus time the employee has worked. It can be edited and all changes will be logged. Any entry here will only appear in the final timesheet if marked as 'approved'.">
                <span style={{ color: "#374151", width: 148 }}>O/time submitted</span>
                <input type="number" min="0" step="0.25" disabled={empty}
                  value={draft.pot !== undefined ? draft.pot
                    : (c.payrollOtHours != null ? String(c.payrollOtHours) : hrs(calc.potOtM))}
                  onChange={e => setDraft("pot", e.target.value)}
                  onBlur={() => {
                    if (draft.pot === undefined) return;
                    const v = Math.max(0, Math.round(Number(draft.pot || 0) * 100) / 100);
                    clearDraft("pot");
                    if (c.payrollOtHours != null && v === c.payrollOtHours) return;
                    persist(d.date, { payrollOtHours: v }, [`Payroll overtime hours set to ${v.toFixed(2)} (staff dialogue)`]);
                  }}
                  style={{ ...tinyInp, width: 56 }} /> h
                {(() => {
                  const otBoxVal = Number(draft.pot !== undefined ? draft.pot
                    : (c.payrollOtHours != null ? c.payrollOtHours : hrs(calc.potOtM))) || 0;
                  const otEnabled = calc.potOtM > 12 || otBoxVal > 0;
                  return (
                    <label style={{ display: "flex", alignItems: "center", gap: 4, marginLeft: 8,
                                    cursor: otEnabled ? "pointer" : "default",
                                    color: otEnabled ? "#1d4ed8" : "#9ca3af", fontWeight: otEnabled ? 700 : 400 }}>
                      <input type="checkbox" checked={!!c.overtimeApproved} disabled={!otEnabled}
                        onChange={e => approveOt(d.date, e.target.checked)} />
                      Approved
                    </label>
                  );
                })()}
              </div>
              </div>
              <textarea value={notesVal} rows={3} placeholder={"Manager notes\u2026"} disabled={empty}
                onChange={e => setDraft("notes", e.target.value)} onBlur={saveNotes}
                style={{ ...tinyInp, flex: "0 0 132px", width: 132, height: 54, resize: "none",
                         boxSizing: "border-box", padding: "3px 6px", background: "#fff", fontFamily: "inherit" }} />
              <label style={{ display: "flex", alignItems: "center", gap: 5, whiteSpace: "nowrap", flex: "0 0 auto",
                              cursor: empty ? "default" : "pointer",
                              fontWeight: 700, color: c.eventReviewed ? "#15803d" : "#374151" }}
                     title="When entries have been adjusted, and any discrepancies such as distance from QR code when scanned accepted, checking this box will mark this entry as being completed and ready for submission."
                     onDoubleClick={e => e.stopPropagation()}>
                <input type="checkbox" checked={!!c.eventReviewed} disabled={empty}
                  onChange={e => persist(d.date, { eventReviewed: e.target.checked }, [`Review ${e.target.checked ? "marked complete" : "re-opened"} (staff dialogue)`])} />
                Review complete
              </label>
            </div>
          </div>
        );
      })}
      {logFor && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9590 }}
             onClick={() => setLogFor(null)}>
          <div style={{ background: "#fff", borderRadius: 8, width: "min(560px, 92vw)", maxHeight: "80vh", overflowY: "auto", padding: 16 }}
               onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <div style={{ fontWeight: 800 }}>Change log {"\u2014"} {staffName}, {dmy(logFor.date)}</div>
              <button style={S.btn("#6b7280")} onClick={() => setLogFor(null)}>Close</button>
            </div>
            {logRows === null && <div style={{ fontSize: 13, color: "#6b7280" }}>Loading{"\u2026"}</div>}
            {logRows !== null && !logRows.length && <div style={{ fontSize: 13, color: "#6b7280" }}>No changes recorded yet for this day.</div>}
            {(logRows || []).map((l, i) => (
              <div key={i} style={{ borderBottom: "1px solid #f1f5f9", padding: "6px 0", fontSize: 12.5 }}>
                <div style={{ color: "#6b7280", fontSize: 11.5 }}>
                  {l.at ? new Date(l.at).toLocaleString("en-GB") : ""}{l.by ? ` \u2014 ${l.by}` : ""}
                </div>
                <div>{l.msg}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function CellDialog({ dbName, entry, onLocalPatch, onReload, onClose, roleName }) {
  const [dlgErr, setDlgErr] = useState(null);
  const [start, setStart] = useState(entry.planned?.start || "");
  const [end, setEnd] = useState(entry.planned?.end || "");
  const [breakH, setBreakH] = useState(entry.planned?.breakMins ? String(Math.round((entry.planned.breakMins / 60) * 100) / 100) : "0");
  const [breaksPaid, setBreaksPaid] = useState(entry.planned?.breaksPaid === true);
  const [timesDirty, setTimesDirty] = useState(false);
  const [timesMsg, setTimesMsg] = useState(null);
  const [busy, setBusy] = useState(false);
  const [noteDraft, setNoteDraft] = useState(entry.reviewNotes || "");
  const [logOpen, setLogOpen] = useState(false);
  const [paidHelp, setPaidHelp] = useState(false);
  const [paidHelpPinned, setPaidHelpPinned] = useState(false);
  const [logRows, setLogRows] = useState(null);

  // ---------- clock in/out + break drafts ----------
  // Declared BEFORE the derived figures below so that "Total hours on site",
  // "Total break time taken" and the summary can be computed from the times
  // currently shown in the panel. Reading entry.sessions/entry.breaks instead
  // left those totals stale until the dialog was closed and reopened.
  const minsOfHHMM = (hhmm) => { const m = /^(\d{2}):(\d{2})$/.exec(hhmm || ""); return m ? Number(m[1]) * 60 + Number(m[2]) : null; };
  const [sessDrafts, setSessDrafts] = useState(() =>
    (entry.sessions || []).map(x => ({ in: x.in ? hm(x.in) : "", out: x.out ? hm(x.out) : "" })));
  const [breakDrafts, setBreakDrafts] = useState(() =>
    (entry.breaks || []).map(b => ({ start: b.start ? hm(b.start) : "", end: b.end ? hm(b.end) : "" })));

  // ---------- derived figures ----------
  const sessions = entry.sessions || [];
  const contractedM = (start && end) ? (() => {
    const [sh, sm] = start.split(":").map(Number), [eh, em] = end.split(":").map(Number);
    return Math.max(0, (eh * 60 + (em || 0)) - (sh * 60 + (sm || 0)));
  })() : 0;
  // Live totals: computed from the DRAFT times on screen, so they refresh the
  // instant a clocking changes (manual edit, double-click, or Set as
  // scheduled) rather than waiting for the entry to be reloaded. A session or
  // break whose end is before its start is treated as running past midnight.
  const spanM = (a, b) => {
    const x = minsOfHHMM(a), y = minsOfHHMM(b);
    if (x == null || y == null) return 0;
    return y >= x ? y - x : y + 1440 - x;
  };
  let actualM = 0;
  for (const d of sessDrafts) if (d.in && d.out) actualM += spanM(d.in, d.out);
  const stillIn = sessDrafts.some(d => d.in && !d.out);
  const breakTakenM = breakDrafts.reduce((t, b) => t + spanM(b.start, b.end), 0);
  const hFmt = (mins) => `${Math.floor(mins / 60)}h ${Math.round(mins % 60)}m`;
  const hDec = (mins) => (Math.round((mins / 60) * 100) / 100).toFixed(2);
  // Paid contracted hours: hours on site minus the break entitlement — but
  // the break is only deducted when it is UNPAID.
  const breakEntM = Math.round(Number(breakH || 0) * 60);
  const paidContractedM = contractedM > 0 ? Math.max(0, contractedM - (breaksPaid ? 0 : breakEntM)) : 0;
  // Payroll default: hours on site LESS the unpaid break, capped at the day's
  // paid contracted hours; any surplus is the potential overtime (exposed
  // above 0.2h). The unpaid deduction is the GREATER of the break actually
  // taken and the entitlement — the contracted side has already been reduced
  // by the full entitlement, so deducting less here would pay for break time
  // that was never earned and would read as overtime. Mirrors dayCalc.
  const unpaidBreakM = breaksPaid ? 0 : Math.max(breakTakenM, breakEntM);
  const netActualM = Math.max(0, actualM - unpaidBreakM);
  const payrollAutoM = Math.min(netActualM, paidContractedM > 0 ? paidContractedM : netActualM);
  const potOtM = Math.max(0, netActualM - (paidContractedM > 0 ? paidContractedM : netActualM));
  // ✓/✗ against the two figures actually shown on the line ("X of Y"), not
  // the raw on-site vs raw contracted pair.
  const covered = netActualM + 0.5 >= paidContractedM;
  // Both sides of the Paid? toggle, computed from THIS day's real figures —
  // drives the explainer that hovers over the checkbox, so the manager sees
  // the actual consequence rather than a general description.
  const paidScenario = (paid) => {
    const pc = contractedM > 0 ? Math.max(0, contractedM - (paid ? 0 : breakEntM)) : 0;
    const deduct = paid ? 0 : Math.max(breakTakenM, breakEntM);
    const net = Math.max(0, actualM - deduct);
    const pay = Math.min(net, pc > 0 ? pc : net);
    const ot = Math.max(0, net - (pc > 0 ? pc : net));
    return { pc, deduct, net, pay, ot };
  };
  const showOt = potOtM > 12; // 0.2h
  const issues = cellIssues(entry.date, (start || end) ? { start, end } : null, sessions);
  const deviceChanged = !!(entry.deviceChangedIn || entry.deviceChangedOut);
  const isAuto = autoConfirmed(entry.date, (start || end) ? { start, end } : null, sessions, potOtM, deviceChanged);
  // Devices used for this day's clockings (unique, in order of use).
  const inDevices = [...new Set(sessions.map(s => s.inDevice).filter(Boolean))];
  const outDevices = [...new Set(sessions.map(s => s.outDevice).filter(Boolean))];
  const payrollDefault = hDec(payrollAutoM);
  const otDefault = hDec(potOtM);
  const storedPayroll = entry.payrollHours != null ? Number(entry.payrollHours).toFixed(2) : null;
  const storedOt = entry.payrollOtHours != null ? Number(entry.payrollOtHours).toFixed(2) : null;
  const [payroll, setPayroll] = useState(storedPayroll != null ? storedPayroll : payrollDefault);
  // A figure the SYSTEM produced — nothing stored, or a stored value equal to
  // the calculated default — keeps tracking the calculation when the inputs
  // change (paid/unpaid toggle, break entitlement, a clock edit). Only a
  // figure that differs from the calculation is treated as a manager's own
  // number and pinned. Previously `payrollTouched` was set by the mere
  // EXISTENCE of a stored value, and saveClockEdits stores one on every clock
  // edit — so after one edit the box stopped following anything.
  const [payrollTouched, setPayrollTouched] = useState(storedPayroll != null && storedPayroll !== payrollDefault);
  const prevPayrollDefault = useRef(payrollDefault);
  useEffect(() => {
    if (prevPayrollDefault.current === payrollDefault) return;
    const wasFollowing = payroll === prevPayrollDefault.current;
    prevPayrollDefault.current = payrollDefault;
    if (!payrollTouched || wasFollowing) { setPayroll(payrollDefault); setPayrollTouched(false); }
  }, [payrollDefault, payroll, payrollTouched]);
  const [otPayroll, setOtPayroll] = useState(storedOt != null ? storedOt : otDefault);
  const [otTouched, setOtTouched] = useState(storedOt != null && storedOt !== otDefault);
  const prevOtDefault = useRef(otDefault);
  useEffect(() => {
    if (prevOtDefault.current === otDefault) return;
    const wasFollowing = otPayroll === prevOtDefault.current;
    prevOtDefault.current = otDefault;
    if (!otTouched || wasFollowing) { setOtPayroll(otDefault); setOtTouched(false); }
  }, [otDefault, otPayroll, otTouched]);
  const saveOtPayroll = () => {
    const v = Math.max(0, Math.round(Number(otPayroll || 0) * 100) / 100);
    setOtPayroll(v.toFixed(2));
    if (entry.payrollOtHours != null ? v === entry.payrollOtHours : v.toFixed(2) === otDefault) { setOtTouched(entry.payrollOtHours != null); return; }
    onLocalPatch({ payrollOtHours: v });
    review({ payrollOtHours: v }, [`Payroll overtime hours set to ${v.toFixed(2)} (potential ${otDefault})`]);
  };

  // ---------- persistence ----------
  const review = async (patch, logMsgs) => {
    try {
      await post("/api/headoffice/clock/event/review",
        { dbName, staffId: entry.staffId, date: entry.date, ...patch, log: logMsgs || [] });
    } catch (e) { setDlgErr(`Save failed: ${e.message}`); await onReload(); }
  };
  const setReviewComplete = (approved) => {
    onLocalPatch({ eventReviewed: approved, reviewNotes: noteDraft });
    review({ approved, notes: noteDraft }, [`Review ${approved ? "marked complete" : "re-opened"}`]);
  };
  const saveNotes = () => {
    if (noteDraft === (entry.reviewNotes || "")) return;
    onLocalPatch({ reviewNotes: noteDraft });
    review({ notes: noteDraft, approved: !!entry.eventReviewed }, ["Manager notes updated"]);
  };
  const savePayroll = (raw) => {
    const v = Math.max(0, Math.round(Number((raw != null ? raw : payroll) || 0) * 100) / 100);
    const vs = v.toFixed(2);
    setPayroll(vs);
    // "Touched" now means "differs from the calculation", so a figure that
    // matches the calculation resumes following it.
    setPayrollTouched(vs !== payrollDefault);
    prevPayrollDefault.current = payrollDefault;
    if (entry.payrollHours != null ? v === Number(entry.payrollHours) : vs === payrollDefault) return;
    onLocalPatch({ payrollHours: v });
    review({ payrollHours: v }, [`Hours to go on payroll sheet changed to ${vs} (calculated ${payrollDefault})`]);
  };
  const acceptOvertime = (approved) => {
    onLocalPatch({ overtimeApproved: approved });
    (async () => {
      try {
        await post("/api/headoffice/clock/overtime/approve", { dbName, staffId: entry.staffId, date: entry.date, approved });
        await review({}, [`Overtime of ${hDec(potOtM)}h ${approved ? "accepted" : "un-accepted"}`]);
      } catch (e) { setDlgErr(`Overtime save failed: ${e.message}`); await onReload(); }
    })();
  };
  const saveWeekday = async () => {
    setBusy(true); setDlgErr(null);
    const occ = occurrenceOfDate(entry.date);
    const occLabel = `${WEEK_ORD[occ - 1]} ${WEEKDAYS[entry.weekday]}`;
    try {
      await post("/api/headoffice/clock/times/set", {
        dbName, staffId: entry.staffId, weekday: entry.weekday,
        occurrences: occ === 1 ? [1, 5] : [occ], start: start || null, end: end || null,
        breakMins: Math.round(Number(breakH || 0) * 60), breaksPaid
      });
      await review({}, [`Contracted times saved to ${entry.staffName} for every ${occLabel} of the month: ${start || "—"}–${end || "—"}, break ${Number(breakH || 0)}h ${breaksPaid ? "paid" : "unpaid"} (manual)`]);
      setTimesMsg(`✔ Saved to ${entry.staffName} for every ${occLabel} of the month`); setTimesDirty(false);
      await onReload();
    } catch (e) { setDlgErr(e.message); } finally { setBusy(false); }
  };
  // v3.27: the two bulk "Copy to all days ..." buttons (and their copyTimes
  // handler) are removed from this dialog — it edits only this one day's
  // slot in the pattern. Bulk changes belong in the four-week schedule
  // editor (staff-name click / Configure scheduled hours).
  const openLog = async () => {
    setLogOpen(true); setLogRows(null);
    try {
      // '/history' not '/log' — IIS security filtering 403s '/log' URLs
      // before they reach the backend (plain-text Forbidden).
      const d = await post("/api/headoffice/clock/review/history", { dbName, staffId: entry.staffId, date: entry.date });
      setLogRows(d.log || []);
    } catch (e) { setLogRows([{ at: null, msg: `Could not load log: ${e.message}` }]); }
  };

  // ---------- clock in/out + breaks editing (v3.36) ----------
  // Session and break times are editable; "Set as scheduled" fills them from
  // the day's contracted pattern. Every change is written via
  // /clock/sessions/set and logged line-by-line through the review audit
  // log; once a day has been adjusted the sessions panel shows AMBER
  // (entry.clockManuallyEdited from the server, or immediately after a save).
  // (sessDrafts / breakDrafts are declared above the derived figures.)
  const [clockDirty, setClockDirty] = useState(false);
  const [clockBusy, setClockBusy] = useState(false);
  const [clockEdited, setClockEdited] = useState(!!entry.clockManuallyEdited);

  const origSess = (entry.sessions || []).map(x => ({ in: x.in ? hm(x.in) : "", out: x.out ? hm(x.out) : "" }));
  const origBreaks = (entry.breaks || []).map(b => ({ start: b.start ? hm(b.start) : "", end: b.end ? hm(b.end) : "" }));

  const clockDiffLines = (sess, brks, viaScheduled) => {
    const lines = [];
    sess.forEach((d, i) => {
      const o = origSess[i] || { in: "", out: "" };
      if ((d.in || "") !== (o.in || "")) lines.push(`Clock in (session ${i + 1}) changed ${o.in || "—"} \u2192 ${d.in || "—"}${viaScheduled ? " (Set as scheduled)" : " (manual)"}`);
      if ((d.out || "") !== (o.out || "")) lines.push(`Clock out (session ${i + 1}) changed ${o.out || "—"} \u2192 ${d.out || "—"}${viaScheduled ? " (Set as scheduled)" : " (manual)"}`);
    });
    brks.forEach((d, i) => {
      const o = origBreaks[i];
      if (!o) { if (d.start && d.end) lines.push(`Break added ${d.start}\u2013${d.end}${viaScheduled ? " (Set as scheduled)" : " (manual)"}`); return; }
      if ((d.start || "") !== (o.start || "") || (d.end || "") !== (o.end || ""))
        lines.push(`Break changed ${o.start || "?"}\u2013${o.end || "?"} \u2192 ${d.start || "?"}\u2013${d.end || "?"}${viaScheduled ? " (Set as scheduled)" : " (manual)"}`);
    });
    for (let i = brks.length; i < origBreaks.length; i++) {
      lines.push(`Break removed (was ${origBreaks[i].start || "?"}\u2013${origBreaks[i].end || "?"})${viaScheduled ? " (Set as scheduled)" : " (manual)"}`);
    }
    return lines;
  };
  const saveClockEdits = async (sess, brks, viaScheduled) => {
    const lines = clockDiffLines(sess, brks, viaScheduled);
    if (!lines.length) { setClockDirty(false); return; }
    setClockBusy(true); setDlgErr(null);
    try {
      await post("/api/headoffice/clock/sessions/set", {
        dbName, staffId: entry.staffId, date: entry.date,
        sessions: sess.map(d => ({ in: d.in || null, out: d.out || null })),
        breaks: brks.filter(d => d.start && d.end),
        setAsScheduled: !!viaScheduled
      });
      // Recalculate the payroll figures from the ADJUSTED clockings and
      // store them alongside the clock edit — so "Cont. hrs submitted" and
      // "O/time submitted" always reflect the times now shown, and the
      // recalculation itself is in the log.
      const synth = {
        planned: (start && end)
          ? { start, end, breakMins: Math.round(Number(breakH || 0) * 60), breaksPaid }
          : entry.planned,
        sessions: sess.filter(d => d.in && d.out)
          .map(d => ({ in: `${entry.date}T${d.in}:00`, out: `${entry.date}T${d.out}:00` })),
        breaks: brks.filter(d => d.start && d.end)
          .map(d => ({ mins: spanM(d.start, d.end) }))
      };
      const k2 = dayCalc(entry.date, synth);
      const newPayrollH = h1(Math.min(k2.netActualM, k2.paidContractedM > 0 ? k2.paidContractedM : k2.netActualM));
      const newOtH = h1(k2.potOtM);
      setPayroll(newPayrollH.toFixed(2)); setPayrollTouched(true);
      setOtPayroll(newOtH.toFixed(2)); setOtTouched(true);
      // Set-as-scheduled (button or double-click): if the inserted times now
      // fully cover the day's contracted hours — every session complete and
      // net on-site >= paid contracted — the day is coherent, so tick
      // "Review complete" as well (logged like any other review change).
      const allComplete = sess.every(d => (d.in && d.out) || (!d.in && !d.out));
      const nowCovered = viaScheduled && allComplete
        && k2.paidContractedM > 0 && k2.netActualM >= k2.paidContractedM;
      const patch = { payrollHours: newPayrollH, payrollOtHours: newOtH };
      // Preserve the ORIGINAL clock-in/out notes of any overridden session in
      // the log, so the staff member's context survives the override and is
      // available for review. (The note fields on the attendance documents
      // themselves are never modified by the edit endpoint.)
      const noteLines = [];
      (entry.sessions || []).forEach((s0, i) => {
        const o = origSess[i] || {}, d = sess[i] || {};
        const touched = viaScheduled
          || (d.in || "") !== (o.in || "") || (d.out || "") !== (o.out || "");
        if (!touched) return;
        if (s0.inNotes) noteLines.push(
          `Original clock-in note preserved (session ${i + 1}, was ${o.in || "?"}): "${String(s0.inNotes).slice(0, 200)}"`);
        if (s0.outNotes) noteLines.push(
          `Original clock-out note preserved (session ${i + 1}, was ${o.out || "?"}): "${String(s0.outNotes).slice(0, 200)}"`);
      });
      const logLines = [
        ...lines,
        ...noteLines,
        `Cont. hrs submitted recalculated to ${newPayrollH.toFixed(2)}h and o/time to ${newOtH.toFixed(2)}h from the adjusted clockings`
      ];
      if (nowCovered && !entry.eventReviewed) {
        patch.approved = true;
        logLines.push("Review marked complete \u2014 scheduled hours inserted and contracted hours fully covered");
      }
      onLocalPatch({ payrollHours: newPayrollH, payrollOtHours: newOtH,
                     ...(nowCovered ? { eventReviewed: true } : {}) });
      await review(patch, logLines.slice(0, 20));
      setClockEdited(true); setClockDirty(false);
      await onReload();
    } catch (e) { setDlgErr(`Clocking save failed: ${e.message}`); }
    finally { setClockBusy(false); }
  };
  // Punctuality vs the scheduled session: "arrived late" compares the FIRST
  // session's In to the contracted start; "left early" / "left late" compare
  // the LAST session's Out to the contracted finish. Tags follow the DRAFT
  // values so they update live while editing. (minsOfHHMM is defined above.)
  const punctualityIn = (hhmm, isFirst) => {
    if (!isFirst || !start) return null;
    const a = minsOfHHMM(hhmm), b = minsOfHHMM(start);
    if (a == null || b == null) return null;
    if (a > b) return { text: `arrived late (${a - b}m)`, color: "#dc2626" };
    return null;
  };
  const punctualityOut = (hhmm, isLast) => {
    if (!isLast || !end) return null;
    const a = minsOfHHMM(hhmm), b = minsOfHHMM(end);
    if (a == null || b == null) return null;
    if (a < b) return { text: `left early (${b - a}m)`, color: "#dc2626" };
    if (a > b) return { text: `left late (${a - b}m)`, color: "#b45309" };
    return null;
  };
  // Double-click an In/Out cell: set THAT field to the scheduled time and
  // save straight away — logged like any other edit, panel goes amber with
  // the Contents-altered badge.
  const dblClickToScheduled = (i, field) => {
    if (clockBusy || busy) return;
    const sched = field === "in" ? start : end;
    if (!sched) { setDlgErr("No contracted times recorded for this day \u2014 set them in the panel on the left first."); return; }
    const sess = sessDrafts.map((x, j) => j === i ? { ...x, [field]: sched } : { ...x });
    setSessDrafts(sess);
    saveClockEdits(sess, breakDrafts, true);
  };

  const setAsScheduled = () => {
    if (!start || !end) { setDlgErr("No contracted times recorded for this day \u2014 set them in the panel on the left first."); return; }
    if (!window.confirm(`Set this day's clock in/out to the scheduled times ${start}\u2013${end}${Number(breakH || 0) > 0 ? ` with a ${breakH}h break` : ""}? The change is recorded in the log.`)) return;
    const sess = [{ in: start, out: end }];
    let brks = [];
    const bMins = Math.round(Number(breakH || 0) * 60);
    if (bMins > 0) {
      // Scheduled break placed at the shift midpoint.
      const [sh, sm] = start.split(":").map(Number), [eh, em] = end.split(":").map(Number);
      const midM = Math.round(((sh * 60 + (sm || 0)) + (eh * 60 + (em || 0))) / 2 - bMins / 2);
      const hh = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
      brks = [{ start: hh(midM), end: hh(midM + bMins) }];
    }
    setSessDrafts(sess); setBreakDrafts(brks);
    saveClockEdits(sess, brks, true);
  };

  // ---------- panels ----------
  const P = { border: "1px solid #e5e7eb", borderRadius: 8, padding: "12px 14px", background: "#fafafa", minWidth: 0 };
  const H = { fontSize: 11, fontWeight: 800, letterSpacing: 0.5, color: "#6b7280", textTransform: "uppercase", marginBottom: 8 };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9500 }}>
      <div style={{ background: "#fff", borderRadius: 8, width: "min(1560px, 98vw)", maxHeight: "96vh", overflowY: "auto", padding: 18 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10 }}>
          <div style={{ fontWeight: 800, fontSize: 15 }}>{entry.staffName} — {dmy(entry.date)} ({WEEKDAYS[entry.weekday]})</div>
          <div style={{ display: "flex", gap: 8 }}>
            <button style={S.btn("#374151")} onClick={openLog}
              title="Opens the change log for this day — every edit to hours, submitted figures, overtime approval, notes and review status is recorded here.">
              View log
            </button>
            <button style={S.btn("#6b7280")} onClick={onClose}>Close</button>
          </div>
        </div>
        {dlgErr && <div style={{ color: "#dc2626", fontSize: 12.5, marginBottom: 8 }}>{dlgErr}</div>}

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 12 }}>

          {/* ---------------- 1. STAFF & CONTRACTED ---------------- */}
          <div style={P}>
            <div style={H}>Staff & contracted hours</div>
            <div style={{ fontSize: 14, fontWeight: 700 }}>{entry.staffName}</div>
            <div style={{ fontSize: 12.5, color: "#6b7280", marginBottom: 10 }}>{roleName || entry.roleName || "—"}</div>
            {(() => {
              const WD_LONG = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
              const slot = `${WEEK_ORD[occurrenceOfDate(entry.date) - 1]} ${WD_LONG[entry.weekday]}`;
              return (
                <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 6, padding: "7px 10px",
                              fontSize: 12, color: "#92400e", lineHeight: 1.45, marginBottom: 12 }}
                     title={`This day is the ${slot} of the month. Contracted hours are stored as a four-week pattern that every month repeats, so changes here update that slot in the pattern — every ${slot} — not just ${dmy(entry.date)}. To change other days, open the schedule editor by clicking the staff member's name on the grid.`}>
                  ⓘ Adjusting the times or break here changes this day's slot in the four-week pattern —
                  it will apply to <b>every {slot} of each month</b>, not just {dmy(entry.date)}.
                </div>
              );
            })()}
            <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap" }}>
              <div><div style={S.lab}>Contracted start</div>
                <input type="time" style={S.inp} value={start}
                  title={`Applies to every ${WEEK_ORD[occurrenceOfDate(entry.date) - 1]} ${WEEKDAYS[entry.weekday]} of each month.`}
                  onChange={e => { setStart(e.target.value); setTimesDirty(true); setTimesMsg(null); }} /></div>
              <div><div style={S.lab}>Contracted finish</div>
                <input type="time" style={S.inp} value={end}
                  title={`Applies to every ${WEEK_ORD[occurrenceOfDate(entry.date) - 1]} ${WEEKDAYS[entry.weekday]} of each month.`}
                  onChange={e => { setEnd(e.target.value); setTimesDirty(true); setTimesMsg(null); }} /></div>
            </div>
            <div style={{ marginTop: 12, fontSize: 13 }}>
              Hours to be on site: <b>{contractedM > 0 ? `${hFmt(contractedM)} (${hDec(contractedM)}h)` : "—"}</b>
            </div>
            <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap", marginTop: 10 }}>
              <div><div style={S.lab}>Break entitlement (hrs)</div>
                <input type="number" min="0" step="0.25" value={breakH}
                  title={`Applies to every ${WEEK_ORD[occurrenceOfDate(entry.date) - 1]} ${WEEKDAYS[entry.weekday]} of each month.`}
                  onChange={e => { setBreakH(e.target.value); setTimesDirty(true); setTimesMsg(null); }}
                  style={{ ...S.inp, width: 78 }} /></div>
              <div style={{ position: "relative", paddingBottom: 7 }}
                   onMouseEnter={() => setPaidHelp(true)} onMouseLeave={() => setPaidHelp(false)}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
                    <input type="checkbox" checked={breaksPaid}
                      onChange={e => { setBreaksPaid(e.target.checked); setTimesDirty(true); setTimesMsg(null); }} />
                    Paid?
                  </label>
                  {/* Outside the <label> — inside it, a click would toggle the
                      checkbox. Click pins the explainer open so it can be read
                      and scrolled without holding the pointer still. */}
                  <span role="button" tabIndex={0}
                    onClick={() => setPaidHelpPinned(v => !v)}
                    onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setPaidHelpPinned(v => !v); } }}
                    title="What does Paid? do? (click to keep open)"
                    style={{ fontSize: 10.5, fontWeight: 800, color: paidHelpPinned ? "#fff" : "#6b7280",
                             background: paidHelpPinned ? "#0f766e" : "transparent",
                             border: `1px solid ${paidHelpPinned ? "#0f766e" : "#cbd5e1"}`,
                             borderRadius: 9, width: 15, height: 15, lineHeight: "14px", textAlign: "center",
                             display: "inline-block", cursor: "pointer", userSelect: "none" }}>i</span>
                </div>
                {(paidHelp || paidHelpPinned) && (() => {
                  const A = paidScenario(true), B = paidScenario(false);
                  // FIXED and centred on the viewport: the dialog scrolls its
                  // own overflow, so anything anchored to the checkbox gets
                  // clipped at whichever edge it grows toward. Fixed escapes
                  // that entirely (no transformed ancestor here), and centring
                  // means it never depends on where the checkbox happens to sit.
                  const box = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                                width: "min(460px, 92vw)", maxHeight: "80vh", overflowY: "auto", zIndex: 9700,
                                background: "#fff", border: "1px solid #cbd5e1", borderRadius: 10,
                                boxShadow: "0 18px 48px rgba(0,0,0,0.30)", padding: "14px 16px",
                                fontSize: 12.5, color: "#374151", whiteSpace: "normal", cursor: "default" };
                  const tdL = { padding: "3px 6px 3px 0", color: "#6b7280" };
                  const tdN = { padding: "3px 6px", textAlign: "center", fontVariantNumeric: "tabular-nums" };
                  const on = { background: "#ecfdf5", fontWeight: 800, color: "#065f46" };
                  const off = { color: "#6b7280" };
                  const row = (label, a, b, bold) => (
                    <tr>
                      <td style={tdL}>{label}</td>
                      <td style={{ ...tdN, ...(breaksPaid ? on : off), fontWeight: bold ? 800 : undefined }}>{a}</td>
                      <td style={{ ...tdN, ...(!breaksPaid ? on : off), fontWeight: bold ? 800 : undefined }}>{b}</td>
                    </tr>
                  );
                  return (
                    <>
                      {paidHelpPinned && (
                        <div style={{ position: "fixed", inset: 0, zIndex: 9690, background: "rgba(0,0,0,0.15)" }}
                             onClick={() => setPaidHelpPinned(false)} />
                      )}
                    <div style={box}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 6 }}>
                        <div style={{ fontWeight: 800, fontSize: 13.5 }}>What the Paid? tick does</div>
                        {paidHelpPinned && (
                          <button type="button" style={{ ...S.btn("#6b7280"), padding: "2px 9px", fontSize: 11.5 }}
                            onClick={() => setPaidHelpPinned(false)}>Close</button>
                        )}
                      </div>
                      <div style={{ color: "#6b7280", marginBottom: 6 }}>
                        This day: <b>{hDec(actualM)}h</b> on site, <b>{hDec(breakTakenM)}h</b> break taken,
                        entitlement <b>{hDec(breakEntM)}h</b>, contracted <b>{hDec(contractedM)}h</b>.
                      </div>
                      <table style={{ borderCollapse: "collapse", width: "100%", marginBottom: 6 }}>
                        <thead>
                          <tr style={{ fontSize: 11, color: "#6b7280" }}>
                            <th style={{ ...tdL, textAlign: "left" }} />
                            <th style={tdN}>Paid ✓</th>
                            <th style={tdN}>Unpaid</th>
                          </tr>
                        </thead>
                        <tbody>
                          {row("Paid contracted hours", `${hDec(A.pc)}h`, `${hDec(B.pc)}h`)}
                          {row("Deducted from time on site", `${hDec(A.deduct)}h`, `${hDec(B.deduct)}h`)}
                          {row("Counts toward contracted", `${hDec(A.pay)}h`, `${hDec(B.pay)}h`, true)}
                          {row("Overtime", `${hDec(A.ot)}h`, `${hDec(B.ot)}h`, true)}
                        </tbody>
                      </table>
                      <div style={{ marginBottom: 4 }}>
                        <b>Ticked (paid):</b> the break sits inside the paid shift — the full {hDec(contractedM)}h is
                        payable and the break costs nothing. A break that pushes the clock-out earlier still
                        shortens time on site.
                      </div>
                      <div style={{ marginBottom: 4 }}>
                        <b>Unticked (unpaid):</b> contracted hours drop by the {hDec(breakEntM)}h entitlement, and
                        that same {hDec(breakEntM)}h is the <i>minimum</i> taken off time on site. A shorter break
                        earns nothing extra; a longer one is deducted in full.
                      </div>
                      <div style={{ color: "#6b7280", fontSize: 11.5 }}>
                        {(() => {
                          const dA = A.net - A.pc, dB = B.net - B.pc;
                          const say = (d) => d >= -0.5 && d <= 0.5 ? "exactly covered"
                            : (d > 0 ? `${hDec(d)}h over` : `${hDec(-d)}h short`);
                          return Math.abs(dA - dB) <= 0.5
                            ? <>The tick changes the size of the figures, not whether the day is over or under —
                               this day is <b>{say(dA)}</b> either way.</>
                            : <>Paid: <b>{say(dA)}</b> · Unpaid: <b>{say(dB)}</b> — the extra{" "}
                               <b>{hDec(breakTakenM - breakEntM)}h</b> of break taken beyond the entitlement is
                               unpaid, so it only costs when the break is unpaid.</>;
                        })()}
                        {" "}Applies to every {WEEK_ORD[occurrenceOfDate(entry.date) - 1]}{" "}
                        {WEEKDAYS[entry.weekday]} of the month once saved.
                      </div>
                    </div>
                    </>
                  );
                })()}
              </div>
            </div>
            <div style={{ marginTop: 10, fontSize: 13 }}>
              Paid contracted hours today: <b>{contractedM > 0 ? `${hFmt(paidContractedM)} (${hDec(paidContractedM)}h)` : "—"}</b>
              {contractedM > 0 && breakEntM > 0 && (
                <span style={{ color: "#6b7280", fontSize: 12 }}> {breaksPaid ? "(breaks paid — nothing deducted)" : "(hours on site minus unpaid break)"}</span>
              )}
            </div>
            {timesDirty && (
              <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 12 }}>
                <button style={{ ...S.btn("#fff"), background: "#0f766e", color: "#fff", border: "none" }} disabled={busy} onClick={saveWeekday}
                  title="Saves these contracted times and break for this day's slot in the four-week pattern. Use the schedule editor (click the staff member's name on the grid) to change other days.">
                  Save to this staff member for every {WEEK_ORD[occurrenceOfDate(entry.date) - 1]} {WEEKDAYS[entry.weekday]} of the month
                </button>
              </div>
            )}
            {timesMsg && <div style={{ marginTop: 10, fontSize: 13, fontWeight: 700, color: "#15803d" }}>{timesMsg}</div>}
            <div style={{ marginTop: 12, paddingTop: 10, borderTop: "1px solid #e5e7eb", fontSize: 13 }}
                 title="Four weeks of this member's weekly pattern: each scheduled day's hours minus the break entitlement when unpaid, times four.">
              Four week contracted hours total: <b>{entry.fourWeekContractedH != null ? `${entry.fourWeekContractedH.toFixed(2)}h` : "—"}</b>
            </div>
          </div>

          {/* ---------------- 2. SESSIONS (editable, v3.36) ---------------- */}
          <div style={{ ...P, background: clockEdited ? "#fef3c7" : P.background,
                        border: clockEdited ? "1px solid #f59e0b" : P.border }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginBottom: 8 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
                <div style={{ ...H, marginBottom: 0 }}>Clock in / clock out sessions</div>
                {clockEdited && (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 5,
                                 background: "#f59e0b", color: "#fff", fontWeight: 800,
                                 fontSize: 12, padding: "2px 9px", borderRadius: 12,
                                 whiteSpace: "nowrap" }}
                        title="The clock in/out or break times on this day were altered by a manager. Every change is recorded — open View log for the detail.">
                    <span style={{ fontSize: 13 }}>⚠</span> Contents altered
                  </span>
                )}
              </div>
              <button style={{ ...S.btn("#0f766e"), padding: "4px 10px", fontSize: 12 }}
                disabled={clockBusy || busy}
                onClick={setAsScheduled}
                title="Sets this day's clock in/out (and break, if the pattern has one) to the scheduled contracted times. The change is recorded in the log.">
                Set as scheduled
              </button>
            </div>
            {clockEdited && (
              <div style={{ fontSize: 12, color: "#92400e", fontWeight: 700, marginBottom: 8 }}>
                ⚠ Clockings on this day have been adjusted by a manager — see the log.
              </div>
            )}
            {!sessDrafts.length && (
              <div style={{ fontSize: 14, color: "#6b7280", marginBottom: 8 }}>No clockings recorded for this day.</div>
            )}
            {sessDrafts.map((d, i) => {
              const s = sessions[i] || {};
              const tIn = { fontSize: 16, fontWeight: 700, padding: "3px 6px", border: "1px solid #d1d5db", borderRadius: 5, width: 96, background: "#fff", flexShrink: 0, boxSizing: "border-box" };
              // fixed-width In/Out labels so both time inputs start at the same x
              const tLab = { width: 34, flexShrink: 0 };
              return (
                <div key={i} style={{ border: "1px solid #e5e7eb", borderRadius: 6, background: "#fff", padding: "8px 10px", marginBottom: 8, fontSize: 15 }}>
                  {sessDrafts.length > 1 && <div style={{ fontWeight: 800, fontSize: 12, color: "#6b7280", marginBottom: 3 }}>SESSION #{i + 1}</div>}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                    <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <b style={tLab}>In</b>
                      <input type="time" value={d.in}
                        onChange={e => { setSessDrafts(p => p.map((x, j) => j === i ? { ...x, in: e.target.value } : x)); setClockDirty(true); }}
                        onDoubleClick={() => dblClickToScheduled(i, "in")}
                        title={start ? `Double-click to set to the scheduled start (${start}) \u2014 saved and logged immediately` : undefined}
                        style={tIn} />
                      {(() => { const t = punctualityIn(d.in, i === 0); return t ? (
                        <span style={{ fontSize: 12, fontWeight: 800, color: "#fff", background: t.color,
                                       padding: "1px 8px", borderRadius: 10, whiteSpace: "nowrap" }}>{t.text}</span>
                      ) : null; })()}
                    </span>
                    <span style={{ fontSize: 13, color: s.distIn != null && s.distIn > DIST_LIMIT_M ? "#dc2626" : "#374151" }}>
                      {s.distIn != null ? `${distText(s.distIn)}${s.distIn > DIST_LIMIT_M ? " ⚠" : ""} away` : (s.in ? "distance not recorded" : "")}
                    </span>
                  </div>
                  <div style={{ fontSize: 12.5, margin: "3px 0 7px" }}>
                    <span style={{ color: "#6b7280" }}>Notes (clock in): </span>
                    <span style={{ color: s.inNotes ? "#92400e" : "#9ca3af" }}>{s.inNotes || "—"}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                    <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <b style={tLab}>Out</b>
                      <input type="time" value={d.out}
                        onChange={e => { setSessDrafts(p => p.map((x, j) => j === i ? { ...x, out: e.target.value } : x)); setClockDirty(true); }}
                        onDoubleClick={() => dblClickToScheduled(i, "out")}
                        title={end ? `Double-click to set to the scheduled finish (${end}) \u2014 saved and logged immediately` : undefined}
                        style={tIn} />
                      {!d.out && s.in && !s.out && <span style={{ fontSize: 12.5, color: "#92400e" }}>still clocked in</span>}
                      {(() => { const t = punctualityOut(d.out, i === sessDrafts.length - 1); return t ? (
                        <span style={{ fontSize: 12, fontWeight: 800, color: "#fff", background: t.color,
                                       padding: "1px 8px", borderRadius: 10, whiteSpace: "nowrap" }}>{t.text}</span>
                      ) : null; })()}
                    </span>
                    <span style={{ fontSize: 13, color: s.distOut != null && s.distOut > DIST_LIMIT_M ? "#dc2626" : "#374151" }}>
                      {s.out ? (s.distOut != null ? `${distText(s.distOut)}${s.distOut > DIST_LIMIT_M ? " ⚠" : ""} away` : "distance not recorded") : ""}
                    </span>
                  </div>
                  <div style={{ fontSize: 12.5, marginTop: 3 }}>
                    <span style={{ color: "#6b7280" }}>Notes (clock out): </span>
                    <span style={{ color: s.outNotes ? "#92400e" : "#9ca3af" }}>{s.outNotes || "—"}</span>
                  </div>
                </div>
              );
            })}
            <button style={{ ...S.btn("#6b7280"), padding: "3px 10px", fontSize: 12, marginBottom: 8 }}
              disabled={clockBusy || busy}
              onClick={() => { setSessDrafts(p => [...p, { in: "", out: "" }]); setClockDirty(true); }}>
              + Add session
            </button>

            <div style={{ ...H, marginTop: 6 }}>Breaks</div>
            {!breakDrafts.length && <div style={{ fontSize: 13.5, color: "#9ca3af", marginBottom: 8 }}>No breaks recorded.</div>}
            {breakDrafts.map((b, i) => {
              const tIn = { fontSize: 15, fontWeight: 700, padding: "2px 6px", border: "1px solid #d1d5db", borderRadius: 5, width: 92, background: "#fff" };
              return (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 14.5, color: "#374151", marginBottom: 6 }}>
                  <span>Break from</span>
                  <input type="time" value={b.start}
                    onChange={e => { setBreakDrafts(p => p.map((x, j) => j === i ? { ...x, start: e.target.value } : x)); setClockDirty(true); }}
                    style={tIn} />
                  <span>to</span>
                  <input type="time" value={b.end}
                    onChange={e => { setBreakDrafts(p => p.map((x, j) => j === i ? { ...x, end: e.target.value } : x)); setClockDirty(true); }}
                    style={tIn} />
                  {(entry.breaks || [])[i]?.mins ? <span style={{ fontSize: 12.5, color: "#6b7280" }}>({(entry.breaks || [])[i].mins}m recorded)</span> : null}
                  <button style={{ ...S.btn("#dc2626"), padding: "1px 8px", fontSize: 12 }}
                    disabled={clockBusy || busy}
                    title="Remove this break (recorded in the log on save)"
                    onClick={() => { setBreakDrafts(p => p.filter((_, j) => j !== i)); setClockDirty(true); }}>
                    ✕
                  </button>
                </div>
              );
            })}
            <button style={{ ...S.btn("#6b7280"), padding: "3px 10px", fontSize: 12 }}
              disabled={clockBusy || busy}
              onClick={() => { setBreakDrafts(p => [...p, { start: "", end: "" }]); setClockDirty(true); }}>
              + Add break
            </button>

            {clockDirty && (
              <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 10 }}>
                <button style={S.btn("#1d4ed8")} disabled={clockBusy}
                  onClick={() => saveClockEdits(sessDrafts, breakDrafts, false)}
                  title="Saves the edited clock in/out and break times. Every changed value is recorded in the log; the panel turns amber to show clockings were manually adjusted.">
                  {clockBusy ? "Saving…" : "Save clocking changes"}
                </button>
                <button style={S.btn("#6b7280")} disabled={clockBusy}
                  onClick={() => { setSessDrafts(origSess.map(x => ({ ...x }))); setBreakDrafts(origBreaks.map(x => ({ ...x }))); setClockDirty(false); }}>
                  Discard
                </button>
              </div>
            )}

            <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: 8, marginTop: 10, fontSize: 15 }}>
              <div>Total hours on site: <b>{hFmt(actualM)} ({hDec(actualM)}h)</b>{stillIn ? " — session still open" : ""}</div>
              <div style={{ marginTop: 3 }}>Total break time taken: <b>{hFmt(breakTakenM)} ({hDec(breakTakenM)}h)</b></div>
            </div>
          </div>

          {/* ---------------- 3. SUMMARY ---------------- */}
          <div style={{ ...P, background: clockEdited ? "#fef3c7" : P.background,
                        border: clockEdited ? "1px solid #f59e0b" : P.border }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
              <div style={{ ...H, marginBottom: 0 }}>Summary</div>
              {clockEdited && (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 5,
                               background: "#f59e0b", color: "#fff", fontWeight: 800,
                               fontSize: 12, padding: "2px 9px", borderRadius: 12,
                               whiteSpace: "nowrap" }}
                      title="The submitted figures were recalculated from manager-adjusted clockings — see View log.">
                  <span style={{ fontSize: 13 }}>⚠</span> Contents altered
                </span>
              )}
            </div>
            <div style={{ fontSize: 13, marginBottom: 4 }}
                 title="Hours on site less the unpaid break (the entitlement is the minimum deducted), counted toward the day's paid contracted hours and capped at that figure.">
              Contracted hrs covered: <b style={{ color: covered ? "#15803d" : "#dc2626" }}>{hDec(Math.min(netActualM, paidContractedM > 0 ? paidContractedM : netActualM))}h</b>
              {paidContractedM > 0 && <span style={{ color: "#6b7280" }}> of {hDec(paidContractedM)}h</span>}
              <span style={{ marginLeft: 6 }}>{covered ? "✓" : "✗"}</span>
            </div>
            <div style={{ fontSize: 13, marginBottom: 8, color: potOtM > 12 ? "#1d4ed8" : "#6b7280", fontWeight: potOtM > 12 ? 700 : 400 }}
                 title="Net hours on site above the day's contracted hours: the surplus once contracted hours are covered.">
              Potential overtime: {hDec(potOtM)}h
            </div>
            {unpaidBreakM > breakTakenM + 0.5 && (
              <div style={{ fontSize: 11.5, color: "#92400e", marginBottom: 8, whiteSpace: "normal" }}
                   title="The contracted hours have already been reduced by the full unpaid break entitlement, so the same entitlement is deducted from the hours on site. Unused unpaid break time is not paid and does not become overtime.">
                Unpaid break entitlement of {hDec(unpaidBreakM)}h deducted ({hDec(breakTakenM)}h actually taken).
              </div>
            )}
            <div style={{ fontSize: 13, marginBottom: 6, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}
                 title="This is the number of hours that will be finally submitted to payroll. It is automatically set to the number of hours worked up to the daily contracted number of hours. It can be edited as required. All changes are logged.">
              <span style={{ width: 148 }}>Cont. hrs submitted</span>
              <input type="number" min="0" step="0.25" value={payroll}
                onChange={e => { setPayroll(e.target.value); setPayrollTouched(true); }}
                onBlur={() => savePayroll()}
                style={{ ...S.inp, width: 74, padding: "3px 6px" }} />
              <span style={{ color: "#6b7280" }}>h</span>
              {/* A stored figure that no longer agrees with the calculation —
                  a manager's own number, or one written before the break rule
                  was corrected — is never silently overwritten, but it is
                  never silently WRONG either: show the gap and offer the
                  calculated value in one click (logged like any other edit). */}
              {Number(payroll) !== Number(payrollDefault) && (
                <button type="button"
                  style={{ ...S.btn("#b45309"), padding: "2px 8px", fontSize: 11.5, whiteSpace: "nowrap" }}
                  title={`The calculation for this day gives ${payrollDefault}h. Click to use it (recorded in the log).`}
                  onClick={() => savePayroll(payrollDefault)}>
                  ≠ calculated {payrollDefault}h — use
                </button>
              )}
            </div>
            <div style={{ fontSize: 13, marginBottom: 10, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}
                 title="This is the number of hours that will be finally submitted for overtime for this day. It is automatically set at any surplus time the employee has worked. It can be edited and all changes will be logged. Any entry here will only appear in the final timesheet if marked as 'approved'.">
              <span style={{ width: 148 }}>O/time submitted</span>
              <input type="number" min="0" step="0.25" value={otPayroll}
                onChange={e => { setOtPayroll(e.target.value); setOtTouched(true); }}
                onBlur={saveOtPayroll}
                style={{ ...S.inp, width: 74, padding: "3px 6px" }} />
              <span style={{ color: "#6b7280" }}>h</span>
              {(() => {
                const otEnabled = potOtM > 12 || (Number(otPayroll) || 0) > 0;
                return (
                  <label style={{ display: "flex", alignItems: "center", gap: 5, marginLeft: 6,
                                  cursor: otEnabled ? "pointer" : "default",
                                  color: otEnabled ? "#1d4ed8" : "#9ca3af", fontWeight: otEnabled ? 700 : 400 }}>
                    <input type="checkbox" checked={!!entry.overtimeApproved} disabled={!otEnabled}
                      onChange={e => acceptOvertime(e.target.checked)} />
                    Approved
                  </label>
                );
              })()}
            </div>
            <div style={S.lab}>Manager notes</div>
            <textarea value={noteDraft}
              onChange={e => setNoteDraft(e.target.value)}
              onBlur={saveNotes}
              placeholder="Comments about this day's clocking event."
              rows={3}
              style={{ width: "100%", boxSizing: "border-box", fontSize: 12.5, padding: "6px 8px", border: "1px solid #d1d5db", borderRadius: 4, fontFamily: "inherit", resize: "vertical", marginBottom: 10 }} />
            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13.5, fontWeight: 700, color: "#15803d",
                            background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 6, padding: "8px 10px", cursor: "pointer", marginTop: 10 }}
                   title="When entries have been adjusted, and any discrepancies such as distance from QR code when scanned accepted, checking this box will mark this entry as being completed and ready for submission.">
              <input type="checkbox" checked={!!entry.eventReviewed} onChange={e => setReviewComplete(e.target.checked)} />
              Review complete
            </label>
            <div style={{ fontSize: 12.5, color: "#6b7280", marginTop: 8 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 5, whiteSpace: "nowrap",
                              color: isAuto ? "#15803d" : "#9ca3af" }}
                     title="Set automatically when the day is clean and complete: on time, in range, fully clocked out, no notes, no significant overtime. Read-only.">
                <input type="checkbox" checked={isAuto} disabled readOnly />
                Auto review
              </label>
              {deviceChanged && <div style={{ color: "#dc2626", marginTop: 4 }}>auto review blocked: clocking device changed</div>}
              {issues.length > 0 && <div style={{ color: "#dc2626", marginTop: 4 }}>⚠ {issues.join("; ")}</div>}
            </div>
          </div>
        </div>

        {/* Device ids — bottom corner. A red background marks the value
            that CHANGED versus the last recorded clocking. */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
          <div style={{ fontSize: 11, color: "#6b7280", textAlign: "right" }}>
            <span>Clock-in device: </span>
            <span style={entry.deviceChangedIn
              ? { background: "#dc2626", color: "#fff", borderRadius: 3, padding: "1px 5px", fontWeight: 700 }
              : { fontWeight: 600 }}>
              {inDevices.length ? inDevices.join(", ") : "not recorded"}
            </span>
            {entry.deviceChangedIn && entry.prevInDevice && (
              <span> (was {entry.prevInDevice})</span>
            )}
            <span style={{ margin: "0 8px", color: "#d1d5db" }}>|</span>
            <span>Clock-out device: </span>
            <span style={entry.deviceChangedOut
              ? { background: "#dc2626", color: "#fff", borderRadius: 3, padding: "1px 5px", fontWeight: 700 }
              : { fontWeight: 600 }}>
              {outDevices.length ? outDevices.join(", ") : "not recorded"}
            </span>
            {entry.deviceChangedOut && entry.prevOutDevice && (
              <span> (was {entry.prevOutDevice})</span>
            )}
          </div>
        </div>

        {/* ---------------- LOG POPUP ---------------- */}
        {logOpen && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9600 }}
               onClick={() => setLogOpen(false)}>
            <div style={{ background: "#fff", borderRadius: 8, width: "min(560px, 92vw)", maxHeight: "80vh", overflowY: "auto", padding: 16 }}
                 onClick={e => e.stopPropagation()}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <div style={{ fontWeight: 800 }}>Change log — {entry.staffName}, {dmy(entry.date)}</div>
                <button style={S.btn("#6b7280")} onClick={() => setLogOpen(false)}>Close</button>
              </div>
              {logRows === null && <div style={{ fontSize: 13, color: "#6b7280" }}>Loading…</div>}
              {logRows !== null && !logRows.length && <div style={{ fontSize: 13, color: "#6b7280" }}>No changes recorded yet for this day.</div>}
              {(logRows || []).map((l, i) => (
                <div key={i} style={{ borderBottom: "1px solid #f1f5f9", padding: "6px 0", fontSize: 12.5 }}>
                  <div style={{ color: "#6b7280", fontSize: 11.5 }}>
                    {l.at ? new Date(l.at).toLocaleString("en-GB") : ""}{l.by ? ` — ${l.by}` : ""}
                  </div>
                  <div>{l.msg}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ============================================================================
   TAB 1 — Day view: branches x staff (grouped by role)
   ============================================================================ */
function DayTab() {
  const [date, setDate] = useState(todayStr());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [activeRoles, setActiveRoles] = useState(new Set());
  const [dlg, setDlg] = useState(null); // { dbName, entry } — shared CellDialog
  const [schedDlg, setSchedDlg] = useState(null); // { dbName, staffId, staffName, roleName } — weekly schedule editor

  const load = useCallback(async (d) => {
    setLoading(true); setErr(null);
    try {
      const res = await post("/api/headoffice/clock/day", { date: d });
      setData(res);
      setActiveRoles(prev => prev.size ? prev : new Set(res.roles));
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(date); }, [date, load]);

  const roles = data?.roles || [];
  const shownRoles = roles.filter(r => activeRoles.has(r));

  // Retained but not wired to any button (see the hidden export above).
  // eslint-disable-next-line no-unused-vars
  const doExport = () => {
    if (!data) return;
    // v3.35: one STYLED tab per pharmacy — same banner-block design as the
    // month export (payroll figures highlighted, "How calculated" narrative,
    // single Review status). One row per staff member for the selected day;
    // distance/device columns removed (they live in the on-screen detail).
    const dateLine = `Date: ${new Date(`${date}T00:00:00`).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}`;
    const wb = XLSX.utils.book_new();
    const used = new Set();
    for (const ph of data.pharmacies) {
      let payrollTotM = 0, otTotM = 0, onSiteTotM = 0, breakTotM = 0, paidContrTotM = 0, needReview = 0, reviewedN = 0;
      const dataRows = [];
      for (const st of ph.staff) {
        if (!activeRoles.has(st.roleName)) continue;
        const c = dayCalc(date, st);
        const hasClock = !!st.sessions?.length;
        payrollTotM += c.payrollM; otTotM += payrollOtM(st, c.potOtM);
        onSiteTotM += c.actualM; breakTotM += c.breakTakenM; paidContrTotM += c.paidContractedM;
        if (hasClock) { needReview++; if (c.autoConf || st.eventReviewed) reviewedN++; }
        dataRows.push([
          st.staffName, st.roleName,
          st.fourWeekContractedH != null ? st.fourWeekContractedH : "",
          ...tsRowCells(st, c),
          st.reviewNotes || "",
          (st.sessions || []).map(x => [x.inNotes, x.outNotes].filter(Boolean).join("; ")).filter(Boolean).join(" | ")
        ]);
      }
      if (!dataRows.length) continue;   // pharmacy has nothing under the selected roles
      const totalsRow = [
        "TOTALS", "", "", h1(payrollTotM), h1(otTotM),
        `SUBMIT TO PAYROLL: ${h1(payrollTotM)}h contracted + ${h1(otTotM)}h approved overtime`,
        "", "", paidContrTotM > 0 ? h1(paidContrTotM) : "",
        "", h1(onSiteTotM), breakTotM > 0 ? h1(breakTotM) : "", "", "",
        needReview ? `${reviewedN}/${needReview} reviewed` : "", "", ""
      ];
      const ws = styledTimesheetSheet({
        infoLines: [`Pharmacy: ${ph.pharmacyName}`, `Clock in/out — day view`, dateLine, generatedStamp()],
        blocks: tsBlocks([
          { label: "Staff", w: 20, kind: "id" },
          { label: "Role", w: 14 },
          { label: "Four week contracted (h)", w: 12 }
        ]),
        dataRows, totalsRow
      });
      XLSX.utils.book_append_sheet(wb, ws, sheetNameFor(ph.pharmacyName, used));
    }
    if (!wb.SheetNames.length) {
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([[dateLine], [generatedStamp()], ["(no data for the selected roles)"]]), "No data");
    }
    XLSX.writeFile(wb, `clock_day_${date}.xlsx`);
  };

  return (
    <div>
      <div style={{ display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={S.lab}>Date:</span>
          <input type="date" style={S.inp} value={date} onChange={e => setDate(e.target.value)} />
          <button style={{ ...S.btn("#6b7280"), padding: "4px 10px", fontSize: 12 }} onClick={() => setDate(todayStr())}>Today</button>
        </div>
        <RoleChecks roles={roles} active={activeRoles} setActive={setActiveRoles} />
        <button style={{ ...S.btn("#0f766e"), marginLeft: "auto" }} disabled={loading} onClick={() => load(date)}>
          {loading ? "Refreshing…" : "↻ Refresh now"}</button>
        {/* v3.37: the day-view Excel export is HIDDEN — a one-day snapshot was
            confusing next to the month timesheet, which is the sheet payroll
            actually works from. doExport is retained below so the button can
            be restored by un-commenting this line. */}
        {/* <button style={S.btn()} onClick={doExport}>⤓ Export to Excel</button> */}
      </div>
      <div style={{ marginBottom: 10 }}><Legend /></div>
      {err && <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 8 }}>Error: {err}</div>}
      {loading && <div style={{ color: "#6b7280", fontSize: 13, padding: 12 }}>Loading {date}…</div>}
      {!loading && data && (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff" }}>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr style={{ background: "#f9fafb" }}>
                <th style={{ ...S.lab, textAlign: "left", padding: "8px 12px", borderBottom: "1px solid #e5e7eb", position: "sticky", left: 0, background: "#f9fafb", zIndex: 2 }}>Branch</th>
                {shownRoles.map(r => (
                  <th key={r} style={{ ...S.lab, textAlign: "left", padding: "8px 12px", borderBottom: "1px solid #e5e7eb", borderLeft: "2px solid #e5e7eb" }}>{r}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.pharmacies.map(ph => (
                <tr key={ph.dbName}>
                  <td style={{ padding: "6px 12px", fontWeight: 700, fontSize: 13, whiteSpace: "nowrap", borderBottom: "1px solid #f1f5f9", position: "sticky", left: 0, background: "#fff", zIndex: 1 }}>
                    {ph.pharmacyName}
                    {ph.error && <div style={{ fontSize: 10, color: "#dc2626", fontWeight: 400 }}>load error</div>}
                  </td>
                  {shownRoles.map(role => {
                    const staff = ph.staff.filter(s => s.roleName === role);
                    return (
                      <td key={role} style={{ padding: "4px 6px", borderBottom: "1px solid #f1f5f9", borderLeft: "2px solid #f1f5f9", verticalAlign: "top" }}>
                        <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                          {staff.map(s => {
                            const bg = cellStatus(date, s.planned, s.sessions, s.eventReviewed, new Date(), !!(s.deviceChangedIn || s.deviceChangedOut));
                            const tip = cellTooltip(s.planned, s.sessions, s.breaks, s.overtimeMins, date, s.eventReviewed, s.reviewNotes, { deviceChanged: !!(s.deviceChangedIn || s.deviceChangedOut) });
                            return (
                              <div key={s.staffId} title={(tip || s.staffName) + "\nDouble-click for the full analysis."}
                                onDoubleClick={() => {
                                  const dObj = new Date(date + "T00:00:00");
                                  setDlg({
                                    dbName: ph.dbName,
                                    entry: {
                                      staffId: s.staffId, staffName: s.staffName, date,
                                      weekday: dObj.getDay(), occurrence: Math.floor((dObj.getDate() - 1) / 7) + 1,
                                      planned: s.planned, sessions: s.sessions || [], breaks: s.breaks || [],
                                      overtimeMins: s.overtimeMins || 0, overtimeApproved: !!s.overtimeApproved,
                                      eventReviewed: !!s.eventReviewed, reviewNotes: s.reviewNotes || "",
                                      payrollHours: s.payrollHours != null ? s.payrollHours : null,
                                      payrollOtHours: s.payrollOtHours != null ? s.payrollOtHours : null,
                                      deviceChangedIn: !!s.deviceChangedIn, deviceChangedOut: !!s.deviceChangedOut,
                                      prevInDevice: s.prevInDevice || null, prevOutDevice: s.prevOutDevice || null,
                                      fourWeekContractedH: s.fourWeekContractedH != null ? s.fourWeekContractedH : null,
                                      roleName: s.roleName,
                                      clockManuallyEdited: !!s.clockManuallyEdited
                                    }
                                  });
                                }}
                                style={{ background: bg, border: "1px solid #d1d5db", borderRadius: 5, padding: "3px 8px", fontSize: 11.5, minWidth: 86, cursor: "pointer" }}>
                                <div style={{ fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 120,
                                               cursor: "pointer", textDecoration: "underline dotted", textUnderlineOffset: 3 }}
                                     title={`Click ${s.staffName}'s name to view and edit their scheduled hours for the whole month (four-week Mon–Sun pattern, break length and paid-break setting).`}
                                     onClick={e => { e.stopPropagation(); setSchedDlg({ dbName: ph.dbName, staffId: s.staffId, staffName: s.staffName, roleName: s.roleName }); }}
                                >{s.staffName}</div>
                                <div style={{ whiteSpace: "nowrap" }}>{sessionsText(s.sessions)}</div>
                                <div style={{ color: "#4b5563", whiteSpace: "nowrap" }}>
                                  {s.planned ? `(${s.planned.start || "?"}–${s.planned.end || "?"})` : "(no plan)"}
                                </div>
                              </div>
                            );
                          })}
                          {!staff.length && <span style={{ color: "#d1d5db", fontSize: 11 }}>—</span>}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {schedDlg && (
        <StaffScheduleDialog {...schedDlg} onReload={load} onClose={() => setSchedDlg(null)} />
      )}
      {dlg && (
        <CellDialog
          dbName={dlg.dbName}
          entry={dlg.entry}
          onClose={() => setDlg(null)}
          onReload={() => load(date)}
          onLocalPatch={(fields) => {
            setDlg(d2 => d2 ? { ...d2, entry: { ...d2.entry, ...fields } } : d2);
            setData(prev => {
              if (!prev) return prev;
              return { ...prev, pharmacies: prev.pharmacies.map(p2 =>
                p2.dbName !== dlg.dbName ? p2 : { ...p2, staff: p2.staff.map(s2 =>
                  s2.staffId !== dlg.entry.staffId ? s2 : { ...s2, ...fields }) }) };
            });
          }}
        />
      )}
    </div>
  );
}

/* ============================================================================
   TAB 2 — Month view: one pharmacy, editable planned hours, totals
   ============================================================================ */
function MonthTab({ pharmacies }) {
  const now = new Date();
  const [dbName, setDbName] = useState("");
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [activeRoles, setActiveRoles] = useState(new Set());
  const [edit, setEdit] = useState(null); // full CellDialog entry built from the clicked cell
  const [schedDlg, setSchedDlg] = useState(null); // weekly schedule editor (name click)
  const [phStatus, setPhStatus] = useState({});   // dbName -> 'green'|'red'|'none' (dropdown colouring)
  const [exportingAll, setExportingAll] = useState(false);
  const [exporting, setExporting] = useState(false);

  // Dropdown colouring: per-pharmacy month status (green = every populated
  // cell approved manually or auto; red = any red cell; none otherwise).
  useEffect(() => {
    let dead = false;
    (async () => {
      try {
        const d = await post("/api/headoffice/clock/month/status", { year, month });
        if (!dead) setPhStatus(d.statuses || {});
      } catch (_) { if (!dead) setPhStatus({}); }
    })();
    return () => { dead = true; };
  }, [year, month]);

  useEffect(() => { if (!dbName && pharmacies.length) setDbName(pharmacies[0].dbName); }, [pharmacies, dbName]);

  const load = useCallback(async () => {
    if (!dbName) return;
    setLoading(true); setErr(null);
    try {
      const res = await post("/api/headoffice/clock/month", { dbName, year, month });
      setData(res);
      const roles = [...new Set(res.staff.map(s => s.roleName))];
      setActiveRoles(new Set(roles));
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  }, [dbName, year, month]);
  useEffect(() => { load(); }, [load]);

  const roles = useMemo(() => [...new Set((data?.staff || []).map(s => s.roleName))].sort(), [data]);
  const staffShown = (data?.staff || []).filter(s => activeRoles.has(s.roleName));

  // Column totals under the NEW payroll arithmetic (dayCalc): planned
  // (contracted) hours, actual payroll hours (stored override or net actual
  // capped at paid contracted), and overtime — the net-rule surplus of
  // APPROVED (ticked) days only.
  const colTotals = (staffId) => {
    const m = data?.cells?.[staffId] || {};
    let rawM = 0, plannedM = 0, payrollM = 0, otApprovedM = 0;
    for (const k of Object.keys(m)) {
      const c = dayCalc(k, m[k]);
      rawM += c.actualM;           // raw = every session's out minus in
      plannedM += c.contractedM;
      payrollM += c.payrollM;
      otApprovedM += payrollOtM(m[k], c.potOtM);
    }
    return { rawH: h1(rawM), plannedH: h1(plannedM), payrollH: h1(payrollM), overtimeH: h1(otApprovedM) };
  };

  // Build + save one workbook (tab per staff member) for a month payload —
  // used by both the single-pharmacy export and "Export all pharmacies".
  // v3.34: each tab is the STYLED sheet (banner blocks, highlighted payroll
  // figures, "How calculated" narrative, single Review status column).
  const exportMonthWorkbook = async (mData, phName, staffList, prevData = null, targetDb = dbName) => {
    const monthLabelStr = `${MONTHS[month - 1]} ${year}`;
    const wb = XLSX.utils.book_new();
    const used = new Set();
    // Server truth from /clock/month wins; login-cached localStorage is the
    // fallback for older backend deployments.
    const payrollSetting = normalizePayrollSetting(mData?.payrollMonthEnd) ?? payrollMonthEndSetting();

    if (!payrollSetting) {
      // Legacy export: the selected calendar month, unchanged.
      const changeLogs = await fetchChangeLogs(targetDb, mData, staffList, mData.days || []);
      for (const s of staffList) {
        XLSX.utils.book_append_sheet(wb, buildStyledMonthSheet(mData, s, phName, monthLabelStr, { changeLogs }), sheetNameFor(s.staffName, used));
      }
      if (!staffList.length) {
        XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([[generatedStamp()], ["(no staff for the selected roles)"]]), "No data");
      }
      XLSX.writeFile(wb, `clock_month_${(phName).replace(/[^\w]+/g, "_")}_${year}-${String(month).padStart(2, "0")}.xlsx`);
      return;
    }

    // Payroll-month-end export: the payroll period ending on this month's
    // payroll month end, days after today ESTIMATED at scheduled hours, and
    // a Reconciliation first page for the previously estimated block.
    const period = payrollPeriodForMonth(year, month - 1, payrollSetting);
    const merged = mergeMonthPayloads(mData, prevData);
    const periodData = { ...mData, staff: merged.staff, cells: merged.cells, days: period.days };
    const todayKey = feDayKey(new Date());
    const periodLabelStr = `${period.start.toLocaleDateString("en-GB")} \u2013 ${period.end.toLocaleDateString("en-GB")} (payroll month end)`;

    if (period.recon) {
      XLSX.utils.book_append_sheet(wb, buildReconSheet(merged, staffList, period.recon, phName), "Reconciliation");
    }
    const periodLogs = await fetchChangeLogs(targetDb, periodData, staffList, period.days);
    for (const s of staffList) {
      XLSX.utils.book_append_sheet(wb,
        buildStyledMonthSheet(periodData, s, phName, periodLabelStr, { estimateAfterKey: todayKey, changeLogs: periodLogs }),
        sheetNameFor(s.staffName, used));
    }
    if (!staffList.length && !period.recon) {
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([[generatedStamp()], ["(no staff for the selected roles)"]]), "No data");
    }
    XLSX.writeFile(wb, `clock_month_${(phName).replace(/[^\w]+/g, "_")}_${period.startKey}_to_${period.endKey}.xlsx`);
  };

  // Previous month's payload — needed in payroll-month-end mode for the
  // period's tail into last month and the Reconciliation page.
  const fetchPrevMonth = async (targetDb, serverSetting) => {
    if (!(normalizePayrollSetting(serverSetting) ?? payrollMonthEndSetting())) return null;
    const pm = month === 1 ? 12 : month - 1;
    const py = month === 1 ? year - 1 : year;
    try { return await post("/api/headoffice/clock/month", { dbName: targetDb, year: py, month: pm }); }
    catch (e) { console.error("prev month fetch:", e.message); return null; }
  };

  const doExport = async () => {
    if (!data || exporting) return;
    setExporting(true);
    try {
      const ph = pharmacies.find(p => p.dbName === dbName);
      const prev = await fetchPrevMonth(dbName, data?.payrollMonthEnd);
      await exportMonthWorkbook(data, ph?.pharmacyName || dbName, staffShown, prev, dbName);
    } catch (e) { setErr(`Export failed: ${e.message}`); }
    finally { setExporting(false); }
  };

  // One spreadsheet PER PHARMACY for the selected month — fetches each
  // pharmacy's month in turn and saves a separate workbook (all roles).
  const exportAll = async () => {
    if (exportingAll) return;
    setExportingAll(true); setErr(null);
    try {
      for (const p of pharmacies) {
        try {
          const d = await post("/api/headoffice/clock/month", { dbName: p.dbName, year, month });
          if ((d.staff || []).length) {
            const prev = await fetchPrevMonth(p.dbName, d?.payrollMonthEnd);
            await exportMonthWorkbook(d, p.pharmacyName, d.staff, prev, p.dbName);
          }
        } catch (e) { console.error("export all:", p.pharmacyName, e.message); }
      }
    } finally { setExportingAll(false); }
  };

  return (
    <div>
      <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={S.lab}>Pharmacy:</span>
          <select style={{ ...S.inp, maxWidth: 260 }} value={dbName} onChange={e => setDbName(e.target.value)}
            title="Green: every recorded day this month is approved (manually or auto-confirmed). Red: at least one day needs attention. No colour: nothing recorded, or a mix awaiting completion.">
            {pharmacies.map(p => {
              const st = phStatus[p.dbName];
              const bg = st === "green" ? "#bbf7d0" : st === "red" ? "#fecaca" : undefined;
              return <option key={p.dbName} value={p.dbName} style={bg ? { background: bg } : undefined}>{p.pharmacyName}</option>;
            })}
          </select>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={S.lab}>Month:</span>
          <select style={S.inp} value={month} onChange={e => setMonth(Number(e.target.value))}>
            {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
          </select>
          <select style={S.inp} value={year} onChange={e => setYear(Number(e.target.value))}>
            {Array.from({ length: 4 }, (_, i) => now.getFullYear() - 2 + i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
        <RoleChecks roles={roles} active={activeRoles} setActive={setActiveRoles} />
        <button style={{ ...S.btn("#0f766e"), marginLeft: "auto" }} disabled={loading} onClick={load}>
          {loading ? "Refreshing…" : "↻ Refresh now"}</button>
        <button style={S.btn()} disabled={exporting || exportingAll} onClick={doExport}
          title="Downloads this pharmacy's month workbook — one tab per staff member, unapproved days shaded red, with the recorded changes for any day that was altered.">
          {exporting ? "Preparing…" : "⤓ Export to Excel"}
        </button>
        <button style={S.btn("#3730a3")} disabled={exportingAll || exporting} onClick={exportAll}
          title="Downloads one workbook per pharmacy for the selected month — every staff member of every role, one tab each.">
          {exportingAll ? "Exporting…" : "⤓ Export all pharmacies"}
        </button>
      </div>
      {/* Export-mode indicator: shows whether the payroll-month-end period
          will be used (server setting from /clock/month, else the login
          cache) — so a legacy calendar-month export is never a mystery. */}
      <div style={{ fontSize: 11.5, color: "#6b7280", margin: "-4px 0 8px" }}>
        {(() => {
          const ps = normalizePayrollSetting(data?.payrollMonthEnd) ?? payrollMonthEndSetting();
          if (!ps) return "Excel export: calendar month (no payroll month end set — configure it in Settings next to \u201CSend monthly timesheets\u201D and Save).";
          const p = payrollPeriodForMonth(year, month - 1, ps);
          const lbl = ps === "last" ? "last day of month" : ps === "first" ? "first day of month" : `day ${ps}`;
          return `Excel export: payroll period ${p.start.toLocaleDateString("en-GB")} \u2013 ${p.end.toLocaleDateString("en-GB")} (payroll month end: ${lbl})` +
            (p.recon ? `; reconciliation page ${p.recon.start.toLocaleDateString("en-GB")} \u2013 ${p.recon.end.toLocaleDateString("en-GB")}` : "") +
            "; days after today estimated at scheduled hours.";
        })()}
      </div>
      <div style={{ marginBottom: 8 }}><Legend /></div>
      <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>
        Click any cell to set that staff member's planned start/end for that weekday pattern (e.g. every 2nd Friday, or all Fridays) — stored per weekday-occurrence in staff_times.
      </div>
      {err && <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 8 }}>Error: {err}</div>}
      {loading && <div style={{ color: "#6b7280", fontSize: 13, padding: 12 }}>Loading month…</div>}
      {!loading && data && (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff", maxHeight: "68vh", overflowY: "auto" }}>
          <table style={{ borderCollapse: "collapse" }}>
            <thead>
              {/* role group header over the staff columns */}
              <tr style={{ background: "#f3f4f6", position: "sticky", top: 0, zIndex: 3 }}>
                <th style={{ position: "sticky", left: 0, background: "#f3f4f6", zIndex: 4 }} />
                {(() => {
                  const groups = [];
                  for (const s of staffShown) {
                    const last = groups[groups.length - 1];
                    if (last && last.role === s.roleName) last.count++;
                    else groups.push({ role: s.roleName, count: 1 });
                  }
                  return groups.map((g, i) => (
                    <th key={`${g.role}-${i}`} colSpan={g.count}
                      style={{ ...S.lab, padding: "4px 8px", borderBottom: "1px solid #e5e7eb", borderLeft: "2px solid #e5e7eb" }}>{g.role}</th>
                  ));
                })()}
              </tr>
              <tr style={{ background: "#f9fafb", position: "sticky", top: 25, zIndex: 3 }}>
                <th style={{ ...S.lab, textAlign: "left", padding: "6px 10px", borderBottom: "1px solid #e5e7eb", position: "sticky", left: 0, background: "#f9fafb", zIndex: 4, minWidth: 74 }}>Day</th>
                {staffShown.map((s, i) => {
                  // all of this member's review-needing days reviewed (manual or auto)?
                  let rNeed = 0, rDone = 0;
                  const cm = data.cells[s.staffId] || {};
                  for (const dd of data.days) {
                    const cc = cm[dd.date] || {};
                    if (!(cc.sessions || []).length && !cc.planned) continue;
                    rNeed++;
                    if (cc.eventReviewed || dayCalc(dd.date, cc).autoConf) rDone++;
                  }
                  const allRev = rNeed > 0 && rDone === rNeed;
                  return (
                  <th key={s.staffId} style={{ ...S.lab, padding: "4px 6px", borderBottom: "1px solid #e5e7eb", minWidth: 92, maxWidth: 130,
                      background: allRev ? "#dcfce7" : undefined,
                      borderLeft: (i === 0 || staffShown[i - 1].roleName !== s.roleName) ? "2px solid #e5e7eb" : "1px solid #f1f5f9" }}
                      title={allRev ? `Every one of ${s.staffName}'s days needing review this month is reviewed (manually or automatically).` : undefined}>
                    <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "inline-block", maxWidth: 120,
                                   cursor: "pointer", textDecoration: "underline dotted", textUnderlineOffset: 3,
                                   color: allRev ? "#15803d" : undefined }}
                          title={`Click ${s.staffName}'s name to view and edit their scheduled hours for the whole month (four-week Mon–Sun pattern, break length and paid-break setting).`}
                          onClick={() => setSchedDlg({ dbName, staffId: s.staffId, staffName: s.staffName, roleName: s.roleName })}
                    >{s.staffName}</span>
                  </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {data.days.map(d => (
                <tr key={d.date} style={{ background: (d.weekday === 0 || d.weekday === 6) ? C.off : undefined }}>
                  <td style={{ padding: "4px 10px", fontSize: 12, whiteSpace: "nowrap", borderBottom: "1px solid #f1f5f9", position: "sticky", left: 0, background: (d.weekday === 0 || d.weekday === 6) ? "#f3f4f6" : "#fff", zIndex: 1, fontWeight: 700 }}>
                    {d.day} <span style={{ fontWeight: 400, color: "#6b7280" }}>{WEEKDAYS[d.weekday]}</span>
                  </td>
                  {staffShown.map((s, i) => {
                    const c = data.cells[s.staffId]?.[d.date];
                    const planned = c?.planned || null;
                    const sessions = c?.sessions || [];
                    const breaks = c?.breaks || [];
                    const otM = c?.overtimeMins || 0;
                    const st = cellStatus(d.date, planned, sessions, c?.eventReviewed, new Date(), !!(c?.deviceChangedIn || c?.deviceChangedOut));
                    const bg = st === C.blank ? "transparent" : st;
                    const tip = cellTooltip(planned, sessions, breaks, otM, d.date, c?.eventReviewed, c?.reviewNotes, { deviceChanged: !!(c?.deviceChangedIn || c?.deviceChangedOut) });
                    const brkM = breaks.reduce((tt, b) => tt + (b.mins || 0), 0);
                    return (
                      <td key={s.staffId} title={tip}
                        onClick={() => setEdit({
                          staffId: s.staffId, staffName: s.staffName, date: d.date,
                          weekday: d.weekday, occurrence: Math.floor((d.day - 1) / 7) + 1,
                          planned, sessions, breaks,
                          overtimeMins: otM, overtimeApproved: !!c?.overtimeApproved,
                          eventReviewed: !!c?.eventReviewed, reviewNotes: c?.reviewNotes || "",
                          payrollHours: c?.payrollHours != null ? c.payrollHours : null,
                          payrollOtHours: c?.payrollOtHours != null ? c.payrollOtHours : null,
                          deviceChangedIn: !!c?.deviceChangedIn, deviceChangedOut: !!c?.deviceChangedOut,
                          prevInDevice: c?.prevInDevice || null, prevOutDevice: c?.prevOutDevice || null,
                          fourWeekContractedH: s.fourWeekContractedH != null ? s.fourWeekContractedH : null,
                          roleName: s.roleName,
                          clockManuallyEdited: !!c?.clockManuallyEdited
                        })}
                        style={{ background: bg, border: "1px solid #f1f5f9",
                                 padding: "2px 3px", fontSize: 10.5, textAlign: "center", cursor: "pointer", verticalAlign: "top",
                                 borderLeft: (i === 0 || staffShown[i - 1].roleName !== s.roleName) ? "2px solid #e5e7eb" : "1px solid #f1f5f9" }}>
                        <div style={{ whiteSpace: "nowrap", fontWeight: 600 }}>{sessions.length ? sessionsText(sessions) : ""}</div>
                        <div style={{ color: "#4b5563", whiteSpace: "nowrap" }}>{planned ? `(${planned.start || "?"}–${planned.end || "?"})` : ""}</div>
                        {brkM > 0 && <div style={{ color: "#7c3aed", whiteSpace: "nowrap" }}>brk {brkM}m</div>}
                        {otM > 0 && (
                          <div style={{ color: "#1d4ed8", fontWeight: 700, whiteSpace: "nowrap" }}>
                            OT {Math.round(otM / 0.6) / 100}h {c?.overtimeApproved ? "☑" : "☐"}
                          </div>
                        )}
                        {c?.eventReviewed && <div style={{ color: "#1e40af", fontWeight: 700 }}>✔ reviewed</div>}
                        {(sessions.some(x => x.inNotes || x.outNotes)) && <div style={{ color: "#0f766e" }}>✎</div>}
                      </td>
                    );
                  })}
                </tr>
              ))}
              {/* totals rows — one per measure, per staff column; STICKY at the
                  bottom of the scroll area (fixed 24px rows, stacked offsets)
                  so the day cells scroll between the header and these totals */}
              {[["rawH", "Raw hours on site:"], ["plannedH", "Planned hrs total:"], ["payrollH", "Actual payroll hours total:"], ["overtimeH", "Overtime total:"]].map(([f, label], ri) => {
                const stickBottom = (3 - ri) * 24;
                const totCell = { position: "sticky", bottom: stickBottom, background: "#f9fafb",
                                  height: 24, boxSizing: "border-box", zIndex: 2,
                                  borderTop: ri === 0 ? "2px solid #e5e7eb" : "1px solid #f1f5f9" };
                return (
                <tr key={f}>
                  <td style={{ ...S.lab, ...totCell, padding: "4px 10px", whiteSpace: "nowrap", left: 0, zIndex: 3 }}
                      title={f === "overtimeH" ? "Sum of APPROVED (ticked) overtime only — the manual payroll o/time override where set, otherwise the net-rule surplus over paid contracted hours."
                        : f === "payrollH" ? "Sum of each day's payroll hours: the manual override where set, otherwise net hours on site capped at paid contracted."
                        : f === "rawH" ? "Every session's clock out minus clock in, summed — no break or contract adjustments." : undefined}>{label}</td>
                  {staffShown.map((s, i) => (
                    <td key={s.staffId} style={{ ...totCell, padding: "3px 6px", fontSize: 11.5, textAlign: "center", fontWeight: 700,
                        color: f === "overtimeH" ? "#1d4ed8" : undefined,
                        borderLeft: (i === 0 || staffShown[i - 1].roleName !== s.roleName) ? "2px solid #e5e7eb" : "1px solid #f1f5f9" }}>
                      {colTotals(s.staffId)[f]}
                    </td>
                  ))}
                </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {schedDlg && (
        <StaffScheduleDialog {...schedDlg} onReload={load} onClose={() => setSchedDlg(null)}
          monthDays={data?.days || []}
          cellsForStaff={data?.cells?.[schedDlg.staffId] || {}}
          monthLabel={`${MONTHS[month - 1]} ${year}`}
          fourWeekContractedH={(data?.staff || []).find(s => s.staffId === schedDlg.staffId)?.fourWeekContractedH ?? null}
          onCellPatch={(date, fields) => {
            setData(prev => {
              if (!prev) return prev;
              const cur = prev.cells?.[schedDlg.staffId]?.[date] || {};
              return { ...prev, cells: { ...prev.cells, [schedDlg.staffId]: { ...(prev.cells[schedDlg.staffId] || {}),
                [date]: { ...cur, ...fields } } } };
            });
          }}
        />
      )}
      {edit && (
        <CellDialog
          dbName={dbName}
          entry={edit}
          onClose={() => setEdit(null)}
          onReload={load}
          onLocalPatch={(fields) => {
            setEdit(e2 => ({ ...e2, ...fields }));
            setData(prev => {
              if (!prev) return prev;
              const cur = prev.cells?.[edit.staffId]?.[edit.date] || { planned: edit.planned, sessions: edit.sessions, breaks: edit.breaks, overtimeMins: edit.overtimeMins };
              return { ...prev, cells: { ...prev.cells, [edit.staffId]: { ...(prev.cells[edit.staffId] || {}),
                [edit.date]: { ...cur, ...fields } } } };
            });
          }}
        />
      )}
    </div>
  );
}

/* ============================================================================
   TAB 3 — Summary: pharmacy x role totals
   ============================================================================ */
function SummaryTab() {
  const now = new Date();
  const [year, setYear] = useState(String(now.getFullYear()));
  const [month, setMonth] = useState("");
  const [measures, setMeasures] = useState({ contracted: true, onSite: true, payroll: true, overtime: true });
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const load = useCallback(async () => {
    setLoading(true); setErr(null);
    try {
      const res = await post("/api/headoffice/clock/summary", {
        year: year ? Number(year) : null, month: month ? Number(month) : null
      });
      setData(res);
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  }, [year, month]);
  useEffect(() => { load(); }, [load]);

  const shown = [
    measures.contracted && ["contractedH", "Contracted"],
    measures.onSite && ["onSiteH", "On site"],
    measures.payroll && ["payrollH", "Payroll"],
    measures.overtime && ["overtimeH", "Overtime (ticked)"]
  ].filter(Boolean);
  // The three bottom totals rows: label + which measure column they sum.
  const TOTAL_ROWS = [
    ["Raw hours on site:", "onSiteH"],
    ["Planned hrs total:", "contractedH"],
    ["Actual payroll hours total:", "payrollH"],
    ["Overtime total:", "overtimeH"]
  ];
  const colSum = (role, field) => {
    let sum = 0;
    for (const [, roleMap] of byPharmacy) { const r = roleMap[role]; if (r) sum += (r[field] || 0); }
    return Math.round(sum * 10) / 10;
  };

  const byPharmacy = useMemo(() => {
    const map = new Map();
    for (const r of (data?.rows || [])) {
      if (!map.has(r.pharmacyName)) map.set(r.pharmacyName, {});
      map.get(r.pharmacyName)[r.roleName] = r;
    }
    return map;
  }, [data]);
  const roles = data?.roles || [];

  const windowLabel = year && month ? `${MONTHS[Number(month) - 1]} ${year}` : year ? `${year} (all months)` : month ? `${MONTHS[Number(month) - 1]} (all years)` : "All time";

  const doExport = () => {
    if (!data) return;
    const rows = [];
    for (const [ph, roleMap] of byPharmacy) {
      const row = { Pharmacy: ph };
      for (const role of roles) {
        const r = roleMap[role];
        for (const [field, label] of shown) row[`${role} — ${label} (h)`] = r ? r[field] : 0;
      }
      rows.push(row);
    }
    if (rows.length) {
      for (const [tLabel, tField] of TOTAL_ROWS) {
        const totalsRow = { Pharmacy: tLabel };
        for (const role of roles) for (const [field, label] of shown) {
          totalsRow[`${role} — ${label} (h)`] = field === tField ? colSum(role, tField) : "";
        }
        rows.push(totalsRow);
      }
    }
    exportSheet(rows.length ? rows : [{ Pharmacy: "(no data)" }], windowLabel.slice(0, 31),
      `clock_summary_${(year || "all")}-${(month || "all")}.xlsx`, [
      `${orgLine() ? orgLine() + " — " : ""}Clock in/out — summary (pharmacy × role)`,
      `Window: ${windowLabel}`,
      generatedStamp()
    ]);
  };

  return (
    <div>
      <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={S.lab}>Year:</span>
          <select style={S.inp} value={year} onChange={e => setYear(e.target.value)}>
            <option value="">All years</option>
            {Array.from({ length: 4 }, (_, i) => now.getFullYear() - 3 + i + 1).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <span style={S.lab}>Month:</span>
          <select style={S.inp} value={month} onChange={e => setMonth(e.target.value)}>
            <option value="">All months</option>
            {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
          </select>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <span style={S.lab}>Show:</span>
          {[["contracted", "Contracted hours"], ["onSite", "Hours on site"], ["overtime", "Overtime (ticked)"]].map(([k, label]) => (
            <label key={k} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13, cursor: "pointer" }}>
              <input type="checkbox" checked={measures[k]} onChange={e => setMeasures(m => ({ ...m, [k]: e.target.checked }))} />
              {label}
            </label>
          ))}
        </div>
        <button style={{ ...S.btn("#0f766e"), marginLeft: "auto" }} disabled={loading} onClick={load}>
          {loading ? "Refreshing…" : "↻ Refresh now"}</button>
        <button style={S.btn()} onClick={doExport}>⤓ Export to Excel</button>
      </div>
      <div style={{ fontSize: 12.5, color: "#374151", marginBottom: 8 }}>
        Window: <b>{windowLabel}</b> · <b style={{ color: "#1d4ed8" }}>Overtime shows CONFIRMED overtime only</b> — cells
        ticked as approved on the month view's day analysis. Unticked overtime is not counted here.
      </div>
      {err && <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 8 }}>Error: {err}</div>}
      {loading && <div style={{ color: "#6b7280", fontSize: 13, padding: 12 }}>Computing summary…</div>}
      {!loading && data && (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff" }}>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr style={{ background: "#f9fafb" }}>
                <th style={{ ...S.lab, textAlign: "left", padding: "8px 12px", borderBottom: "1px solid #e5e7eb", position: "sticky", left: 0, background: "#f9fafb" }}>Pharmacy</th>
                {roles.map(role => (
                  <th key={role} colSpan={shown.length} style={{ ...S.lab, padding: "6px 8px", borderBottom: "1px solid #e5e7eb", borderLeft: "2px solid #e5e7eb" }}>{role}</th>
                ))}
              </tr>
              {shown.length > 1 && (
                <tr style={{ background: "#f9fafb" }}>
                  <th style={{ borderBottom: "1px solid #e5e7eb", position: "sticky", left: 0, background: "#f9fafb" }} />
                  {roles.map(role => shown.map(([f, label]) => (
                    <th key={`${role}-${f}`} style={{ fontSize: 10, color: "#6b7280", padding: "2px 6px", borderBottom: "1px solid #e5e7eb", borderLeft: f === shown[0][0] ? "2px solid #e5e7eb" : "1px solid #f1f5f9" }}>{label}</th>
                  )))}
                </tr>
              )}
            </thead>
            <tbody>
              {[...byPharmacy.entries()].map(([ph, roleMap]) => (
                <tr key={ph}>
                  <td style={{ padding: "6px 12px", fontWeight: 700, fontSize: 13, whiteSpace: "nowrap", borderBottom: "1px solid #f1f5f9", position: "sticky", left: 0, background: "#fff" }}>{ph}</td>
                  {roles.map(role => shown.map(([f], fi) => {
                    const r = roleMap[role];
                    return (
                      <td key={`${role}-${f}`} style={{ padding: "6px 8px", fontSize: 12.5, textAlign: "center", whiteSpace: "nowrap", borderBottom: "1px solid #f1f5f9", borderLeft: fi === 0 ? "2px solid #f1f5f9" : "1px solid #f8fafc" }}>
                        {r ? `${r[f]}h` : "—"}
                      </td>
                    );
                  }))}
                </tr>
              ))}
              {byPharmacy.size > 0 && TOTAL_ROWS.map(([label, field], ri) => (
                <tr key={label} style={{ background: "#f9fafb", borderTop: ri === 0 ? "2px solid #e5e7eb" : undefined }}>
                  <td style={{ ...S.lab, padding: "5px 12px", whiteSpace: "nowrap", position: "sticky", left: 0, background: "#f9fafb" }}>{label}</td>
                  {roles.map(role => shown.map(([f], fi) => (
                    <td key={`t-${label}-${role}-${f}`} style={{ padding: "5px 8px", fontSize: 12.5, fontWeight: 800, textAlign: "center", whiteSpace: "nowrap", borderLeft: fi === 0 ? "2px solid #e5e7eb" : "1px solid #f1f5f9" }}>
                      {f === field ? `${colSum(role, field)}h` : ""}
                    </td>
                  )))}
                </tr>
              ))}
              {!byPharmacy.size && (
                <tr><td colSpan={1 + roles.length * shown.length} style={{ padding: 20, textAlign: "center", color: "#6b7280", fontSize: 13 }}>No clock data in this window.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

/* ============================================================================
   Panel shell
   ============================================================================ */
export default function ClockInOut() {
  const [tab, setTab] = useState(0);
  const [pharmacies, setPharmacies] = useState([]);
  useEffect(() => {
    // pharmacy list for the month tab's selector: reuse the day endpoint's
    // scoped members via a lightweight call for today (names only needed)
    post("/api/headoffice/clock/day", { date: todayStr() })
      .then(d => setPharmacies((d.pharmacies || []).map(p => ({ pharmacyName: p.pharmacyName, dbName: p.dbName }))))
      .catch(() => {});
  }, []);

  const TABS = ["Day view — all branches", "Month view — one branch", "Summary", "Workforce planner", "Raw data", "Pharmacist rota"];
  // v3.24 (revised): floating summaries are now a styled hover panel (native
  // title tooltips can't be formatted). Each tip is a list of sections —
  // { h: heading, p: [paragraph, ...] } — rendered under the hovered tab.
  const TAB_TIPS = [
    // Day view
    [
      { h: "What it shows", p: [
        "One day across every branch, with each rostered staff member grouped by role.",
        "Defaults to today, but you can select any day in the past with the date picker."
      ]},
      { h: "Cell colours", p: [
        "Green — auto-confirmed or review complete.",
        "Yellow — clean, but still clocked in.",
        "Red — needs attention (late in, left early, too far away, notes, or absent)."
      ]},
      { h: "How to use it", p: [
        "Float over a cell to see its details.",
        "Click a staff member's NAME to open a dialogue where their scheduled hours can be changed.",
        "Click anywhere else on the cell to open the full day detail — clockings, breaks, submitted hours and review."
      ]},
      { h: "Also here", p: [
        "Use the role tick-boxes to filter the columns. The timesheet spreadsheet is produced from the MONTH view — that is the sheet payroll works from."
      ]}
    ],
    // Month view
    [
      { h: "What it shows", p: [
        "A whole month for one branch, one row per staff member per day.",
        "Pick the branch and month at the top."
      ]},
      { h: "How to use it", p: [
        "Float over a cell for its detail; click a cell for the full analysis and the approval ticks.",
        "Staff-name headers turn green once every day needing review for that member has been reviewed."
      ]},
      { h: "Totals", p: [
        "Sticky totals rows at the bottom show raw, planned, actual payroll and overtime hours."
      ]}
    ],
    // Summary
    [
      { h: "What it shows", p: [
        "Totals across all branches for a chosen period — contracted, worked, payroll and overtime hours, rolled up per branch and per staff member."
      ]},
      { h: "When to use it", p: [
        "Sanity-check the period before running payroll."
      ]}
    ],
    // Workforce planner
    [
      { h: "What it shows", p: [
        "Staffing plans across the organisation — weekly patterns and cover for each branch."
      ]},
      { h: "When to use it", p: [
        "Compare branches and spot gaps before they become a problem on the day."
      ]}
    ],
    // Raw data
    [
      { h: "What it shows", p: [
        "The unprocessed clock-in / clock-out records exactly as they were captured, for audit and troubleshooting."
      ]},
      { h: "Note", p: [
        "Nothing here is edited or interpreted — use the Day or Month views to review and adjust."
      ]}
    ],
    // Pharmacist rota
    [
      { h: "What it shows", p: [
        "The pharmacist rota across all branches: who is the Responsible Pharmacist where and when."
      ]},
      { h: "Also covers", p: [
        "Locum cover and locum payments."
      ]}
    ]
  ];
  const [tipFor, setTipFor] = useState(null); // index of hovered tab, or null
  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", color: "#111" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 12, flexWrap: "wrap" }}>
        <h2 style={{ margin: 0, fontSize: 20, color: "#0f766e" }}>Staff clock in/out</h2>
        {/* Segmented control: abutting buttons, selected one filled.
            Hovering a button opens a formatted summary panel below the bar. */}
        <div style={{ position: "relative", display: "inline-flex", border: "1px solid #0f766e", borderRadius: 6 }}
             onMouseLeave={() => setTipFor(null)}>
          {TABS.map((t, i) => (
            <button key={t} onClick={() => setTab(i)}
              onMouseEnter={() => setTipFor(i)}
              onFocus={() => setTipFor(i)}
              onBlur={() => setTipFor(null)}
              style={{
                border: "none",
                borderLeft: i > 0 ? "1px solid #0f766e" : "none",
                borderRadius: i === 0 ? "5px 0 0 5px" : (i === TABS.length - 1 ? "0 5px 5px 0" : 0),
                background: tab === i ? "#0f766e" : "#fff",
                color: tab === i ? "#fff" : "#0f766e",
                padding: "7px 16px", fontSize: 13.5,
                fontWeight: tab === i ? 800 : 600,
                cursor: "pointer", fontFamily: "inherit"
              }}>
              {t}
            </button>
          ))}
          {tipFor != null && (
            <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, zIndex: 4000,
                          width: "min(460px, 90vw)", background: "#fff", border: "1px solid #d1d5db",
                          borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.16)", padding: "12px 14px" }}>
              <div style={{ fontSize: 13, fontWeight: 800, color: "#0f766e", marginBottom: 8 }}>{TABS[tipFor]}</div>
              {TAB_TIPS[tipFor].map((sec, si) => (
                <div key={si} style={{ marginBottom: si < TAB_TIPS[tipFor].length - 1 ? 10 : 0 }}>
                  <div style={{ fontSize: 10.5, fontWeight: 800, letterSpacing: 0.5, textTransform: "uppercase",
                                color: "#6b7280", marginBottom: 3 }}>{sec.h}</div>
                  {sec.p.map((para, pi) => (
                    <div key={pi} style={{ fontSize: 12.5, color: "#374151", lineHeight: 1.45,
                                           marginBottom: pi < sec.p.length - 1 ? 4 : 0 }}>{para}</div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {tab === 0 && <DayTab />}
      {tab === 1 && <MonthTab pharmacies={pharmacies} />}
      {tab === 2 && <SummaryTab />}
      {/* Moved in from the left menu (Staff flyout) — same components,
          same logic, now living as tabs in this panel. Workforce gets the
          organisation's real pharmacy names in place of its placeholders. */}
      {tab === 3 && <Workforce />}
      {tab === 4 && <Stafflogin />}
      {tab === 5 && <PharmacistRota />}
    </div>
  );
}